var _a, _b, _c, _d, _e, _f, _g;
import { Slice, Fragment, Node, DOMSerializer, NodeRange, DOMParser } from "prosemirror-model";
import { SeshatNodes, BlockTypes, NodeViewTypes, SeshatNodeGroups, BlockAttrsParams, SeshatInlineNodes, capitalizeFirstLetter, generateRandomId, MarkTypes, MarkAttrsParams, isUrl, urlMediaParser, SeshatCssClass, findSubstringOffset, CardClipStatus, LAUNCHER_EDITOR_ID, SeshatWrappingBlocks, pipe } from "@lazy-app/common";
import { Transaction, TextSelection, Selection, PluginKey, Plugin, NodeSelection } from "prosemirror-state";
import { Step, StepResult, ReplaceStep, AddMarkStep, RemoveMarkStep, ReplaceAroundStep } from "prosemirror-transform";
import { findChildren, getSchema, Extension as Extension$1, Node as Node$1, InputRule, mergeAttributes, findChildrenInRange, getMarkRange, Mark, markPasteRule, markInputRule, getMarksBetween, Editor } from "@tiptap/core";
import { Decoration, DecorationSet } from "prosemirror-view";
import { Extension } from "@tiptap/react";
import { Document } from "@tiptap/extension-document";
import { History } from "@tiptap/extension-history";
import { history } from "prosemirror-history";
import { Typography } from "@tiptap/extension-typography";
export { Typography as TypographyExtension } from "@tiptap/extension-typography";
import arduino from "highlight.js/lib/languages/arduino";
import bash from "highlight.js/lib/languages/bash";
import c from "highlight.js/lib/languages/c";
import cpp from "highlight.js/lib/languages/cpp";
import csharp from "highlight.js/lib/languages/csharp";
import css from "highlight.js/lib/languages/css";
import diff from "highlight.js/lib/languages/diff";
import go from "highlight.js/lib/languages/go";
import ini from "highlight.js/lib/languages/ini";
import java from "highlight.js/lib/languages/java";
import javascript from "highlight.js/lib/languages/javascript";
import json from "highlight.js/lib/languages/json";
import kotlin from "highlight.js/lib/languages/kotlin";
import less from "highlight.js/lib/languages/less";
import lua from "highlight.js/lib/languages/lua";
import makefile from "highlight.js/lib/languages/makefile";
import markdown from "highlight.js/lib/languages/markdown";
import objectivec from "highlight.js/lib/languages/objectivec";
import perl from "highlight.js/lib/languages/perl";
import php from "highlight.js/lib/languages/php";
import phpTemplate from "highlight.js/lib/languages/php-template";
import plaintext from "highlight.js/lib/languages/plaintext";
import python from "highlight.js/lib/languages/python";
import pythonRepl from "highlight.js/lib/languages/python-repl";
import r from "highlight.js/lib/languages/r";
import ruby from "highlight.js/lib/languages/ruby";
import rust from "highlight.js/lib/languages/rust";
import scss from "highlight.js/lib/languages/scss";
import shell from "highlight.js/lib/languages/shell";
import sql from "highlight.js/lib/languages/sql";
import swift from "highlight.js/lib/languages/swift";
import typescript from "highlight.js/lib/languages/typescript";
import vbnet from "highlight.js/lib/languages/vbnet";
import xml from "highlight.js/lib/languages/xml";
import yaml from "highlight.js/lib/languages/yaml";
import high from "highlight.js/lib/core";
import formatter from "format";
import { Link } from "@tiptap/extension-link";
import { Strike } from "@tiptap/extension-strike";
import { Bold } from "@tiptap/extension-bold";
export { Bold as BoldMark } from "@tiptap/extension-bold";
import { Code } from "@tiptap/extension-code";
export { Code as CodeMark } from "@tiptap/extension-code";
import { Italic } from "@tiptap/extension-italic";
export { Italic as ItalicMark } from "@tiptap/extension-italic";
import { TextStyle } from "@tiptap/extension-text-style";
export { TextStyle as TextStyleMark } from "@tiptap/extension-text-style";
import { Underline } from "@tiptap/extension-underline";
export { Underline as UnderlineMark } from "@tiptap/extension-underline";
import { Text } from "@tiptap/extension-text";
import Fuse from "fuse.js";
const generateEmptyBlock = (attrs) => {
  var _a2;
  return {
    type: SeshatNodes.BLOCK,
    content: [
      {
        type: SeshatNodes.BLOCK_CONTENT,
        content: [
          {
            type: SeshatNodes.CONTENT
          }
        ]
      }
    ],
    attrs: {
      textAlign: "left",
      type: (_a2 = attrs == null ? void 0 : attrs.type) != null ? _a2 : BlockTypes.PARAGRAPH,
      ...attrs
    }
  };
};
const generateParagraph = ({
  content,
  children,
  attrs
} = {}) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    textAlign: "left",
    ...attrs,
    type: "paragraph"
  },
  content: children != null ? children : [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT,
          content: content != null ? content : [
            {
              type: "text",
              text: "Hello, I am a default Seshat Block"
            }
          ]
        }
      ]
    }
  ]
});
const generateCapture = ({
  children,
  attrs
} = {}) => ({
  attrs: {
    textAlign: "left",
    ...attrs,
    type: BlockTypes.CAPTURE
  },
  content: children != null ? children : [],
  type: SeshatNodes.WRAPPING_BLOCK
});
const generateNote = ({
  content,
  children,
  attrs
} = {}) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    textAlign: "left",
    isDone: 0,
    ...attrs,
    type: BlockTypes.CARD_CONTENT,
    cardType: "note"
  },
  content: [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT,
          content: content != null ? content : [
            {
              type: "text",
              text: "Card Title"
            }
          ]
        }
      ]
    },
    ...children != null ? children : []
  ]
});
const generateTask = ({
  content,
  children,
  attrs
} = {}) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    textAlign: "left",
    isDone: 0,
    ...attrs,
    type: BlockTypes.CARD_CONTENT,
    cardType: "task"
  },
  content: [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT,
          content: content != null ? content : [
            {
              type: "text",
              text: "Card Title"
            }
          ]
        }
      ]
    },
    ...children != null ? children : []
  ]
});
const generateTaskEditable = ({
  attrs,
  content
} = {}) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    textAlign: "left",
    ...attrs,
    type: BlockTypes.TASK_EDITABLE
  },
  content: [
    {
      type: "seshatBlockContent",
      content: [
        {
          type: "seshatContent",
          content: content != null ? content : [
            {
              type: "text",
              text: "Task Editable Name"
            }
          ]
        }
      ]
    }
  ]
});
const generateHighlights = ({
  attrs,
  children
} = {}) => ({
  type: SeshatNodes.WRAPPING_BLOCK,
  attrs: {
    textAlign: "left",
    connectedClip: "clipId1",
    ...attrs,
    type: BlockTypes.HIGHLIGHTS
  },
  content: children != null ? children : []
});
const generateClipBookmark = ({
  attrs,
  content,
  children,
  bookmarkAttrs
} = {}) => ({
  type: SeshatNodes.BLOCK,
  attrs: {
    textAlign: "left",
    ...attrs,
    nodeViewType: NodeViewTypes.CLIP_BOOKMARK,
    type: BlockTypes.NODE_VIEW
  },
  content: children != null ? children : [
    {
      type: SeshatNodes.BLOCK_CONTENT,
      content: [
        {
          type: SeshatNodes.CONTENT_NODE_VIEW,
          content: content != null ? content : [
            {
              type: NodeViewTypes.CLIP_BOOKMARK,
              attrs: {
                title: "Bookmark Title",
                href: "https://www.google.com",
                highlights: void 0,
                ...bookmarkAttrs
              }
            }
          ]
        }
      ]
    }
  ]
});
const generateClipContent = ({
  attrs,
  children
}) => ({
  type: SeshatNodes.WRAPPING_BLOCK,
  attrs: {
    textAlign: "left",
    ...attrs,
    type: BlockTypes.CLIP_CONTENT
  },
  content: children != null ? children : [
    {
      type: SeshatNodes.BLOCK,
      attrs: {
        textAlign: "left",
        type: BlockTypes.PARAGRAPH
      },
      content: [
        {
          type: SeshatNodes.BLOCK_CONTENT,
          content: [
            {
              type: SeshatNodes.CONTENT,
              content: []
            }
          ]
        }
      ]
    }
  ]
});
const isBlock = (node, predicate) => {
  var _a2;
  if (!node || node.type.spec.group !== SeshatNodeGroups.BLOCK)
    return false;
  return (_a2 = predicate == null ? void 0 : predicate(node)) != null ? _a2 : true;
};
const getCurrentBlock = (doc, pos, predicate) => {
  for (let i = pos; i >= 0; i--) {
    const node = doc.nodeAt(i);
    const $i = doc.resolve(i);
    if (!isBlock(node, predicate))
      continue;
    return {
      node,
      depth: $i.depth + 1,
      from: i,
      $from: $i,
      to: i + node.nodeSize,
      $to: doc.resolve(i + node.nodeSize)
    };
  }
  return void 0;
};
const SESHAT_ROOT_DEPTH = 1;
const SESHAT_CONTENT_DEPTH = 2;
const seshatBlockOnEnter = {
  [BlockTypes.HEADING_1]: BlockTypes.PARAGRAPH,
  [BlockTypes.HEADING_2]: BlockTypes.PARAGRAPH,
  [BlockTypes.HEADING_3]: BlockTypes.PARAGRAPH,
  [BlockTypes.HEADING_4]: BlockTypes.PARAGRAPH,
  [BlockTypes.CODE]: BlockTypes.PARAGRAPH,
  [BlockTypes.NODE_VIEW]: BlockTypes.PARAGRAPH
};
const seshatBlockResetOnStartBackspace = [
  BlockTypes.HEADING_1,
  BlockTypes.HEADING_2,
  BlockTypes.HEADING_3,
  BlockTypes.HEADING_4,
  BlockTypes.BULLETED_LIST,
  BlockTypes.NUMBERED_LIST,
  BlockTypes.HIGHLIGHT,
  BlockTypes.CODE,
  BlockTypes.CALLOUT,
  BlockTypes.TOGGLE_LIST,
  BlockTypes.CARD_CONTENT,
  BlockTypes.TASK_EDITABLE
];
const seshatBlockResetOnEmptyEnter = [
  BlockTypes.HEADING_1,
  BlockTypes.HEADING_2,
  BlockTypes.HEADING_3,
  BlockTypes.HEADING_4,
  BlockTypes.BULLETED_LIST,
  BlockTypes.NUMBERED_LIST,
  BlockTypes.BLOCKQUOTE,
  BlockTypes.CARD_CONTENT,
  BlockTypes.TOGGLE_LIST
];
const seshatBlockSoftBreakOnEnter = [BlockTypes.CODE];
const HARD_BREAK_DUE_TO_PARENT_TYPE = [
  BlockTypes.BLOCKQUOTE,
  BlockTypes.CLIP_CONTENT
];
const HARD_BREAK_DUE_TO_BLOCK_TYPE = [BlockTypes.CODE];
const seshatBlockChildrenOnEnter = {
  [BlockTypes.CARD_CONTENT]: { type: BlockTypes.PARAGRAPH },
  [BlockTypes.TOGGLE_LIST]: { type: BlockTypes.PARAGRAPH }
};
const seshatBlockSoftTab = [BlockTypes.CODE];
const disabledIndent = [BlockTypes.CARD_LINK];
const isContentEditableFalseBlockType = [
  BlockTypes.CARD_LINK,
  BlockTypes.NODE_VIEW
];
const clipBlocks = [
  BlockTypes.CLIP_CONTENT,
  NodeViewTypes.CLIP_BOOK,
  NodeViewTypes.CLIP_BOOKMARK
];
const excludedFromBlockSelection = [
  BlockTypes.HIGHLIGHT,
  BlockTypes.HIGHLIGHT_NOTE,
  BlockTypes.BLOCK_COLUMN
];
const seshatBlockAttributes = {
  type: {
    default: BlockTypes.PARAGRAPH,
    keepOnSplit: true
  },
  nodeViewType: {
    default: void 0,
    keepOnSplit: true
  },
  textAlign: {
    default: "left",
    keepOnSplit: true
  },
  [BlockAttrsParams.CONTEXT_UUID]: {
    default: void 0,
    keepOnSplit: true
  },
  [BlockAttrsParams.BLOCK_UUID]: {
    default: void 0,
    keepOnSplit: false
  },
  asin: {
    default: void 0,
    keepOnSplit: true
  },
  author: {
    default: void 0,
    keepOnSplit: true
  },
  char: {
    default: void 0,
    keepOnSplit: true
  },
  color: {
    default: void 0,
    keepOnSplit: true
  },
  collapsed: {
    default: void 0,
    keepOnSplit: true
  },
  coverUrl: {
    default: void 0,
    keepOnSplit: true
  },
  cardType: {
    default: void 0,
    keepOnSplit: true
  },
  isDone: {
    default: void 0,
    keepOnSplit: true
  },
  fileName: {
    default: void 0,
    keepOnSplit: true
  },
  fileSize: {
    default: void 0,
    keepOnSplit: true
  },
  fileType: {
    default: void 0,
    keepOnSplit: true
  },
  previewType: {
    default: void 0,
    keepOnSplit: true
  },
  fileUuid: {
    default: void 0,
    keepOnSplit: true
  },
  value: {
    default: void 0,
    keepOnSplit: true
  },
  cardUuid: {
    default: void 0,
    keepOnSplit: true
  },
  height: {
    default: void 0,
    keepOnSplit: true
  },
  src: {
    default: void 0,
    keepOnSplit: true
  },
  target: {
    default: void 0,
    keepOnSplit: true
  },
  language: {
    default: void 0,
    keepOnSplit: true
  },
  highlightId: {
    default: void 0,
    keepOnSplit: true
  },
  highlightNote: {
    default: void 0,
    keepOnSplit: true
  },
  kindleHighlights: {
    default: void 0,
    keepOnSplit: true
  },
  id: {
    default: void 0,
    keepOnSplit: true
  },
  alt: {
    default: void 0,
    keepOnSplit: true
  },
  timestamp: {
    default: void 0,
    keepOnSplit: true
  },
  connectedClip: {
    default: void 0,
    keepOnSplit: true
  },
  contentEditable: {
    default: void 0,
    keepOnSplit: true
  },
  href: {
    default: void 0,
    keepOnSplit: true
  },
  hrefBackup: {
    default: void 0,
    keepOnSplit: true
  },
  fetched: {
    default: void 0,
    keepOnSplit: true
  },
  twitter: {
    default: void 0,
    keepOnSplit: true
  },
  email: {
    default: void 0,
    keepOnSplit: true
  },
  video: {
    default: void 0,
    keepOnSplit: true
  },
  status: {
    default: void 0,
    keepOnSplit: true
  },
  isPaywallContent: {
    default: void 0,
    keepOnSplit: true,
    rendered: false
  },
  highlights: {
    default: void 0,
    keepOnSplit: false,
    rendered: false
  },
  favicon: {
    default: void 0,
    keepOnSplit: true,
    rendered: false
  },
  title: {
    default: void 0,
    keepOnSplit: true,
    rendered: false
  },
  emoji: {
    default: void 0,
    keepOnSplit: true
  },
  width: {
    default: void 0,
    keepOnSplit: true
  }
};
const PreviewFile = {
  IMAGE: "image",
  FILE: "file",
  PDF: "pdf"
};
const findAncestor = ($from, predicate) => {
  let depth = $from.depth;
  while (depth >= 0) {
    let node = $from.node(depth);
    if (predicate(node)) {
      return { node, depth };
    } else {
      depth--;
    }
  }
  return void 0;
};
const ParagraphBlockConfig = {
  type: BlockTypes.PARAGRAPH,
  title: "Text",
  search: ["paragraph", "text"],
  schemaType: SeshatNodes.BLOCK,
  commandsType: ["basic-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().updateBlockAttributes({ type: BlockTypes.PARAGRAPH }).run()
};
const HeadingBlockConfig = (level) => ({
  type: `heading${level}`,
  title: `Heading ${level}`,
  schemaType: SeshatNodes.BLOCK,
  search: ["title", "header", `header ${level}`, `h${level}`],
  commandsType: ["basic-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().updateBlockAttributes({
    type: `heading${level}`
  }).run()
});
const BulletBlockConfig = {
  type: BlockTypes.BULLETED_LIST,
  title: "Bullet List",
  schemaType: SeshatNodes.BLOCK,
  search: ["list", "bullet"],
  commandsType: ["basic-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().updateBlockAttributes({ type: BlockTypes.BULLETED_LIST }).run()
};
const NumberedBlockConfig = {
  type: BlockTypes.NUMBERED_LIST,
  title: "Numbered List",
  schemaType: SeshatNodes.BLOCK,
  search: ["number", "list", "ordered list"],
  commandsType: ["basic-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().updateBlockAttributes({ type: BlockTypes.NUMBERED_LIST }).run()
};
const TaskBlockConfig = {
  type: BlockTypes.TASK_EDITABLE,
  title: "Task",
  schemaType: SeshatNodes.BLOCK,
  search: ["tasks", "todo"],
  commandsType: ["basic-node-view-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().updateBlockAttributes({
    type: BlockTypes.TASK_EDITABLE
  }).run()
};
const QuoteBlockConfig = {
  type: BlockTypes.BLOCKQUOTE,
  title: "Quote",
  schemaType: SeshatNodes.WRAPPING_BLOCK,
  search: ["quote"],
  commandsType: ["basic-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().wrapIntoBlock({ type: BlockTypes.BLOCKQUOTE }).run()
};
const CodeBlockConfig = {
  type: BlockTypes.CODE,
  title: "Code",
  schemaType: SeshatNodes.BLOCK,
  search: ["codeblock", "code-block", "code block"],
  commandsType: ["basic-content", "turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().updateBlockAttributes({ type: BlockTypes.CODE }).run()
};
const DividerBlockConfig = {
  type: NodeViewTypes.HORIZONTAL_RULE,
  title: "Divider",
  schemaType: SeshatNodes.BLOCK,
  search: ["divider", "horizontal"],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => editorApi.chain().focus().setHorizontalRule().run()
};
const EmbedBlockConfig = {
  type: NodeViewTypes.IFRAME,
  title: "Embed",
  schemaType: NodeViewTypes.IFRAME,
  search: ["iframe", "media", "embed"],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => editorApi.chain().focus().setIframe({}).run()
};
const TableOfContentBlockConfig = {
  type: NodeViewTypes.TABLE_OF_CONTENTS,
  title: "Table of contents",
  schemaType: SeshatNodes.BLOCK,
  search: ["table", "content"],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => editorApi.chain().focus().setTableOfContents().run()
};
const AddNoteConfig = {
  type: BlockTypes.CARD_LINK,
  title: "Note",
  schemaType: SeshatNodes.BLOCK,
  search: ["note", "add", "page"],
  commandsType: ["turn-into"],
  runCommand: (editorApi) => editorApi.chain().focus().insertCardLink({ cardType: "note" }).run()
};
const HighlightsConfig = {
  type: BlockTypes.HIGHLIGHTS,
  title: "Highlights",
  schemaType: SeshatNodes.WRAPPING_BLOCK,
  search: ["highlights"],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => editorApi.chain().focus().insertHighlightsBlock().run()
};
const FileBlockConfig = (previewType) => ({
  type: NodeViewTypes.FILE,
  title: capitalizeFirstLetter(previewType),
  schemaType: NodeViewTypes.FILE,
  search: ["file", previewType],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => editorApi.chain().focus().setFile({
    previewType
  }).run()
});
const ClipBlockConfig = {
  type: BlockTypes.CLIP_CONTENT,
  title: "Clip",
  schemaType: SeshatNodes.WRAPPING_BLOCK,
  search: ["Clip"],
  commandsType: ["basic-node-view-content"],
  shouldBeHidden: (editor) => !!editor && !!findAncestor(
    editor.state.selection.$from,
    (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.CLIP_CONTENT
  ),
  runCommand: (editorApi) => {
    return editorApi.chain().focus().wrapIntoBlock({ type: BlockTypes.CLIP_CONTENT }).run();
  }
};
const ConnectionConfig = {
  type: SeshatInlineNodes.REFERENCE,
  title: "Make connection",
  schemaType: SeshatInlineNodes.REFERENCE,
  search: ["make connection connections"],
  commandsType: ["basic-node-view-content"],
  runCommand: (editorApi) => {
    return editorApi.chain().focus().insertMentionPlaceholder({}).run();
  }
};
const ALL_BLOCK_COMMANDS = [
  ParagraphBlockConfig,
  HeadingBlockConfig(1),
  HeadingBlockConfig(2),
  HeadingBlockConfig(3),
  TaskBlockConfig,
  BulletBlockConfig,
  NumberedBlockConfig,
  CodeBlockConfig,
  QuoteBlockConfig,
  AddNoteConfig,
  DividerBlockConfig,
  EmbedBlockConfig,
  ClipBlockConfig,
  FileBlockConfig(PreviewFile.IMAGE),
  FileBlockConfig(PreviewFile.PDF),
  FileBlockConfig(PreviewFile.FILE),
  TableOfContentBlockConfig,
  HighlightsConfig,
  ConnectionConfig
];
const seshatBlockMarkdown = [
  { regexExps: [RegExp(`^(#{1,${1}})\\s$`)], type: BlockTypes.HEADING_1 },
  { regexExps: [RegExp(`^(#{1,${2}})\\s$`)], type: BlockTypes.HEADING_2 },
  { regexExps: [RegExp(`^(#{1,${3}})\\s$`)], type: BlockTypes.HEADING_3 },
  { regexExps: [/^\s*([-+*])\s$/], type: BlockTypes.BULLETED_LIST },
  { regexExps: [/^(\d+)\.\s$/], type: BlockTypes.NUMBERED_LIST },
  {
    regexExps: [
      /^``` $/,
      /^~~~ $/,
      /^```(?<language>[a-z]*)? $/,
      /^~~~(?<language>[a-z]*)? $/
    ],
    type: BlockTypes.CODE
  },
  { regexExps: [/^\s*\|\s$/gm], type: BlockTypes.BLOCKQUOTE },
  { regexExps: [/^\s*“\s$/gm, /^\s*"\s$/gm], type: BlockTypes.BLOCKQUOTE }
];
const YELLOW = "rgba(244, 169, 82, 0.24)";
const GroupHighlightColors = [
  {
    title: "Default",
    color: "inherit",
    order: 1
  },
  {
    title: "Gray",
    color: "rgba(122, 122, 122, 0.24)",
    colorForIcon: "rgba(122, 122, 122, 0.64)",
    order: 2
  },
  {
    title: "Yellow",
    color: YELLOW,
    colorForIcon: "rgba(244, 169, 82, 0.64)",
    order: 5
  },
  {
    title: "Blue",
    color: "rgba(24, 149, 220, 0.24)",
    colorForIcon: "rgba(24, 149, 220, 0.64)",
    order: 6
  },
  {
    title: "Purple",
    color: "rgba(86, 44, 201, 0.24)",
    colorForIcon: "rgba(86, 44, 201, 0.64)",
    order: 8
  },
  {
    title: "Pink",
    color: "rgba(201, 44, 107, 0.24)",
    colorForIcon: "rgba(201, 44, 107, 0.64)",
    order: 9
  }
];
const GroupColors = [
  {
    title: "Default",
    color: "inherit",
    order: 1
  },
  {
    title: "Brown",
    color: "rgb(147, 114, 100)",
    order: 3
  },
  {
    title: "Orange",
    color: "rgb(255, 163, 68)",
    order: 4
  },
  {
    title: "Green",
    color: "rgb(77, 171, 154)",
    order: 7
  },
  {
    title: "Red",
    color: "rgb(255, 115, 105)",
    order: 10
  },
  {
    title: "Gray",
    color: "rgba(122, 122, 122)",
    order: 2
  },
  {
    title: "Yellow",
    color: "rgba(244, 169, 82)",
    order: 5
  },
  {
    title: "Blue",
    color: "rgba(24, 149, 220)",
    order: 6
  },
  {
    title: "Purple",
    color: "rgba(86, 44, 201)",
    order: 8
  },
  {
    title: "Pink",
    color: "rgba(201, 44, 107)",
    order: 9
  }
];
class UpdateAttrsStep extends Step {
  constructor(pos, attrs) {
    super();
    this.pos = pos;
    this.attrs = attrs;
    this.pos = pos;
    this.attrs = attrs;
  }
  apply(doc) {
    const node = doc.nodeAt(this.pos);
    if (!node)
      return StepResult.fail("Node not found at pos " + this.pos);
    const newNode = node.copy();
    newNode.attrs = { ...newNode.attrs, ...this.attrs };
    const slice = new Slice(Fragment.from(newNode), 0, 0);
    return StepResult.ok(doc.replace(this.pos, this.pos + 1, slice));
  }
  invert(doc) {
    var _a2, _b2;
    return new UpdateAttrsStep(this.pos, (_b2 = (_a2 = doc.nodeAt(this.pos)) == null ? void 0 : _a2.attrs) != null ? _b2 : {});
  }
  map(mapping) {
    const at = mapping.mapResult(this.pos);
    return at.deleted ? null : new UpdateAttrsStep(this.pos, this.attrs);
  }
  merge(other) {
    if (other instanceof UpdateAttrsStep && other.pos === this.pos)
      return new UpdateAttrsStep(this.pos, this.attrs);
    return null;
  }
  static fromJSON(_schema, json2) {
    return new UpdateAttrsStep(json2.at, json2.attrs);
  }
  toJSON() {
    return {
      attrs: this.attrs,
      at: this.pos,
      stepType: "updateAttrs"
    };
  }
}
Step.jsonID("updateAttrs", UpdateAttrsStep);
Transaction.prototype.updateAttrs = function updateAttrs(pos, attrs) {
  return this.step(new UpdateAttrsStep(pos, attrs));
};
const deleteBlock = () => ({ tr, dispatch }) => {
  dispatch == null ? void 0 : dispatch(deleteBlockTransaction({ tr }));
  return true;
};
const deleteBlockTransaction = ({ tr }) => {
  const { selection, doc } = tr;
  const { from } = selection;
  const seshatBlock = getCurrentBlock(doc, from);
  if (!(seshatBlock == null ? void 0 : seshatBlock.node))
    return tr;
  tr.delete(seshatBlock.from, seshatBlock.to);
  const caretPos = minMax(
    seshatBlock.from - SESHAT_CONTENT_DEPTH - 1,
    SESHAT_ROOT_DEPTH,
    tr.doc.nodeSize - SESHAT_ROOT_DEPTH
  );
  tr.setSelection(TextSelection.create(tr.doc, caretPos));
  return tr;
};
const shortcutConfig = {
  strikethrough: "Mod-Shift-s",
  lastUsedColor: "Mod-Shift-c",
  toggleHighlight: "Mod-Shift-h",
  moveUp: "Mod-Shift-ArrowUp",
  moveDown: "Mod-Shift-ArrowDown",
  selectAll: "Mod-a",
  selectPrevBlock: "ArrowUp",
  selectNextBlock: "ArrowDown",
  expandPrevBlock: "Shift-ArrowUp",
  expandNextBlock: "Shift-ArrowDown",
  link: "Mod-k",
  undo: "Mod-y",
  redo: "Mod-Shift-y"
};
const seshatBlockShortcut = [
  { keys: "Mod-Alt-0", type: BlockTypes.PARAGRAPH },
  { keys: "Mod-Alt-1", type: BlockTypes.HEADING_1 },
  { keys: "Mod-Alt-2", type: BlockTypes.HEADING_2 },
  { keys: "Mod-Alt-3", type: BlockTypes.HEADING_3 },
  { keys: "Mod-Alt-4", type: BlockTypes.TASK_EDITABLE },
  { keys: "Mod-Alt-5", type: BlockTypes.BULLETED_LIST },
  { keys: "Mod-Alt-6", type: BlockTypes.NUMBERED_LIST },
  { keys: "Mod-Alt-7", type: BlockTypes.CODE },
  { keys: "Mod-Alt-8", type: BlockTypes.BLOCKQUOTE },
  { keys: "Mod-Alt-9", type: BlockTypes.CARD_LINK }
];
const preventDefaultKeyBehavior = (event) => {
  event.preventDefault();
  event.stopPropagation();
  return true;
};
class BlockSelectionBookmark {
  constructor(from, to) {
    this.from = from;
    this.to = to;
  }
  map(mapping) {
    return new BlockSelectionBookmark(
      mapping.map(this.from),
      mapping.map(this.to)
    );
  }
  resolve(doc) {
    return BlockSelection.createFromRange(doc, this.from, this.to);
  }
}
class BlockSelection extends Selection {
  constructor($anchor, $head) {
    super($anchor, $head);
    this.$anchor = $anchor;
    this.$head = $head;
  }
  eq(other) {
    if (!(other instanceof BlockSelection))
      return false;
    return other.$head.pos === this.$head.pos && other.$anchor.pos === this.$anchor.pos;
  }
  toJSON() {
    return {
      type: "block",
      anchor: this.anchor,
      head: this.head
    };
  }
  getBookmark() {
    return new BlockSelectionBookmark(this.from, this.to);
  }
  map(doc, mapping) {
    const $anchor = doc.resolve(mapping.map(this.anchor));
    const $head = doc.resolve(mapping.map(this.head));
    return new BlockSelection($anchor, $head);
  }
  listPositions() {
    const doc = this.$head.doc;
    const positions = [];
    for (let pos = this.from; pos < this.to; pos++) {
      const node = doc.nodeAt(pos);
      if ((node == null ? void 0 : node.type.spec.group) === SeshatNodeGroups.BLOCK) {
        positions.push(pos);
      }
    }
    return positions;
  }
  firstBlock() {
    return this.list()[0];
  }
  lastBlock() {
    const list = this.list();
    return list[list.length - 1];
  }
  list() {
    const doc = this.$head.doc;
    const blockList = this.listPositions().map((pos) => {
      const node = doc.nodeAt(pos);
      const $pos = doc.resolve(pos);
      if (!node)
        return void 0;
      return {
        node,
        from: pos,
        $from: doc.resolve(pos),
        to: pos + node.nodeSize,
        $to: doc.resolve(pos + node.nodeSize),
        depth: $pos.depth + 1
      };
    }).filter((item) => item !== void 0);
    const minDepth = blockList.reduce(
      (cur, next) => next.depth < cur ? next.depth : cur,
      Number.MAX_SAFE_INTEGER
    );
    return blockList.filter((block) => block.depth === minDepth);
  }
  getFragment() {
    return this.list().reduce((fragment, block) => {
      return fragment.append(Fragment.from(block.node));
    }, Fragment.from());
  }
  static createFromPositions(doc, blocksPositions) {
    const sortedBlocksPositions = blocksPositions.slice().filter((pos) => pos !== 0).sort((a, b) => a > b ? 1 : -1);
    if (!blocksPositions.length)
      return new this(doc.resolve(0), doc.resolve(0));
    const anchor = sortedBlocksPositions[0];
    if (!anchor)
      return new this(doc.resolve(0), doc.resolve(0));
    const head = Math.max(
      ...sortedBlocksPositions.map(
        (pos) => {
          var _a2, _b2;
          return pos + ((_b2 = (_a2 = doc.nodeAt(pos)) == null ? void 0 : _a2.nodeSize) != null ? _b2 : 0);
        }
      )
    );
    const $anchor = doc.resolve(anchor);
    const $head = doc.resolve(head);
    return new this($anchor, $head);
  }
  static createFromRange(doc, from, to) {
    return new BlockSelection(doc.resolve(from), doc.resolve(to));
  }
  static createFromPosition(doc, pos) {
    const block = getCurrentBlock(doc, pos);
    if (!block)
      throw new Error("position is not valid");
    return new BlockSelection(block.$from, block.$to);
  }
  static createFromTextSelection(doc, textSelection) {
    var _a2, _b2;
    const firstBlockDepth = (_a2 = getCurrentBlock(doc, textSelection.from)) == null ? void 0 : _a2.depth;
    const lastBlockDepth = (_b2 = getCurrentBlock(doc, textSelection.to)) == null ? void 0 : _b2.depth;
    return BlockSelection.createFromRange(
      doc,
      textSelection.$from.before(firstBlockDepth),
      textSelection.$to.after(lastBlockDepth)
    );
  }
}
function isBlockSelection(value) {
  return !!value && value instanceof BlockSelection;
}
const countLeaves = (content) => {
  return content.reduce((acc, node) => {
    if (node.content) {
      return acc + countLeaves(node.content);
    }
    return acc + 1;
  }, 0);
};
const LARGE_DOCUMENT_LEAVES_COUNT = 100;
const isLargeDocument = (content) => countLeaves(content) >= LARGE_DOCUMENT_LEAVES_COUNT;
const createSeshatBlock = ({
  attrs = { type: BlockTypes.PARAGRAPH },
  content,
  schema,
  children = []
}) => {
  var _a2, _b2, _c2, _d2;
  let _content = content;
  if (typeof _content === "string") {
    _content = schema.text(_content);
  }
  const nodeType = getNodeTypeByBlockType(attrs.type);
  if (nodeType === SeshatNodes.WRAPPING_BLOCK) {
    return (_a2 = schema.nodes[SeshatNodes.WRAPPING_BLOCK]) == null ? void 0 : _a2.create({ ...attrs }, [
      ...children
    ]);
  }
  const seshatContent = (_b2 = schema.nodes[SeshatNodes.CONTENT]) == null ? void 0 : _b2.create(
    {},
    _content
  );
  const seshatBlockContent = (_c2 = schema.nodes[SeshatNodes.BLOCK_CONTENT]) == null ? void 0 : _c2.create(
    {},
    seshatContent
  );
  return (_d2 = schema.nodes[SeshatNodes.BLOCK]) == null ? void 0 : _d2.create({ ...attrs }, [
    seshatBlockContent,
    ...children
  ]);
};
const insertTrailingLine = (props) => ({ state, dispatch, tr }) => {
  dispatch == null ? void 0 : dispatch(insertTrailingLineTransaction({ state, tr, ...props }));
  return true;
};
const insertTrailingLineTransaction = ({
  tr,
  state,
  withoutSetSelection
}) => {
  const newParagraphBlock = createSeshatBlock({ schema: state.schema });
  const insertPos = tr.doc.content.size - SESHAT_ROOT_DEPTH;
  tr.insert(insertPos, newParagraphBlock);
  if (!withoutSetSelection) {
    const caretPos = insertPos + getNodeDepth(newParagraphBlock);
    tr.setSelection(TextSelection.create(tr.doc, caretPos)).scrollIntoView();
  }
  return tr;
};
const findNextCaretPosition = (doc, pos) => {
  if (pos > doc.content.size - SESHAT_ROOT_DEPTH)
    return void 0;
  if (pos < 0)
    return findNextCaretPosition(doc, SESHAT_ROOT_DEPTH);
  const next = Selection.findFrom(doc.resolve(pos), 1);
  if (next && doc.resolve(next.from).parent.type.name !== SeshatNodes.CONTENT)
    return findNextCaretPosition(doc, next.to + 1);
  return next ? next.from : void 0;
};
const getBlocksInRange = (state, range) => {
  return BlockSelection.createFromTextSelection(
    state.doc,
    TextSelection.create(state.doc, range.from, range.to)
  ).list().map((block) => ({
    node: block.node.toJSON(),
    from: block.from,
    to: block.to
  }));
};
const isRangeTextSelected = (editorState) => {
  const { selection, doc } = editorState;
  const { ranges, empty } = selection;
  const from = Math.min(...ranges.map((range) => range.$from.pos));
  const to = Math.max(...ranges.map((range) => range.$to.pos));
  if (from === to)
    return false;
  const isTextSelected = doc.textBetween(from, to).length > 0 && selection instanceof TextSelection;
  if (empty || !isTextSelected)
    return false;
  return true;
};
const getFromNToFromRange = (ranges) => {
  const from = Math.min(...ranges.map((range) => range.$from.pos));
  const to = Math.max(...ranges.map((range) => range.$to.pos));
  return { from, to };
};
const findBlockAtMousePosition = (view, event) => {
  const { doc } = view.state;
  const pos = view.posAtCoords({ left: event.clientX, top: event.clientY });
  const isPosInsideEditor = (pos == null ? void 0 : pos.pos) && (pos == null ? void 0 : pos.inside) !== -1;
  if (!isPosInsideEditor)
    return findNearestBlockInsideEditor(view, event);
  const $block = getCurrentBlock(doc, pos.pos);
  if (!$block)
    return void 0;
  return {
    $block,
    clientX: event.clientX,
    clientY: event.clientY,
    isOutsideEditor: false
  };
};
const findNearestBlockInsideEditor = (view, event) => {
  var _a2, _b2, _c2;
  const { doc } = view.state;
  const editorRect = view.dom.getBoundingClientRect();
  const { paddingLeft, paddingRight } = window.getComputedStyle(view.dom);
  const rightBoundary = editorRect.right - parseInt(paddingRight, 10);
  const leftBoundary = editorRect.left + parseInt(paddingLeft, 10) * 0.6;
  if (event.clientX > rightBoundary) {
    const left = event.clientX - 50;
    const pos = (_a2 = view.posAtCoords({ left, top: event.clientY })) == null ? void 0 : _a2.pos;
    const $block = pos && getCurrentBlock(doc, pos);
    if (!$block)
      return void 0;
    return {
      $block,
      clientX: event.clientX,
      clientY: event.clientY,
      isOutsideEditor: "right"
    };
  }
  if (event.clientX < leftBoundary) {
    const left = event.clientX + 50;
    const pos = (_b2 = view.posAtCoords({ left, top: event.clientY })) == null ? void 0 : _b2.pos;
    const $block = pos && getCurrentBlock(doc, pos);
    if (!$block)
      return void 0;
    return {
      $block,
      clientX: event.clientX,
      clientY: event.clientY,
      isOutsideEditor: "left"
    };
  }
  const editorContentLeft = editorRect.left + parseInt(paddingLeft, 10);
  if (leftBoundary < event.clientX && event.clientX < editorContentLeft) {
    const left = event.clientX + 50;
    const pos = (_c2 = view.posAtCoords({ left, top: event.clientY })) == null ? void 0 : _c2.pos;
    const $block = pos && getCurrentBlock(doc, pos);
    if (!$block)
      return void 0;
    return {
      $block,
      clientX: event.clientX,
      clientY: event.clientY
    };
  }
  return void 0;
};
const setCaretNearby = (props) => ({
  state,
  dispatch,
  tr
}) => {
  dispatch == null ? void 0 : dispatch(insertTrailingLineTransaction({ state, tr, ...props }));
  return true;
};
const setCaretNearbyTransaction = ({
  tr,
  pos,
  state
}) => {
  const caretPos = findNextCaretPosition(tr.doc, pos);
  if (!caretPos)
    return insertTrailingLineTransaction({ state, tr });
  return tr.setSelection(TextSelection.create(tr.doc, caretPos)).scrollIntoView();
};
const getNodeDepth = (node) => {
  return Math.floor((node.nodeSize - node.textContent.length) / 2);
};
const ANALYTICS_META = "sendEventToAnalytics";
const AnalyticsExtension = (options) => Extension.create({
  name: "AnalyticsExtension",
  onTransaction({ transaction }) {
    var _a2, _b2;
    const editorVersion = (_a2 = options == null ? void 0 : options.extensionVersion) != null ? _a2 : "main";
    const description = transaction.getMeta(ANALYTICS_META);
    if (!transaction || !description)
      return;
    (_b2 = options == null ? void 0 : options.analytics) == null ? void 0 : _b2.onTransactionToSend({ description, editorVersion });
  }
});
const getNearestHighlightBlock = ($from) => {
  let depth = $from.depth;
  while (depth >= 0) {
    let node = $from.node(depth);
    if ((node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHT) {
      return { node, depth };
    } else {
      depth--;
    }
  }
  return void 0;
};
const insertHighlightNote = () => ({ dispatch, state, tr }) => {
  var _a2;
  const { $from } = state.selection;
  const highlightBlock = getNearestHighlightBlock($from);
  if (!highlightBlock)
    return false;
  const hasHighlightNote = ((_a2 = highlightBlock.node.lastChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.HIGHLIGHT_NOTE;
  if (hasHighlightNote) {
    tr = insertEmptyBlockAtEndOfNote({ state, highlightBlock });
  } else {
    tr = insertNoteWithEmptyBlock({ state, highlightBlock });
  }
  tr.setMeta(ANALYTICS_META, "Insert Highlight Note");
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const insertEmptyBlockAtEndOfNote = ({
  state,
  highlightBlock
}) => {
  var _a2, _b2;
  const { tr, schema } = state;
  const blockquoteEnd = state.selection.$from.end(highlightBlock.depth + 1) + 1;
  const noteSize = (_b2 = (_a2 = highlightBlock.node.lastChild) == null ? void 0 : _a2.content.size) != null ? _b2 : 0;
  const insertPos = blockquoteEnd + noteSize + 1;
  const block = createSeshatBlock({ schema });
  tr.insert(insertPos, block);
  return setCaretNearbyTransaction({
    state,
    tr,
    pos: insertPos + block.content.size - SESHAT_CONTENT_DEPTH
  });
};
const insertNoteWithEmptyBlock = ({
  state,
  highlightBlock
}) => {
  const { tr, schema } = state;
  const blockquoteEnd = state.selection.$from.end(highlightBlock.depth + 1);
  const insertPos = blockquoteEnd + 1;
  const block = schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    { type: BlockTypes.HIGHLIGHT_NOTE },
    [createSeshatBlock({ schema })]
  );
  tr.insert(insertPos, block);
  return setCaretNearbyTransaction({
    state,
    tr,
    pos: insertPos + block.content.size - SESHAT_CONTENT_DEPTH
  });
};
const highlightsBlocksObserverPluginKey = new PluginKey(
  "highlightsBlocksObserverPlugin"
);
const clipObserverPluginKey = new PluginKey("clipObserverPlugin");
const createHighlightsFromKindleHighlights = ({
  schema,
  kindleHighlights
}) => {
  return kindleHighlights.map((kindleHighlight) => {
    return createHighlightNode$1({ schema, kindleHighlight });
  });
};
const createHighlightNode$1 = ({
  schema,
  kindleHighlight
}) => {
  var _a2;
  const quote = schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    { type: BlockTypes.BLOCKQUOTE, contentEditable: false },
    [createSeshatBlock({ schema, content: kindleHighlight.highlight })]
  );
  const note = !!kindleHighlight.note && schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    { type: BlockTypes.HIGHLIGHT_NOTE },
    [createSeshatBlock({ schema, content: kindleHighlight.note })]
  );
  return schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    {
      type: BlockTypes.HIGHLIGHT,
      [BlockAttrsParams.HIGHLIGHT_UUID]: (_a2 = kindleHighlight.id) != null ? _a2 : generateRandomId()
    },
    note ? [quote, note] : [quote]
  );
};
const isNestedClipBookNodeView = (node) => node.type.name === NodeViewTypes.CLIP_BOOK;
const createNewHighlightsFromKindleHighlights = ({
  schema,
  clip,
  block
}) => {
  var _a2, _b2;
  const view = (_a2 = findChildren(clip.node, isNestedClipBookNodeView)) == null ? void 0 : _a2[0];
  const existingHighlightIds = block.node.content.content.map(
    (node) => node.attrs.highlightId
  );
  const newHighlights = (_b2 = view == null ? void 0 : view.node) == null ? void 0 : _b2.attrs.kindleHighlights.filter(
    (highlight2) => !existingHighlightIds.includes(highlight2.id)
  );
  return createHighlightsFromKindleHighlights({
    schema,
    kindleHighlights: newHighlights
  });
};
const getHighlightsFromClipBook = (node) => {
  var _a2;
  return node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOK ? (_a2 = findChildren(node, isNestedClipBookNodeView)) == null ? void 0 : _a2[0].node.attrs.kindleHighlights : void 0;
};
const getHighlightsFromClipBookmark = (node) => {
  var _a2;
  return node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOKMARK ? (_a2 = findChildren(node, isNestedClipBookmarkNodeView)) == null ? void 0 : _a2[0].node.attrs.highlights : void 0;
};
const isNestedClipBookmarkNodeView = (node) => node.type.name === NodeViewTypes.CLIP_BOOKMARK;
const createHighlightsBlockFromClipBookmark = ({
  schema,
  clip
}) => {
  const bookmarkHighlights = getHighlightsFromClipBookmark(clip);
  return Node.fromJSON(schema, bookmarkHighlights);
};
const syncClipBookmark = ({
  tr,
  highlightsBlock,
  clip
}) => {
  var _a2;
  const clipBookmarkNodePos = clip.pos + SESHAT_CONTENT_DEPTH + 1;
  const highlights = (_a2 = tr.doc.nodeAt(highlightsBlock.pos)) != null ? _a2 : highlightsBlock.node;
  return tr.updateAttrs(clipBookmarkNodePos, {
    highlights: highlights.toJSON()
  });
};
const isClipWithAttributesSync = (node) => (node == null ? void 0 : node.attrs) && (node.attrs.isPaywallContent && !node.textContent || node.attrs.video);
const addHighlightsInHighlightsAttribute = () => ({
  tr,
  dispatch,
  state
}) => {
  dispatch == null ? void 0 : dispatch(addHighlightsInHighlightsAttributeTransaction({ tr, state }));
  return false;
};
const addHighlightsInHighlightsAttributeTransaction = ({
  tr,
  state: { schema }
}) => {
  var _a2, _b2;
  const clip = (_a2 = findChildren(
    tr.doc,
    (node) => node.attrs.type === BlockTypes.CLIP_CONTENT
  )) == null ? void 0 : _a2[0];
  const highlightsBlock = (_b2 = findChildren(
    tr.doc,
    (node) => node.attrs.type === BlockTypes.HIGHLIGHTS
  )) == null ? void 0 : _b2[0];
  if (!clip || !highlightsBlock)
    return tr;
  if (!isClipThatShouldSyncWithAttributes(
    clip,
    highlightsBlock.node.content.content
  ))
    return tr;
  if (shouldHaveEmptyContent(clip)) {
    tr.delete(clip.pos + 1, clip.pos + clip.node.content.size);
    tr.insert(clip.pos + 1, createSeshatBlock({ schema }));
  }
  tr.setNodeMarkup(clip.pos, void 0, {
    ...clip.node.attrs,
    isPaywallContent: !clip.node.attrs.video,
    highlights: highlightsBlock ? highlightsBlock.node.toJSON() : void 0
  });
  tr.setNodeMarkup(highlightsBlock.pos, void 0, {
    ...highlightsBlock.node.attrs,
    connectedClip: clip.node.attrs[BlockAttrsParams.BLOCK_UUID]
  });
  return tr;
};
const highlightContentExceedsClipContent = (clip, highlights) => {
  const clipLength = clip.node.textContent.length;
  const highlightLength = highlights.reduce(
    (prev, node) => {
      var _a2, _b2;
      return prev + ((_b2 = (_a2 = node.firstChild) == null ? void 0 : _a2.textContent.length) != null ? _b2 : 0);
    },
    0
  );
  return highlightLength > clipLength;
};
const shouldHaveEmptyContent = (clip) => clip.node.attrs.isPaywallContent && !clip.node.attrs.video;
const isClipThatShouldSyncWithAttributes = (clip, highlights) => isClipWithAttributesSync(clip.node) || highlightContentExceedsClipContent(clip, highlights);
const applyBlockIdToExtension = (options) => (extension) => {
  var _a2;
  const generateId = (_a2 = options == null ? void 0 : options.generateRandomId) != null ? _a2 : generateRandomId;
  return extension.extend({
    addAttributes() {
      var _a3;
      return {
        ...(_a3 = this.parent) == null ? void 0 : _a3.call(this),
        [BlockAttrsParams.BLOCK_UUID]: {
          default: void 0,
          keepOnSplit: false,
          parseHTML: (element) => {
            return element.getAttribute(BlockAttrsParams.BLOCK_UUID) || generateId();
          },
          renderHTML: (attributes) => {
            return {
              ...attributes,
              [BlockAttrsParams.BLOCK_UUID]: attributes == null ? void 0 : attributes[BlockAttrsParams.BLOCK_UUID]
            };
          }
        }
      };
    }
  });
};
const getExtensionOptions = (editor, extensionName) => {
  var _a2, _b2;
  const extension = (_b2 = (_a2 = editor == null ? void 0 : editor.options) == null ? void 0 : _a2.extensions) == null ? void 0 : _b2.find(
    (r2) => r2.name === extensionName
  );
  return extension == null ? void 0 : extension.options;
};
const getSeshatEditorSchema = (extensionOptions) => {
  return getSchema(getEditorExtensions({ extensionOptions }));
};
const generateBlockId = (editor) => {
  var _a2, _b2, _c2;
  return (_c2 = (_b2 = (_a2 = getExtensionOptions(
    editor,
    BlockAttrsParams.BLOCK_UUID
  )) == null ? void 0 : _a2.generateId) == null ? void 0 : _b2.call(_a2)) != null ? _c2 : generateRandomId();
};
const getNodeAttribute = (node, type) => {
  var _a2;
  return (_a2 = node == null ? void 0 : node.attrs) == null ? void 0 : _a2[type];
};
const hasNodeSchemaAttribute = ({
  schema,
  node,
  attributeType
}) => {
  var _a2, _b2, _c2, _d2;
  if (!(schema == null ? void 0 : schema.nodes))
    return false;
  const nodeType = (_a2 = node == null ? void 0 : node.type) == null ? void 0 : _a2.name;
  if (!nodeType)
    return false;
  const attributesNodes = (_d2 = (_c2 = (_b2 = schema == null ? void 0 : schema.nodes) == null ? void 0 : _b2[nodeType]) == null ? void 0 : _c2.spec) == null ? void 0 : _d2.attrs;
  if (!attributesNodes)
    return true;
  return Object.keys(attributesNodes).some((val) => val === attributeType);
};
const pluginKey = new PluginKey(BlockAttrsParams.BLOCK_UUID);
const BlockIDExtension = (options) => Extension$1.create({
  name: "BlockIDExtension",
  addOptions() {
    var _a2;
    return {
      generateId: (_a2 = options == null ? void 0 : options.generateRandomId) != null ? _a2 : generateRandomId
    };
  },
  addProseMirrorPlugins() {
    const { options: options2 } = this;
    return [
      new Plugin({
        key: pluginKey,
        appendTransaction: (_, oldState, newState) => {
          const hasNoChange = newState.doc === oldState.doc;
          if (hasNoChange) {
            return;
          }
          let newTransaction = buildBlockIdTransaction(newState, options2);
          return newTransaction;
        }
      })
    ];
  }
});
const buildBlockIdTransaction = (newState, options) => {
  let { tr, schema } = newState;
  newState.doc.descendants((node, pos) => {
    var _a2, _b2;
    const blockID = getNodeAttribute(node, BlockAttrsParams.BLOCK_UUID);
    if (node.type.spec.group === SeshatNodeGroups.BLOCK) {
      if (!hasNodeSchemaAttribute({
        schema,
        node,
        attributeType: BlockAttrsParams.BLOCK_UUID
      }))
        return;
      const shouldAddBlockIdToNode = blockID === void 0 || blockID === null;
      if (shouldAddBlockIdToNode && node.type.validContent(node.content)) {
        const attrs = {
          ...node.attrs,
          [BlockAttrsParams.BLOCK_UUID]: (_b2 = (_a2 = options.generateId) == null ? void 0 : _a2.call(options)) != null ? _b2 : generateRandomId()
        };
        tr.setNodeMarkup(pos, void 0, attrs).setMeta(pluginKey, true);
      }
    }
  });
  return tr;
};
const getSeshatContentFromHtml$1 = ({
  content,
  schema
}) => {
  var _a2, _b2, _c2;
  const { jsonContent } = createJSONContentFromHTML({
    HTMLContent: content,
    schema,
    options: {
      parseOptions: {
        preserveWhitespace: "full"
      }
    },
    config: {
      bidirectionalName: "reference_bracket"
    }
  });
  if ((_b2 = (_a2 = jsonContent == null ? void 0 : jsonContent[0]) == null ? void 0 : _a2.content) == null ? void 0 : _b2.length)
    return (_c2 = jsonContent == null ? void 0 : jsonContent[0]) == null ? void 0 : _c2.content;
  return [
    createSeshatBlock({
      attrs: {
        type: BlockTypes.PARAGRAPH
      },
      schema
    }).toJSON()
  ];
};
const DEPTH_BETWEEN_PREVIOUS_SESHAT_BLOCK_AND_CLIP_CONTENT_FIRST_ELEMENT = (SESHAT_CONTENT_DEPTH + 1) * 2 + 1;
const insertClip = ({
  contentEditable,
  content,
  href,
  hrefBackup,
  contextUuid,
  status,
  insertAtEnd = false,
  focus,
  attrs
}) => ({ editor, chain, state, tr }) => {
  const htmlAsContent = getSeshatContentFromHtml$1({
    schema: state.schema,
    content
  });
  const {
    selection,
    doc: { nodeSize }
  } = tr;
  const { $from } = selection;
  const selectionEndBlock = $from.end();
  const pos = $from.pos;
  const docSize = nodeSize - SESHAT_CONTENT_DEPTH * 2;
  const insertPosition = insertAtEnd ? docSize + 1 : selectionEndBlock + SESHAT_CONTENT_DEPTH + 1;
  const focusPos = !href ? pos : selectionEndBlock + DEPTH_BETWEEN_PREVIOUS_SESHAT_BLOCK_AND_CLIP_CONTENT_FIRST_ELEMENT;
  const clipUuid = generateBlockId(editor);
  let _chain = chain().replaceWith({
    content: {
      type: SeshatNodes.WRAPPING_BLOCK,
      content: htmlAsContent,
      attrs: {
        ...attrs,
        type: BlockTypes.CLIP_CONTENT,
        contentEditable,
        href,
        hrefBackup,
        [BlockAttrsParams.CONTEXT_UUID]: contextUuid,
        [BlockAttrsParams.BLOCK_UUID]: clipUuid,
        status
      }
    },
    from: insertPosition,
    to: insertPosition
  });
  _chain = maybeConnectHighlights({ tr, chain: _chain, clipUuid });
  if (focus === false)
    return _chain.run();
  _chain.focus(focusPos);
  if (contentEditable !== false) {
    _chain.scrollIntoView();
  }
  return _chain.run();
};
const maybeConnectHighlights = ({
  tr,
  clipUuid,
  chain
}) => {
  const highlightWithNoConnection = findChildren(
    tr.doc,
    (node) => node.attrs.type === BlockTypes.HIGHLIGHTS
  ).find((nodePos) => !nodePos.node.attrs.connectedClip);
  if (highlightWithNoConnection) {
    chain.updateBlockAttributesAt({
      pos: highlightWithNoConnection.pos,
      attrs: { connectedClip: clipUuid }
    });
    chain.setMeta("clipObserverPlugin", true);
  }
  return chain;
};
const ANNOTATION_MODE_ATTRIBUTE = "data-annotation-mode";
const ANNOTATION_META = "annotation";
const isAnnotation = (transaction) => {
  return transaction.getMeta(ANNOTATION_META) === true;
};
const AnnotationModeExtension = (options) => Extension$1.create({
  name: "annotationMode",
  addOptions() {
    return { annotationOnly: options == null ? void 0 : options.annotationOnly };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("annotationMode"),
        filterTransaction: (transaction) => {
          if (!this.options.annotationOnly) {
            return true;
          }
          if (transaction.docChanged) {
            return isAnnotation(transaction);
          }
          return true;
        },
        props: {
          attributes: this.options.annotationOnly ? { [ANNOTATION_MODE_ATTRIBUTE]: "true" } : void 0
        }
      })
    ];
  },
  addCommands() {
    return {
      markAsAnnotation: () => ({ chain }) => {
        chain().setMeta(ANNOTATION_META, true).setMeta(ANALYTICS_META, "Add Highlight Note from Clip");
        return true;
      }
    };
  }
});
function checkIfNextContent({ state }) {
  let hasNextContent = false;
  const $to = state.selection.$to;
  const endOfBlock = isBlockSelection(state.selection) ? state.selection.to : state.selection.$from.after();
  state.doc.cut(endOfBlock, $to.end(0)).descendants((node) => {
    if (node.type.name === SeshatNodes.CONTENT) {
      hasNextContent = true;
    }
    return !hasNextContent;
  });
  return hasNextContent;
}
const insertTrailingLineOnArrowDown = () => ({
  state,
  chain
}) => {
  const { from } = state.selection;
  const block = getCurrentBlock(state.doc, from);
  if (isCurrentBlockEmptyText(block == null ? void 0 : block.node))
    return false;
  if (checkIfNextContent({ state }))
    return false;
  chain().unsetBlockSelection().insertTrailingLine({}).run();
  return true;
};
const isCurrentBlockEmptyText = (node) => {
  return !node || node.textContent === "" || isSeshatBlockEmpty(node);
};
function isMouseUnderLastBlock({
  view,
  e
}) {
  var _a2;
  const lastBlockDom = (_a2 = view.dom) == null ? void 0 : _a2.lastElementChild;
  return lastBlockDom && e.pageY > lastBlockDom.getBoundingClientRect().bottom;
}
const onMouseDown = (view, e) => {
  if (!(e instanceof MouseEvent))
    return false;
  const { state, dispatch } = view;
  const {
    selection: { $from }
  } = state;
  if (isLastBlockEmptyText({ $from }))
    return false;
  if (!isMouseUnderLastBlock({ view, e }))
    return false;
  dispatch == null ? void 0 : dispatch(insertTrailingLineTransaction({ state, tr: state.tr }));
  return true;
};
const isLastBlockEmptyText = ({ $from }) => {
  const mainBlock = $from.node(SESHAT_ROOT_DEPTH);
  if (!mainBlock)
    return false;
  const lastBlock = mainBlock.child(mainBlock.childCount - 1);
  return !isAtom(lastBlock) && !lastBlock.textContent;
};
const TrailingLineExtension = Extension$1.create({
  name: "TrailingLineExtension",
  addCommands() {
    return {
      insertTrailingLineOnArrowDown,
      insertTrailingLine
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: { handleDOMEvents: { mousedown: onMouseDown } },
        appendTransaction: (_, __, state) => {
          const parentBlock = state.doc.firstChild;
          if (parentBlock && !hasEditableChildBlocks(parentBlock))
            return insertTrailingLineTransaction({
              state,
              tr: state.tr,
              withoutSetSelection: true
            });
          return;
        }
      })
    ];
  }
});
const hasEditableChildBlocks = (blockNode) => {
  return findChildren(
    blockNode,
    (node) => node.type.spec.group === SeshatNodeGroups.BLOCK && !isAtom(node)
  ).length;
};
const FontColorExtension = Extension$1.create({
  name: "FontColorExtension",
  addOptions() {
    return {
      types: [MarkTypes.TEXT_STYLE]
    };
  },
  parseHTML() {
    return [
      {
        tag: "span.color",
        priority: 56
      }
    ];
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontColor: {
            default: null,
            renderHTML: (attributes) => attributes.fontColor ? {
              style: `color: ${attributes.fontColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontColor: (fontColor) => ({ chain }) => {
        return chain().setMark(MarkTypes.TEXT_STYLE, { fontColor }).run();
      },
      unsetFontColor: () => ({ chain }) => {
        return chain().setMark(MarkTypes.TEXT_STYLE, { fontColor: null }).removeEmptyTextStyle().run();
      }
    };
  }
});
const updateBlockAttributes = (attrs) => ({
  tr,
  state,
  dispatch
}) => {
  const finalTr = updateBlockAttributesTransaction({
    state,
    tr,
    attrs
  });
  if (finalTr) {
    dispatch == null ? void 0 : dispatch(finalTr);
    return true;
  }
  return false;
};
const updateBlockAttributesTransaction = ({
  tr,
  state,
  attrs
}) => {
  const blockSelection = isBlockSelection(state.selection) ? state.selection : BlockSelection.createFromTextSelection(state.doc, state.selection);
  const type = attrs.type;
  blockSelection.list().reverse().forEach((block) => {
    if (type && getNodeTypeByBlockType(type) === SeshatNodes.WRAPPING_BLOCK && getNodeTypeByBlockType(block.node.attrs.type) !== SeshatNodes.WRAPPING_BLOCK) {
      wrapIntoBlock$1({
        tr,
        schema: state.schema,
        attrs: { ...attrs, type },
        $from: block.$from,
        $to: block.$to
      });
    } else {
      tr.setNodeMarkup(block.from, void 0, {
        ...block.node.attrs,
        ...attrs
      });
    }
  });
  return tr;
};
const wrapIntoBlock$1 = ({
  schema,
  tr,
  attrs,
  $from,
  $to
}) => {
  if (getNodeTypeByBlockType(attrs.type) !== SeshatNodes.WRAPPING_BLOCK)
    return tr;
  const seshatBlockNode = $from.node();
  if (seshatBlockNode.type.spec.group !== SeshatNodeGroups.BLOCK)
    return tr;
  const range = $from.blockRange($to);
  if (!range)
    return tr;
  tr.wrap(range, [{ type: schema.nodes[SeshatNodes.WRAPPING_BLOCK], attrs }]);
  tr.scrollIntoView();
  return tr;
};
const TextAlignExtension = Extension$1.create({
  name: "TextAlignExtension",
  addCommands() {
    return {
      setAlign: (align) => ({ tr, state, dispatch }) => {
        const block = getCurrentBlock(tr.doc, tr.selection.from);
        if (!block)
          return false;
        tr = updateBlockAttributesTransaction({
          tr,
          state,
          attrs: {
            ...block.node.attrs,
            textAlign: align
          }
        });
        dispatch == null ? void 0 : dispatch(tr);
        return true;
      }
    };
  }
});
const ContextIDExtension = (options) => Extension$1.create({
  name: "ContextUuidExtension",
  addOptions() {
    var _a2;
    return {
      generateId: (_a2 = options == null ? void 0 : options.generateRandomId) != null ? _a2 : generateRandomId
    };
  }
});
const applyContextIdToExtension = (extension) => extension.extend({
  addAttributes() {
    var _a2;
    return {
      ...(_a2 = this.parent) == null ? void 0 : _a2.call(this),
      [BlockAttrsParams.CONTEXT_UUID]: {
        default: void 0,
        keepOnSplit: false,
        parseHTML: (element) => {
          const contextUuid = element.getAttribute(
            BlockAttrsParams.CONTEXT_UUID
          );
          return contextUuid;
        },
        renderHTML: (attributes) => {
          return {
            ...attributes,
            [BlockAttrsParams.CONTEXT_UUID]: attributes == null ? void 0 : attributes[BlockAttrsParams.CONTEXT_UUID]
          };
        }
      }
    };
  }
});
const PAIRED_TOKEN = {
  "(": ")",
  "[": "]",
  "{": "}"
};
const wrapSelectionWithBrackets = (token) => ({
  tr,
  dispatch
}) => {
  const { selection } = tr;
  if (selection.empty)
    return false;
  if (!(selection instanceof TextSelection))
    return false;
  if (!isInlineContent(selection))
    return false;
  const { from, to } = selection;
  tr.insertText(token, from);
  tr.insertText(PAIRED_TOKEN[token], to + 1);
  tr.setSelection(TextSelection.create(tr.doc, from + 1, to + 1));
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const isInlineContent = (selection) => selection.$from.parent.inlineContent;
const BRACKETS_EXTENSION_NAME = "BracketsExtension";
const BracketsExtension = Extension$1.create({
  name: BRACKETS_EXTENSION_NAME,
  addProseMirrorPlugins() {
    const shortcuts = addKeypressShortcuts(this.editor);
    const handler = keypressHandler(shortcuts);
    return [makePlugin(BRACKETS_EXTENSION_NAME, handler)];
  },
  addCommands() {
    return { wrapSelectionWithBrackets };
  }
});
const addKeypressShortcuts = (editor) => ({
  "(": makeWrapSelectionWithBrackets(editor, "("),
  "[": makeWrapSelectionWithBrackets(editor, "["),
  "{": makeWrapSelectionWithBrackets(editor, "{")
});
const keypressHandler = (shortcuts) => (view, event) => {
  var _a2, _b2;
  const { key } = event;
  return (_b2 = (_a2 = shortcuts == null ? void 0 : shortcuts[key]) == null ? void 0 : _a2.call(shortcuts, view.state)) != null ? _b2 : false;
};
const makeWrapSelectionWithBrackets = (editor, token) => () => editor.commands.wrapSelectionWithBrackets(token);
const makePlugin = (key, handleKeyPress2) => new Plugin({ key: new PluginKey(key), props: { handleKeyPress: handleKeyPress2 } });
const RestoreLayoutPlugin = new Plugin({
  key: new PluginKey("restore-document-layout-plugin"),
  appendTransaction: (trs, __, state) => {
    if (hasValidLayout(state.doc))
      return;
    const attrs = getAttrsFromOldRootBlock(trs);
    if (!attrs)
      return;
    const { tr, schema } = state;
    const children = [createSeshatBlock({ schema })];
    const newRootBlock = createSeshatBlock({ attrs, schema, children });
    tr.replaceWith(0, tr.doc.content.size, newRootBlock);
    tr.setSelection(TextSelection.create(tr.doc, SESHAT_ROOT_DEPTH));
    return tr;
  }
});
const isRootBlockType = (type) => type === BlockTypes.CARD_CONTENT || type === BlockTypes.CAPTURE;
const hasValidLayout = (doc) => {
  var _a2;
  return isRootBlockType((_a2 = doc.firstChild) == null ? void 0 : _a2.attrs.type);
};
const getAttrsFromOldRootBlock = (trs) => {
  const docs = trs.reduce(
    (prevDocs, tr) => [...prevDocs, ...tr.docs],
    []
  );
  const attrs = docs.reduce((prevAttrs, doc) => {
    var _a2, _b2;
    if (isRootBlockType((_a2 = doc.firstChild) == null ? void 0 : _a2.attrs.type))
      return { ...prevAttrs, ...(_b2 = doc.firstChild) == null ? void 0 : _b2.attrs };
    else
      return prevAttrs;
  }, {});
  return attrs.type ? attrs : void 0;
};
const LayoutNode = Document.extend({
  content: `${SeshatNodeGroups.BLOCK}`,
  addProseMirrorPlugins() {
    return [RestoreLayoutPlugin];
  }
});
const TabIndexExtension = Extension$1.create({
  name: "TabIndexExtension",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("TabIndex"),
        props: {
          attributes: () => {
            return {
              tabindex: "-1"
            };
          }
        }
      })
    ];
  }
});
const resetHistory = () => ({ view, editor }) => {
  const plugins = view.state.plugins;
  const historyPlugin = plugins == null ? void 0 : plugins.find(
    (plugin) => {
      var _a2;
      return (_a2 = plugin == null ? void 0 : plugin.key) == null ? void 0 : _a2.includes("history");
    }
  );
  const newState = view.state.reconfigure({
    plugins: [...plugins.filter((plugin) => {
      var _a2;
      return !((_a2 = plugin.key) == null ? void 0 : _a2.includes("history"));
    })]
  });
  view.updateState(newState);
  setTimeout(function registerNewInstanceOfHistoryPlugin() {
    editor.registerPlugin(history({ ...historyPlugin == null ? void 0 : historyPlugin.spec.config }));
  }, 500);
  return true;
};
const HistoryExtension = History.extend({
  addCommands() {
    var _a2;
    return {
      ...(_a2 = this.parent) == null ? void 0 : _a2.call(this),
      resetHistory
    };
  }
});
const clipboardSerializerConfig = {
  [BlockTypes.PARAGRAPH]: ({ content }) => {
    return `<p>${content}</p>`;
  },
  [BlockTypes.HEADING_1]: ({ content }) => {
    return `<h1>${content}</h1>`;
  },
  [BlockTypes.HEADING_2]: ({ content }) => {
    return `<h2>${content}</h2>`;
  },
  [BlockTypes.HEADING_3]: ({ content }) => {
    return `<h3>${content}</h3>`;
  },
  [BlockTypes.HEADING_4]: ({ content }) => {
    return `<h4>${content}</h4>`;
  },
  [BlockTypes.NUMBERED_LIST]: ({ content, prevNode, nextNode }) => {
    return `${(prevNode == null ? void 0 : prevNode.attrs.type) !== BlockTypes.NUMBERED_LIST ? "<ol>" : ""}<li>${content}</li>${(nextNode == null ? void 0 : nextNode.attrs.type) !== BlockTypes.NUMBERED_LIST ? "</ol>" : ""}`;
  },
  [BlockTypes.BULLETED_LIST]: ({ content, prevNode, nextNode }) => {
    return `${(prevNode == null ? void 0 : prevNode.attrs.type) !== BlockTypes.BULLETED_LIST ? "<ul>" : ""}<li>${content}</li>${(nextNode == null ? void 0 : nextNode.attrs.type) !== BlockTypes.BULLETED_LIST ? "</ul>" : ""}`;
  },
  [BlockTypes.BLOCKQUOTE]: ({ content }) => {
    return content ? `<blockquote>${content}</blockquote>` : "";
  },
  [BlockTypes.HIGHLIGHTS]: ({ content }) => {
    return `<div><strong>Highlights:</strong></div><div>${content}</div>`;
  },
  [BlockTypes.HIGHLIGHT]: ({ node, content }) => {
    return node.attrs.timestamp ? `<blockquote>${node.attrs.timestamp}</blockquote>${content}` : content;
  },
  [SeshatNodes.CONTENT_NODE_VIEW]: ({ content }) => {
    return content;
  },
  [SeshatNodes.CONTENT]: ({ content }) => {
    return content;
  },
  [SeshatNodes.BLOCK_CONTENT]: ({ content }) => {
    return content;
  },
  [SeshatInlineNodes.REFERENCE]: ({ node, content }) => {
    var _a2;
    return (_a2 = `[[${node.attrs.value}]]`) != null ? _a2 : content;
  },
  default: ({ content }) => {
    return `<div>${content}</div>`;
  }
};
class ClipboardDOMSerializer {
  constructor(schema) {
    this.serialize = ({
      node,
      prevNode,
      nextNode
    }) => {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
      if (!node)
        return "";
      if (node.isInline) {
        const wrapper = document.createElement("div");
        const serializedContent = (_b2 = (_a2 = clipboardSerializerConfig[node.type.name]) == null ? void 0 : _a2.call(clipboardSerializerConfig, { node, content: "" })) != null ? _b2 : this.nativeSerializer.serializeNode(node);
        wrapper.append(serializedContent);
        return wrapper.innerHTML;
      }
      const content = (_e2 = (_d2 = (_c2 = node == null ? void 0 : node.content) == null ? void 0 : _c2.content) == null ? void 0 : _d2.reduce(
        (acc, childNode, i) => acc + this.serialize({
          node: childNode,
          prevNode: node.content.content[i - 1],
          nextNode: node.content.content[i + 1]
        }),
        ""
      )) != null ? _e2 : "";
      const serializeNode = (_g2 = (_f2 = clipboardSerializerConfig[node.attrs.type]) != null ? _f2 : clipboardSerializerConfig[node.type.name]) != null ? _g2 : clipboardSerializerConfig.default;
      return serializeNode({ node, content, prevNode, nextNode });
    };
    this.nativeSerializer = DOMSerializer.fromSchema(schema);
    this.marks = this.nativeSerializer.marks;
    this.nodes = this.nativeSerializer.nodes;
  }
  serializeFragment(fragment) {
    const html = this.serialize({ node: fragment.content[0] });
    return createFragmentFromHtml(html);
  }
  serializeNode(node) {
    const html = this.serialize({ node });
    return createNodeFromHtml(html);
  }
}
const createNodeFromHtml = (html) => {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;
  return wrapper.firstChild;
};
const createFragmentFromHtml = (html) => {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;
  const formattedDomFragment = document.createDocumentFragment();
  formattedDomFragment.append(...wrapper.children);
  return formattedDomFragment;
};
class ClipboardTextSerializer {
  serializeFragment(fragment) {
    let textContent = "";
    fragment.descendants((node) => {
      var _a2, _b2;
      if (!node.isInline) {
        textContent += "\n";
        return;
      }
      textContent += (_b2 = (_a2 = clipboardSerializerConfig[node.type.name]) == null ? void 0 : _a2.call(clipboardSerializerConfig, { node, content: "" })) != null ? _b2 : node.textContent;
    });
    return textContent;
  }
  serializeSlice(slice) {
    return this.serializeFragment(slice.content);
  }
}
const setClipboardEventData = ({
  state,
  data
}) => {
  var _a2;
  const slice = state.selection.content();
  if (!slice.size)
    return;
  const domSerializer = new ClipboardDOMSerializer(state.schema);
  const domFragment = domSerializer.serializeFragment(slice.content);
  const dom = document.createElement("div");
  dom.append(domFragment);
  const textSerializer = new ClipboardTextSerializer();
  const text = textSerializer.serializeFragment(slice.content);
  (_a2 = data.clearData) == null ? void 0 : _a2.call(data);
  data.setData("text/html", dom.innerHTML);
  data.setData("text/plain", text);
  data.setData(
    "application/json",
    JSON.stringify({
      slice: slice.toJSON(),
      blockSelection: isBlockSelection(state.selection)
    })
  );
};
const clipboardCopyHandler = (view, event) => {
  if (!(event instanceof ClipboardEvent))
    return true;
  const data = event.clipboardData;
  event.preventDefault();
  if (!data)
    return true;
  setClipboardEventData({ state: view.state, data });
  return true;
};
const clipboardCutHandler = (view, event) => {
  var _a2;
  if (!(event instanceof ClipboardEvent))
    return true;
  const data = event.clipboardData;
  event.preventDefault();
  if (!data)
    return true;
  setClipboardEventData({ state: view.state, data });
  const { tr } = view.state;
  tr.deleteSelection();
  (_a2 = view.dispatch) == null ? void 0 : _a2.call(view, tr);
  return true;
};
const ATTRS_TO_UNSET = [
  BlockAttrsParams.BLOCK_UUID,
  BlockAttrsParams.HIGHLIGHT_UUID,
  MarkAttrsParams.HIGHLIGHT_NOTE
];
const resetAttrsInSlice = (schema, slice) => {
  var _a2;
  const newSlice = Slice.fromJSON(schema, (_a2 = slice.toJSON()) != null ? _a2 : {});
  newSlice.content.nodesBetween(0, newSlice.size, (node) => {
    node = resetAttrsInNode(node, ATTRS_TO_UNSET);
  });
  return newSlice;
};
const resetAttrsInNode = (node, attrs) => {
  const updatedNode = Object.assign({}, node);
  attrs.forEach((attr) => {
    if (node.attrs[attr] !== void 0) {
      updatedNode.attrs[attr] = void 0;
    }
    node.marks.forEach((mark, i) => {
      if (mark.attrs[attr] !== void 0) {
        updatedNode.marks[i].attrs[attr] = attr === MarkAttrsParams.HIGHLIGHT_UUID ? generateRandomId() : void 0;
      }
    });
  });
  return updatedNode;
};
const WRAPPING_BLOCKS_TO_REMOVE = [
  BlockTypes.HIGHLIGHTS,
  BlockTypes.HIGHLIGHT,
  BlockTypes.HIGHLIGHT_NOTE
];
const cleanupPastedContent = ({
  state,
  pastedContentRange
}) => {
  const { tr } = state;
  const isPasteWithinClipContent = !!findAncestor(
    tr.selection.$from,
    (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.CLIP_CONTENT
  );
  tr.doc.nodesBetween(
    pastedContentRange.from,
    pastedContentRange.to,
    (node, pos) => {
      var _a2;
      if (pos < pastedContentRange.from || pos > pastedContentRange.to)
        return;
      const blockType = (_a2 = node.attrs.nodeViewType) != null ? _a2 : node.attrs.type;
      if (WRAPPING_BLOCKS_TO_REMOVE.includes(blockType)) {
        const $from = tr.doc.resolve(tr.mapping.map(pos + 1));
        const $to = tr.doc.resolve(tr.mapping.map(pos + node.nodeSize - 1));
        tr.lift(new NodeRange($from, $to, $from.depth), $from.depth - 1);
      }
      if (isPasteWithinClipContent && clipBlocks.includes(blockType)) {
        tr.delete(tr.mapping.map(pos), tr.mapping.map(pos + node.content.size));
      }
    }
  );
  return tr;
};
const pastedInEmptyPaywallClip = (state) => {
  var _a2, _b2, _c2;
  const { $anchor } = state.selection;
  const { depth } = $anchor;
  const clipNode = depth >= 5 && $anchor.node(depth - 3);
  return clipNode && clipNode.attrs.type === BlockTypes.CLIP_CONTENT && clipNode.attrs.isPaywallContent && ((_c2 = (_b2 = (_a2 = clipNode.firstChild) == null ? void 0 : _a2.firstChild) == null ? void 0 : _b2.firstChild) == null ? void 0 : _c2.childCount) === 0;
};
const clipboardPasteHandler = (view, e, pastedSlice) => {
  var _a2, _b2, _c2;
  if ((_a2 = e.clipboardData) == null ? void 0 : _a2.files.length)
    return false;
  const { state, dispatch } = view;
  let { tr } = state;
  const clipboardSerializedData = (_c2 = (_b2 = e.clipboardData) == null ? void 0 : _b2.getData("application/json")) != null ? _c2 : void 0;
  const clipboardData = clipboardSerializedData && JSON.parse(clipboardSerializedData);
  const content = clipboardData ? Slice.fromJSON(state.schema, clipboardData.slice) : pastedSlice;
  const slice = resetAttrsInSlice(view.state.schema, content);
  const hasBlocks = slice.content.content.some((node) => node.isBlock);
  if (hasBlocks && (!clipboardData || clipboardData.blockSelection)) {
    tr = pasteAsBlocks({ view, slice });
  } else {
    tr.replace(state.selection.from, state.selection.to, slice);
  }
  if (pastedInEmptyPaywallClip(state)) {
    tr = setIsPaywallContent({ tr, state, value: false });
    tr = matchHighlightsWithClipContentTransaction({ tr, state });
  }
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const pasteAsBlocks = ({ view, slice }) => {
  var _a2, _b2, _c2, _d2;
  const selection = view.state.selection;
  const lastBlock = isBlockSelection(selection) ? selection.lastBlock() : getCurrentBlock(view.state.doc, selection.to);
  if (!lastBlock)
    return view.state.tr;
  let tr = view.state.tr;
  const startPos = lastBlock.node.textContent ? lastBlock.to : lastBlock.from;
  const endPos = lastBlock.to;
  tr.replace(startPos, endPos, slice);
  (_a2 = view.dispatch) == null ? void 0 : _a2.call(view, tr);
  const pastedContentRange = { from: startPos, to: startPos + slice.size };
  const newTr = cleanupPastedContent({ state: view.state, pastedContentRange });
  if (isUrl((_d2 = (_c2 = (_b2 = slice == null ? void 0 : slice.content) == null ? void 0 : _b2.content) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.textContent))
    return newTr;
  newTr.setSelection(
    BlockSelection.createFromRange(
      newTr.doc,
      newTr.mapping.map(startPos),
      newTr.mapping.map(startPos + slice.size)
    )
  );
  return newTr.scrollIntoView();
};
const setIsPaywallContent = ({
  tr,
  state,
  value
}) => {
  const { $anchor } = state.selection;
  const { depth } = $anchor;
  const clipNode = depth >= 5 && $anchor.node(depth - 3);
  if (!clipNode || clipNode.attrs.type !== BlockTypes.CLIP_CONTENT)
    return tr;
  const clipPos = $anchor.pos - 1 - SESHAT_CONTENT_DEPTH - 1;
  return tr.setNodeMarkup(clipPos, void 0, {
    ...clipNode.attrs,
    isPaywallContent: value === true ? true : void 0
  });
};
const ClipboardExtension = Extension$1.create({
  name: "ClipboardExtension",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handlePaste: clipboardPasteHandler,
          handleDOMEvents: {
            copy: clipboardCopyHandler,
            cut: clipboardCutHandler
          }
        }
      })
    ];
  }
});
const INDENTATION_PADDING = 21;
const insertAsBlockBefore = ($block) => {
  return { pos: $block.from };
};
const insertAsBlockAfter = ($block) => {
  return { pos: $block.to };
};
const insertAsNestedBlock = ($block) => {
  return { pos: $block.from + 1 };
};
const insertAsIndentedBlock = ($block) => {
  var _a2;
  const blockContentLength = ((_a2 = $block.node.firstChild) == null ? void 0 : _a2.nodeSize) || 0;
  return {
    pos: $block.from + blockContentLength + 1,
    indented: true
  };
};
const insertAsColumn$1 = ($block, side) => {
  return {
    pos: findColumnInsertPos($block),
    column: side
  };
};
const findColumnInsertPos = ($block) => {
  let pos = $block.from;
  if (!isBlockColumn($block.node)) {
    const existingBlockColumn = findAncestor($block.$from, isBlockColumn);
    pos = existingBlockColumn ? $block.$from.before(existingBlockColumn.depth) : $block.from;
  }
  return pos;
};
const isBlockColumn = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.BLOCK_COLUMN;
const fault = Object.assign(create(Error), {
  eval: create(EvalError),
  range: create(RangeError),
  reference: create(ReferenceError),
  syntax: create(SyntaxError),
  type: create(TypeError),
  uri: create(URIError)
});
function create(Constructor) {
  FormattedError.displayName = Constructor.displayName || Constructor.name;
  return FormattedError;
  function FormattedError(format, ...values) {
    const reason = format ? formatter(format, ...values) : format;
    return new Constructor(reason);
  }
}
const own = {}.hasOwnProperty;
const defaultPrefix = "hljs-";
function highlight(language, value, options = {}) {
  let prefix = options.prefix;
  if (typeof language !== "string") {
    throw fault("Expected `string` for name, got `%s`", language);
  }
  if (!high.getLanguage(language)) {
    throw fault("Unknown language: `%s` is not registered", language);
  }
  if (typeof value !== "string") {
    throw fault("Expected `string` for value, got `%s`", value);
  }
  if (prefix === null || prefix === void 0) {
    prefix = defaultPrefix;
  }
  high.configure({ __emitter: HastEmitter, classPrefix: prefix });
  const result = high.highlight(value, { language, ignoreIllegals: true });
  high.configure({});
  if (result.errorRaised) {
    throw result.errorRaised;
  }
  result._emitter.root.data.language = result.language;
  result._emitter.root.data.relevance = result.relevance;
  return result._emitter.root;
}
function highlightAuto(value, options = {}) {
  const subset = options.subset || high.listLanguages();
  options.prefix;
  let index = -1;
  let result = {
    type: "root",
    data: { language: null, relevance: 0 },
    children: []
  };
  if (typeof value !== "string") {
    throw fault("Expected `string` for value, got `%s`", value);
  }
  while (++index < subset.length) {
    const name = subset[index];
    if (!high.getLanguage(name))
      continue;
    const current = highlight(name, value, options);
    if (current.data.relevance > result.data.relevance)
      result = current;
  }
  return result;
}
function registerLanguage(language, syntax) {
  high.registerLanguage(language, syntax);
}
const registerAlias = function(language, alias) {
  if (typeof language === "string") {
    high.registerAliases(alias, { languageName: language });
  } else {
    let key;
    for (key in language) {
      if (own.call(language, key)) {
        high.registerAliases(language[key], { languageName: key });
      }
    }
  }
};
function registered(aliasOrLanguage) {
  return Boolean(high.getLanguage(aliasOrLanguage));
}
function listLanguages() {
  return high.listLanguages();
}
class HastEmitter {
  constructor(options) {
    this.options = options;
    this.root = {
      type: "root",
      data: { language: null, relevance: 0 },
      children: []
    };
    this.stack = [this.root];
  }
  addText(value) {
    if (value === "")
      return;
    const current = this.stack[this.stack.length - 1];
    const tail = current.children[current.children.length - 1];
    if (tail && tail.type === "text") {
      tail.value += value;
    } else {
      current.children.push({ type: "text", value });
    }
  }
  addKeyword(value, name) {
    this.openNode(name);
    this.addText(value);
    this.closeNode();
  }
  addSublanguage(other, name) {
    const current = this.stack[this.stack.length - 1];
    const results = other.root.children;
    if (name) {
      current.children.push({
        type: "element",
        tagName: "span",
        properties: { className: [name] },
        children: results
      });
    } else {
      current.children.push(...results);
    }
  }
  openNode(name) {
    const className = name.split(".").map((d, i) => i ? d + "_".repeat(i) : this.options.classPrefix + d);
    const current = this.stack[this.stack.length - 1];
    const child = {
      type: "element",
      tagName: "span",
      properties: { className },
      children: []
    };
    current.children.push(child);
    this.stack.push(child);
  }
  closeNode() {
    this.stack.pop();
  }
  closeAllNodes() {
  }
  finalize() {
  }
  toHTML() {
    return "";
  }
}
const lowlight = {
  highlight,
  highlightAuto,
  registerLanguage,
  registered,
  listLanguages,
  registerAlias
};
const parseNodes = (nodes, className = []) => {
  return nodes.map((node) => {
    const classes = [
      ...className,
      ...node.properties ? node.properties.className : []
    ];
    if (node.children) {
      return parseNodes(node.children, classes);
    }
    return {
      text: node.value,
      classes
    };
  }).flat();
};
const generateDecorationsForABlock = (block, language) => {
  const blockDecorations = [];
  let from = block.pos + SESHAT_CONTENT_DEPTH + 1;
  const nodes = lowlight.highlight(language, block.node.textContent).children;
  parseNodes(nodes).forEach((node) => {
    const to = from + node.text.length;
    if (node.classes.length) {
      const decoration = Decoration.inline(from, to, {
        class: node.classes.join(" ")
      });
      blockDecorations.push(decoration);
    }
    from = to;
  });
  return blockDecorations;
};
lowlight.registerLanguage("arduino", arduino);
lowlight.registerLanguage("bash", bash);
lowlight.registerLanguage("c", c);
lowlight.registerLanguage("cpp", cpp);
lowlight.registerLanguage("csharp", csharp);
lowlight.registerLanguage("css", css);
lowlight.registerLanguage("diff", diff);
lowlight.registerLanguage("go", go);
lowlight.registerLanguage("ini", ini);
lowlight.registerLanguage("java", java);
lowlight.registerLanguage("javascript", javascript);
lowlight.registerLanguage("json", json);
lowlight.registerLanguage("kotlin", kotlin);
lowlight.registerLanguage("less", less);
lowlight.registerLanguage("lua", lua);
lowlight.registerLanguage("makefile", makefile);
lowlight.registerLanguage("markdown", markdown);
lowlight.registerLanguage("objectivec", objectivec);
lowlight.registerLanguage("perl", perl);
lowlight.registerLanguage("php", php);
lowlight.registerLanguage("php-template", phpTemplate);
lowlight.registerLanguage("plaintext", plaintext);
lowlight.registerLanguage("python", python);
lowlight.registerLanguage("python-repl", pythonRepl);
lowlight.registerLanguage("r", r);
lowlight.registerLanguage("ruby", ruby);
lowlight.registerLanguage("rust", rust);
lowlight.registerLanguage("scss", scss);
lowlight.registerLanguage("shell", shell);
lowlight.registerLanguage("sql", sql);
lowlight.registerLanguage("swift", swift);
lowlight.registerLanguage("typescript", typescript);
lowlight.registerLanguage("vbnet", vbnet);
lowlight.registerLanguage("xml", xml);
lowlight.registerLanguage("yaml", yaml);
const plainTextLanguage = "plain-text";
const codeBlockLanguages = [
  plainTextLanguage,
  ...lowlight.listLanguages()
];
const isSupportedCodeBlockLanguage = (language) => codeBlockLanguages.includes(language);
const getDecorations = ({ doc }) => {
  let decorations = [];
  findChildren(doc, (node) => node.attrs.type === BlockTypes.CODE).forEach(
    (block) => {
      const language = block.node.attrs.language;
      if (!isSupportedCodeBlockLanguage(language))
        return;
      const blockDecorations = generateDecorationsForABlock(block, language);
      decorations = decorations.concat(blockDecorations);
    }
  );
  return DecorationSet.create(doc, decorations);
};
const CodeBlockHighlightPluginKey = new PluginKey("code-block-highlight");
const CodeBlockHighlightPlugin = new Plugin({
  key: CodeBlockHighlightPluginKey,
  state: {
    init: (_, { doc }) => getDecorations({ doc }),
    apply: ({ doc, docChanged }, decorationSet) => docChanged ? getDecorations({ doc }) : decorationSet
  },
  props: {
    decorations(state) {
      return CodeBlockHighlightPluginKey.getState(state);
    }
  }
});
const CodeBlockPastePlugin = new Plugin({
  key: new PluginKey("code-block-paste-plugin"),
  props: {
    handlePaste: (view, event, slice) => {
      if (!event.clipboardData)
        return false;
      const text = event.clipboardData.getData("text/plain");
      if (!text)
        return false;
      const { state, dispatch } = view;
      const block = getCurrentBlock(state.doc, state.selection.from);
      if (!block)
        return false;
      const vscode = event.clipboardData.getData("vscode-editor-data");
      const vscodeData = vscode ? JSON.parse(vscode) : void 0;
      const vscodeLang = vscodeData == null ? void 0 : vscodeData.mode;
      let { tr, schema } = state;
      const content = text.replace(/\r\n?/g, "\n");
      const isPasteWithinCodeBlock = block.node.attrs.type === BlockTypes.CODE;
      const isPastedCodeBlock = vscodeData || isSliceWithSingleCodeBlock(slice);
      if (!isPasteWithinCodeBlock && !isPastedCodeBlock)
        return false;
      if (isPasteWithinCodeBlock && isBlockSelection(tr.selection)) {
        const contentStart = block.from + SESHAT_CONTENT_DEPTH + 1;
        const contentEnd = block.to - SESHAT_CONTENT_DEPTH - 1;
        tr.setSelection(TextSelection.create(tr.doc, contentStart, contentEnd));
      }
      if (isPasteWithinCodeBlock) {
        tr.insertText(content, tr.selection.from, tr.selection.to);
      }
      if (!isPasteWithinCodeBlock) {
        const lang = isSupportedCodeBlockLanguage(vscodeLang) ? vscodeLang : void 0;
        const attrs = { type: BlockTypes.CODE, language: lang };
        const code = createSeshatBlock({ schema, attrs, content });
        const contentEnd = block.to - SESHAT_CONTENT_DEPTH - 1 + code.nodeSize;
        tr.insert(block.to, code);
        tr.setSelection(TextSelection.near(tr.doc.resolve(contentEnd)));
      }
      tr.scrollIntoView();
      dispatch(tr);
      return true;
    }
  }
});
const isSliceWithSingleCodeBlock = (slice) => {
  var _a2;
  return slice.content.childCount === 1 && ((_a2 = slice.content.firstChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.CODE;
};
const CodeBlock = Extension$1.create({
  name: BlockTypes.CODE,
  priority: 500,
  addProseMirrorPlugins() {
    return [CodeBlockHighlightPlugin, CodeBlockPastePlugin];
  }
});
const wrapNodeViewContentIntoBlock = ({
  node,
  schema,
  indentedNodes,
  blockAttrs
}) => {
  var _a2, _b2;
  const seshatNodeViewContent = (_a2 = schema.nodes[SeshatNodes.CONTENT_NODE_VIEW]) == null ? void 0 : _a2.create({}, [node]);
  const seshatBlockContent = schema.nodes[SeshatNodes.BLOCK_CONTENT].create(
    {},
    [seshatNodeViewContent]
  );
  return (_b2 = schema.nodes[SeshatNodes.BLOCK]) == null ? void 0 : _b2.create(
    { ...{ type: BlockTypes.NODE_VIEW }, ...blockAttrs || {} },
    [seshatBlockContent, ...indentedNodes || []]
  );
};
const insertNodeViewContent = ({
  node,
  indentedNodes,
  blockAttrs,
  at
}) => ({ tr, dispatch, state }) => {
  dispatch == null ? void 0 : dispatch(
    insertNodeViewContentTransaction({
      state,
      tr,
      node,
      indentedNodes,
      blockAttrs,
      at
    })
  );
  return true;
};
const insertNodeViewContentTransaction = ({
  state,
  tr,
  node,
  indentedNodes,
  blockAttrs,
  at
}) => {
  const newTr = tr != null ? tr : state.tr;
  const { selection } = newTr;
  const { schema } = state;
  const { $from } = selection;
  const block = getCurrentBlock(newTr.doc, $from.pos);
  if (!block)
    return newTr;
  let insertAt = at != null ? at : block.to;
  if (isSeshatBlockEmpty(block.node) && !at) {
    newTr.delete(block.from, block.to);
    insertAt = block.from;
  }
  const seshatBlock = wrapNodeViewContentIntoBlock({
    node,
    schema,
    indentedNodes,
    blockAttrs
  });
  newTr.insert(insertAt, [seshatBlock, createSeshatBlock({ schema })]);
  return setCaretNearbyTransaction({
    state,
    tr: newTr,
    pos: insertAt + seshatBlock.nodeSize + SESHAT_CONTENT_DEPTH + 1
  });
};
const uploadAndInsertFile = ({
  view,
  editor,
  files,
  onUpload,
  previewType,
  insertPos
}) => {
  if (!files || !editor && !view)
    return;
  const setFile = editor ? (attrs) => editor.commands.setFile({ ...attrs }) : view ? (attrs) => {
    var _a2;
    const node = view.state.schema.nodes[NodeViewTypes.FILE].create(attrs);
    (_a2 = view.dispatch) == null ? void 0 : _a2.call(
      view,
      insertNodeViewContentTransaction({
        tr: view.state.tr,
        state: view.state,
        at: insertPos,
        node
      })
    );
  } : void 0;
  if (!setFile)
    return;
  Array.from(files).forEach((file) => {
    onUpload == null ? void 0 : onUpload({ file, previewType }).then((attrs) => {
      if (attrs)
        setFile(attrs);
    });
  });
};
const FileBlock = (options) => Node$1.create({
  name: NodeViewTypes.FILE,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: true,
  draggable: true,
  addAttributes() {
    return {
      fileUuid: {
        default: void 0,
        keepOnSplit: false
      },
      fileName: {
        default: void 0,
        keepOnSplit: false
      },
      fileSize: {
        default: void 0,
        keepOnSplit: false
      },
      fileType: {
        default: void 0,
        keepOnSplit: false
      },
      previewType: {
        default: PreviewFile.FILE,
        keepOnSplit: false
      }
    };
  },
  addOptions() {
    var _a2;
    return (_a2 = options == null ? void 0 : options.file) != null ? _a2 : {};
  },
  parseHTML() {
    return [
      {
        tag: "input",
        attrs: {
          type: "file"
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "input",
      {
        ...HTMLAttributes,
        fileUuid: void 0,
        fileName: void 0,
        fileType: void 0,
        fileSize: void 0,
        previewUrl: void 0,
        previewType: PreviewFile.FILE
      }
    ];
  },
  addCommands() {
    return {
      setFile: (options2) => ({ commands }) => {
        const node = this.type.create(options2);
        return commands.insertNodeViewContent({ node });
      },
      uploadAndInsertFile: ({ files }) => ({ editor }) => {
        var _a2;
        uploadAndInsertFile({
          editor,
          files,
          onUpload: (_a2 = this.options) == null ? void 0 : _a2.onUpload
        });
        return true;
      }
    };
  },
  addProseMirrorPlugins() {
    const { editor, options: options2 } = this;
    return [
      new Plugin({
        props: {
          handlePaste: function(_, e) {
            var _a2;
            e == null ? void 0 : e.preventDefault();
            const files = (_a2 = e == null ? void 0 : e.clipboardData) == null ? void 0 : _a2.files;
            uploadAndInsertFile({
              editor,
              files,
              onUpload: options2 == null ? void 0 : options2.onUpload
            });
            return false;
          }
        }
      })
    ];
  }
});
const IFrameBlock = Node$1.create({
  name: NodeViewTypes.IFRAME,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: true,
  addAttributes() {
    return {
      src: {
        default: null
      },
      srcDoc: {
        default: null
      },
      alt: {
        default: void 0
      },
      frameBorder: {
        default: 0
      },
      allowFullScreen: {
        default: true,
        parseHTML: () => {
          return {
            allowFullScreen: true
          };
        }
      },
      url: {
        parseHTML: (element) => {
          const url = element.getAttribute("url");
          return url ? urlMediaParser(url) : void 0;
        }
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "iframe"
      },
      {
        tag: "oembed"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", ["iframe", HTMLAttributes]];
  },
  addCommands() {
    return {
      setIframe: (options) => ({ commands }) => {
        const node = this.type.create(options);
        return commands.insertNodeViewContent({ node });
      }
    };
  }
});
const MAX_COLUMNS = 12;
const expandNarrowestColumn = ({
  tr,
  blockLinePos
}) => {
  const blockLine = tr.doc.nodeAt(blockLinePos);
  if (!blockLine)
    return;
  const narrowestColumn = getNarrowestColumn(blockLine);
  const leftoverWidth = getLeftoverWidth(blockLine);
  if (!narrowestColumn)
    return;
  return tr.setNodeMarkup(
    blockLinePos + narrowestColumn.offset + 1,
    void 0,
    {
      ...narrowestColumn.node.attrs,
      width: narrowestColumn.node.attrs.width + leftoverWidth
    }
  );
};
const getLeftoverWidth = (blockLine) => {
  let leftoverWidth = MAX_COLUMNS;
  blockLine.content.forEach((columnNode) => {
    const columnWidth = columnNode.attrs.width;
    leftoverWidth -= columnWidth;
  });
  return leftoverWidth;
};
const getNarrowestColumn = (blockLine) => {
  let narrowestColumn;
  blockLine.content.forEach((node, offset) => {
    if (!narrowestColumn || narrowestColumn.node.attrs.width > node.attrs.width) {
      narrowestColumn = { node, offset };
    }
  });
  return narrowestColumn;
};
const findBlockLines = (doc) => findChildren(doc, (node) => node.attrs.type === BlockTypes.BLOCK_LINE);
const maybeDeleteEmptyColumns = (tr) => {
  const blockLines = findBlockLines(tr.doc);
  const emptyColumns = getAllEmptyBlockColumns(blockLines);
  if (!emptyColumns.length)
    return;
  emptyColumns.forEach(({ node, pos }) => {
    var _a2, _b2;
    const width = node.attrs.width;
    tr.delete(pos, pos + node.nodeSize);
    if (width) {
      const blockLinePos = (_a2 = getParentBlockLine(tr.doc, pos)) == null ? void 0 : _a2.pos;
      if (!blockLinePos)
        return;
      tr = (_b2 = expandNarrowestColumn({ tr, blockLinePos })) != null ? _b2 : tr;
    }
  });
  return tr;
};
const getAllEmptyBlockColumns = (blockLines) => {
  const emptyColumns = [];
  blockLines.forEach(({ node, pos }) => {
    node.content.forEach((columnNode, columnOffset) => {
      if (columnNode.childCount === 0)
        emptyColumns.unshift({ node: columnNode, pos: pos + columnOffset + 1 });
    });
  });
  return emptyColumns;
};
const getParentBlockLine = (doc, pos) => {
  const $pos = doc.resolve(pos);
  const blockLine = findAncestor(
    $pos,
    (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.BLOCK_LINE
  );
  return blockLine ? { node: blockLine.node, pos: $pos.before(blockLine.depth) } : void 0;
};
const maybeUnwrapBlockLinesWithOneColumn = (tr) => {
  const blockLines = findBlockLines(tr.doc);
  const singleColumnBlockLines = getBlockLinesWithOneColumn(blockLines);
  if (!singleColumnBlockLines.length)
    return;
  singleColumnBlockLines.forEach(({ node, pos }) => {
    const $columnContentStart = tr.doc.resolve(pos + 2);
    const $columnContentEnd = tr.doc.resolve(pos + node.nodeSize - 2);
    const range = $columnContentStart.blockRange($columnContentEnd);
    if (range)
      tr.lift(range, tr.doc.resolve(pos).depth);
  });
  return tr;
};
const getBlockLinesWithOneColumn = (blockLines) => {
  return blockLines.filter(({ node }) => node.childCount === 1);
};
const getNearestSeshatBlockOfType = ({
  doc,
  pos,
  type
}) => {
  var _a2;
  for (let i = pos; i >= 0; i--) {
    let node = doc.nodeAt(i);
    if (((_a2 = node == null ? void 0 : node.attrs) == null ? void 0 : _a2.type) === type)
      return { node, pos: i };
  }
  return;
};
const containsChildCountChange = ({
  trs,
  oldState,
  newState
}) => {
  let changedBlockLine;
  const containsChange = trs.some(
    (tr) => tr.steps.some((step) => {
      if (!isReplaceStepWithinDoc(oldState, step))
        return false;
      const { from } = step;
      const oldBlockLine = getNearestSeshatBlockOfType({
        doc: oldState.doc,
        pos: getPosLimitedToDocSize({ state: oldState, from }),
        type: BlockTypes.BLOCK_LINE
      });
      const newBlockLine = getNearestSeshatBlockOfType({
        doc: newState.doc,
        pos: getPosLimitedToDocSize({ state: newState, from }),
        type: BlockTypes.BLOCK_LINE
      });
      const childCountChanged = (oldBlockLine == null ? void 0 : oldBlockLine.node.childCount) !== (newBlockLine == null ? void 0 : newBlockLine.node.childCount);
      if (!oldBlockLine || !newBlockLine || !childCountChanged)
        return false;
      const wasColumnInserted = oldBlockLine.node.childCount < newBlockLine.node.childCount;
      changedBlockLine = {
        ...newBlockLine,
        columnInsertedAtPos: wasColumnInserted ? from : void 0
      };
      return true;
    })
  );
  return { containsChange, changedBlockLine };
};
const isReplaceStepWithinDoc = (oldState, step) => {
  return step instanceof ReplaceStep && step.from < oldState.doc.nodeSize - SESHAT_CONTENT_DEPTH;
};
const DOC_MARGE_SIZE = 2;
const getPosLimitedToDocSize = ({
  state,
  from
}) => state.doc.nodeSize - 2 < from ? state.doc.nodeSize - DOC_MARGE_SIZE : from;
const shrinkWidestColumn = ({
  tr,
  blockLinePos
}) => {
  const blockLine = tr.doc.nodeAt(blockLinePos);
  if (!blockLine)
    return;
  const widestColumn = getWidestColumn(blockLine);
  const insertedColumn = getInsertedColumn(blockLine);
  if (!widestColumn || !insertedColumn)
    return;
  const insertedColumnWidth = Math.round(widestColumn.node.attrs.width / 2);
  return tr.setNodeMarkup(blockLinePos + insertedColumn.offset + 1, void 0, {
    ...insertedColumn.node.attrs,
    width: insertedColumnWidth
  }).setNodeMarkup(blockLinePos + widestColumn.offset + 1, void 0, {
    ...widestColumn.node.attrs,
    width: widestColumn.node.attrs.width - insertedColumnWidth
  });
};
const getWidestColumn = (blockLine) => {
  let widestColumn;
  blockLine.content.forEach((node, offset) => {
    if (!node.attrs.width)
      return;
    if (!widestColumn || widestColumn.node.attrs.width < node.attrs.width) {
      widestColumn = { node, offset };
    }
  });
  return widestColumn;
};
const getInsertedColumn = (blockLine) => {
  let insertedColumn;
  blockLine.content.forEach((node, offset) => {
    if (!node.attrs.width) {
      insertedColumn = { node, offset };
    }
  });
  return insertedColumn;
};
const maybeUpdateColumnWidths = (trs, oldState, state) => {
  const { containsChange, changedBlockLine } = containsChildCountChange({
    trs,
    oldState,
    newState: state
  });
  if (!containsChange || !changedBlockLine || !hasFixedWidthColumns(changedBlockLine.node))
    return;
  const { pos: blockLinePos, columnInsertedAtPos } = changedBlockLine;
  if (columnInsertedAtPos) {
    return shrinkWidestColumn({ tr: state.tr, blockLinePos });
  } else {
    return expandNarrowestColumn({ tr: state.tr, blockLinePos });
  }
};
const hasFixedWidthColumns = (blockLineNode) => {
  var _a2, _b2;
  return ((_a2 = blockLineNode == null ? void 0 : blockLineNode.firstChild) == null ? void 0 : _a2.attrs.width) || ((_b2 = blockLineNode.lastChild) == null ? void 0 : _b2.attrs.width);
};
const BlockLineObserverPluginKey = new PluginKey("blockLineObserverPlugin");
const blockLineObserverPlugin = new Plugin({
  key: BlockLineObserverPluginKey,
  appendTransaction(trs, oldState, state) {
    const blockLines = findBlockLines(state.doc);
    if (!blockLines.length)
      return;
    let tr = maybeUpdateColumnWidths(trs, oldState, state);
    const deleteColumnTr = maybeDeleteEmptyColumns(tr != null ? tr : state.tr);
    if (deleteColumnTr)
      tr = deleteColumnTr;
    const unwrapTr = maybeUnwrapBlockLinesWithOneColumn(tr != null ? tr : state.tr);
    if (unwrapTr)
      tr = unwrapTr;
    return tr;
  }
});
const BlockLineBlock = Extension$1.create({
  name: BlockTypes.BLOCK_LINE,
  addProseMirrorPlugins() {
    return [blockLineObserverPlugin];
  }
});
const resetCapture = (content) => ({
  tr,
  dispatch,
  editor,
  view
}) => {
  var _a2;
  const { schema } = editor;
  const captureBlock = (_a2 = editor.schema.nodes[SeshatNodes.WRAPPING_BLOCK]) == null ? void 0 : _a2.create(
    { type: BlockTypes.CAPTURE },
    content ? Node.fromJSON(schema, content) : createSeshatBlock({ schema })
  );
  tr.replaceWith(0, tr.doc.content.size, [captureBlock]);
  tr.setSelection(Selection.atEnd(tr.doc));
  dispatch == null ? void 0 : dispatch(tr);
  view.focus();
  return true;
};
const ValidAncestorNodeTypes = [
  SeshatNodes.BLOCK,
  SeshatNodes.WRAPPING_BLOCK,
  SeshatNodes.BLOCK_CONTENT,
  SeshatNodes.CONTENT
];
const isAtStartOfCapture = (state) => {
  const { selection, doc } = state;
  let pos = selection.$from.pos - 1;
  let node = doc.nodeAt(pos);
  while (node && ValidAncestorNodeTypes.includes(node.type.name)) {
    if ((node == null ? void 0 : node.attrs.type) === BlockTypes.CAPTURE)
      return true;
    pos--;
    node = doc.nodeAt(pos);
  }
  return false;
};
const CaptureBlock = (options) => Extension$1.create({
  name: "CaptureBlock",
  addCommands: () => ({
    resetCapture
  }),
  addKeyboardShortcuts() {
    return {
      ArrowUp: () => {
        var _a2;
        if (!isAtStartOfCapture(this.editor.state))
          return false;
        return !!((_a2 = options == null ? void 0 : options.capture) == null ? void 0 : _a2.arrowUpOnTopOfEditorCallback());
      }
    };
  }
});
const buildLauncherInputRules = (options) => {
  var _a2, _b2, _c2, _d2;
  return [
    {
      regexToMatch: /^#\s/,
      replaceIntoTitle: "#",
      callback: (_b2 = (_a2 = options == null ? void 0 : options.card) == null ? void 0 : _a2.turnCaptureIntoCallback) == null ? void 0 : _b2.turnIntoNote
    },
    {
      regexToMatch: /^\[\]/,
      replaceIntoTitle: "[",
      callback: (_d2 = (_c2 = options == null ? void 0 : options.card) == null ? void 0 : _c2.turnCaptureIntoCallback) == null ? void 0 : _d2.turnIntoTask
    }
  ].map((option) => markdownTurnInto(option));
};
const markdownTurnInto = ({
  callback,
  regexToMatch,
  replaceIntoTitle
}) => new InputRule({
  find: regexToMatch,
  handler: ({ state, commands }) => {
    if (!callback)
      return;
    const { tr, selection } = state;
    const { $from } = selection;
    if ($from.pos !== 5)
      return;
    const mainSeshatBlock = state.doc.resolve(1).parent;
    const content = $from.parent.textContent.replace(replaceIntoTitle, "");
    if (BlockTypes.CAPTURE === mainSeshatBlock.attrs.type) {
      if (!callback(content.length ? content : void 0))
        return;
      commands.command(({ dispatch }) => {
        tr.setMeta("undo", false);
        tr.deleteRange($from.start(), $from.end());
        dispatch == null ? void 0 : dispatch(tr);
        return true;
      });
    }
    return;
  }
});
const turnEditorIntoCard = (props) => ({
  tr,
  state,
  dispatch
}) => dispatch == null ? void 0 : dispatch(turnEditorIntoCardTransaction({ tr, state, ...props }));
const formatCard = ({
  tr,
  state,
  title,
  seshatBlock,
  cardType
}) => {
  const { schema } = state;
  const textContent = title ? [schema.text(title)] : void 0;
  const seshatContent = schema.nodes.seshatContent.create({}, textContent);
  const seshatBlockContent = state.schema.nodes[SeshatNodes.BLOCK_CONTENT].create({}, seshatContent);
  const cardContentBlock = state.schema.nodes[SeshatNodes.BLOCK].create(
    {
      ...seshatBlock.attrs,
      cardType,
      type: BlockTypes.CARD_CONTENT
    },
    [seshatBlockContent, ...seshatBlock.content.content]
  );
  tr.replaceWith(0, tr.doc.content.size, cardContentBlock);
  tr.setSelection(TextSelection.create(tr.doc, 3 + title.length));
  return tr;
};
const changeTitle = ({
  tr,
  state,
  title,
  firstChildBlock
}) => {
  const { schema } = state;
  const textContent = title ? [schema.text(title)] : void 0;
  const seshatContent = schema.nodes.seshatContent.create({}, textContent);
  const seshatBlockContent = state.schema.nodes[SeshatNodes.BLOCK_CONTENT].create({}, seshatContent);
  tr.replaceWith(1, 1 + firstChildBlock.nodeSize, seshatBlockContent);
  tr.setSelection(TextSelection.create(tr.doc, 3 + title.length));
  return tr;
};
const formatCapture = ({
  tr,
  state,
  seshatBlock
}) => {
  const captureBlock = state.schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    {
      ...seshatBlock.attrs,
      cardType: "capture",
      type: BlockTypes.CAPTURE
    },
    [...seshatBlock.content.content.slice(1)]
  );
  tr.replaceWith(0, tr.doc.content.size, captureBlock);
  tr.setSelection(TextSelection.create(tr.doc, 3));
  return tr;
};
const turnEditorIntoCardTransaction = ({
  title,
  cardType,
  tr,
  state
}) => {
  const seshatBlock = tr.doc.content.content[0];
  const firstSeshatBlockAttrs = seshatBlock.attrs;
  const isCapture = firstSeshatBlockAttrs.type === BlockTypes.CAPTURE;
  const firstChildBlock = seshatBlock.content.content[0];
  if (title && ["task", "note"].includes(cardType)) {
    if (isCapture && (firstChildBlock == null ? void 0 : firstChildBlock.type.name) !== SeshatNodes.BLOCK_CONTENT) {
      tr = formatCard({
        tr,
        state,
        title,
        seshatBlock,
        cardType
      });
    } else {
      tr = changeTitle({ tr, state, title, firstChildBlock });
      tr.setNodeMarkup(0, state.schema.nodes[SeshatNodes.BLOCK], {
        ...firstSeshatBlockAttrs,
        cardType,
        type: BlockTypes.CARD_CONTENT
      });
    }
  }
  if (!isCapture && cardType === "capture") {
    tr = formatCapture({ tr, state, seshatBlock });
  }
  return tr;
};
const insertBlockIfCardContentIsEmpty = (state) => {
  const { tr } = state;
  const seshatBlockCard = tr.doc.content.content[0];
  const isSeshatBlockInsideCardContent = seshatBlockCard.content.content.find(
    (b) => b.type.spec.group === SeshatNodeGroups.BLOCK
  );
  if (!isSeshatBlockInsideCardContent) {
    const seshatBlockNew = createSeshatBlock({
      schema: state.schema,
      attrs: { type: BlockTypes.PARAGRAPH }
    });
    tr.insert(seshatBlockCard.nodeSize - SESHAT_ROOT_DEPTH, seshatBlockNew);
  }
  return tr;
};
const CardBlock = (options) => Extension$1.create({
  name: BlockTypes.CARD_CONTENT,
  priority: 1e3,
  addCommands: () => ({
    turnEditorIntoCard
  }),
  addInputRules() {
    return (options == null ? void 0 : options.extensionVersion) === "launcher" ? buildLauncherInputRules(options) : [];
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("CardContentValidation"),
        appendTransaction: (_trs, _oldState, newState) => {
          return insertBlockIfCardContentIsEmpty(newState);
        }
      })
    ];
  }
});
const getCardTitleContentFromSeshatBlockCard = (seshatNode) => {
  var _a2, _b2, _c2, _d2;
  if (((_a2 = seshatNode.attrs) == null ? void 0 : _a2.type) !== BlockTypes.CARD_CONTENT) {
    return void 0;
  }
  return (_d2 = (_c2 = (_b2 = seshatNode.content) == null ? void 0 : _b2[0]) == null ? void 0 : _c2.content) == null ? void 0 : _d2[0];
};
const getCardContentFromSeshatBlockCard = (seshatNode) => {
  var _a2, _b2;
  if (((_a2 = seshatNode.content) == null ? void 0 : _a2[0].type) === SeshatNodes.BLOCK)
    return seshatNode.content;
  return (_b2 = seshatNode.content) == null ? void 0 : _b2.slice(1);
};
const isContentNotEmpty = (content) => {
  var _a2;
  return !!(content.content && content.content.length >= 1 && ((_a2 = content.content) == null ? void 0 : _a2.some((c2) => c2.text || isContentNotEmpty(c2))));
};
const maybeFormatNode = (node) => {
  if (node.type !== SeshatNodes.BLOCK && node.type === SeshatNodes.BLOCK_CONTENT) {
    return {
      type: SeshatNodes.BLOCK,
      attrs: {
        type: BlockTypes.HEADING_1
      },
      content: [node]
    };
  }
  return node;
};
const removeCardFromAppendContent = (content) => {
  return content.flatMap((node) => {
    if (isRootBlockJSON(node)) {
      return removeCardFromAppendContent(node.content || []);
    }
    return maybeFormatNode(node);
  });
};
const appendContentInACardContent = ({
  seshatNode,
  newSeshatBlockContent
}) => {
  const cardContent = seshatNode.content;
  if (!cardContent)
    return seshatNode;
  const _isCardContentEmpty = !isContentNotEmpty(seshatNode);
  const previousContent = _isCardContentEmpty ? [] : cardContent;
  return {
    ...seshatNode,
    content: [
      ...previousContent,
      ...removeCardFromAppendContent(newSeshatBlockContent)
    ]
  };
};
const createShellCardContent = ({
  attrs,
  schema
}) => {
  var _a2;
  return (_a2 = schema.nodes[SeshatNodes.BLOCK]) == null ? void 0 : _a2.create(
    {
      type: BlockTypes.CARD_CONTENT,
      ...attrs
    },
    []
  );
};
const seshatBlockNodeViewInputRule = ({
  regexp,
  type
}) => {
  return new InputRule({
    find: regexp,
    handler: ({ chain, range }) => {
      const node = type.create();
      chain().deleteRange(range).insertNodeViewContent({ node }).run();
    }
  });
};
const HorizontalRuleBlock = Node$1.create({
  name: NodeViewTypes.HORIZONTAL_RULE,
  addOptions() {
    return {
      class: "horizontal_rule"
    };
  },
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: true,
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(this.options, HTMLAttributes), ["div"]];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ commands }) => {
        const node = this.type.create();
        return commands.insertNodeViewContent({ node });
      }
    };
  },
  addInputRules() {
    return [
      seshatBlockNodeViewInputRule({
        regexp: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
});
function minMax(value = 0, min = 0, max = 0) {
  return Math.min(Math.max(value, min), max);
}
const insertClipBook = ({
  attrs,
  at
}) => ({ state: { schema }, dispatch, tr }) => dispatch == null ? void 0 : dispatch(insertClipBookTransaction({ schema, tr, at, attrs }));
const insertClipBookTransaction = ({
  schema,
  tr,
  at,
  attrs
}) => {
  const insertPos = at ? minMax(at, 0, tr.doc.content.size) : BlockSelection.createFromPosition(tr.doc, tr.selection.$from.pos).to;
  const node = schema.nodes[NodeViewTypes.CLIP_BOOK].create(attrs);
  const seshatBlock = wrapNodeViewContentIntoBlock({
    node,
    schema,
    blockAttrs: { nodeViewType: NodeViewTypes.CLIP_BOOK }
  });
  tr = tr.insert(insertPos, seshatBlock);
  tr.setSelection(BlockSelection.createFromPosition(tr.doc, insertPos));
  return tr;
};
const getAsinUrl = (asin) => `https://read.amazon.com/?asin=${asin}&language=en-US`;
const handleEnterOnSelectedClipBook = ({
  editor
}) => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  const node = (_b2 = (_a2 = editor.state) == null ? void 0 : _a2.selection) == null ? void 0 : _b2.$from.nodeAfter;
  if (!node || node.attrs.nodeViewType !== NodeViewTypes.CLIP_BOOK)
    return false;
  const { asin } = ((_f2 = (_e2 = (_d2 = (_c2 = node.content.content) == null ? void 0 : _c2[0].content.content) == null ? void 0 : _d2[0].content.content) == null ? void 0 : _e2[0]) == null ? void 0 : _f2.attrs) || {};
  if (!asin)
    return false;
  const url = getAsinUrl(asin);
  if (typeof window !== "undefined")
    window.open(url, "_blank");
  return true;
};
const ClipBookBlock = (options) => Node$1.create({
  name: NodeViewTypes.CLIP_BOOK,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: false,
  addOptions() {
    return options == null ? void 0 : options.clip;
  },
  addAttributes() {
    return {
      asin: {
        default: void 0,
        keepOnSplit: true
      },
      title: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      coverUrl: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      author: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      kindleHighlights: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      status: {
        default: void 0,
        keepOnSplit: true
      }
    };
  },
  addCommands() {
    return {
      insertClipBook
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes), ["div"]];
  },
  addKeyboardShortcuts() {
    return {
      Enter: handleEnterOnSelectedClipBook
    };
  }
});
const insertClipBookmark = ({
  attrs,
  nodeViewAttrs,
  at
}) => ({
  state: { schema },
  dispatch,
  tr
}) => dispatch == null ? void 0 : dispatch(
  insertClipBookmarkTransaction({ schema, tr, at, attrs, nodeViewAttrs })
);
const insertClipBookmarkTransaction = ({
  schema,
  tr,
  at,
  nodeViewAttrs,
  attrs
}) => {
  const insertPos = at ? minMax(at, 0, tr.doc.content.size) : BlockSelection.createFromPosition(tr.doc, tr.selection.$from.pos).to;
  const node = schema.nodes[NodeViewTypes.CLIP_BOOKMARK].create(nodeViewAttrs);
  const seshatBlock = wrapNodeViewContentIntoBlock({
    node,
    schema,
    blockAttrs: { ...attrs, nodeViewType: NodeViewTypes.CLIP_BOOKMARK }
  });
  tr = tr.insert(insertPos, seshatBlock);
  tr.setSelection(BlockSelection.createFromPosition(tr.doc, insertPos));
  return tr;
};
const replaceClipBookmarkByClipContent = () => ({
  editor,
  tr,
  chain
}) => {
  const { doc } = tr;
  const result = retrieveClipBookmarkAndHref(doc);
  if (!result)
    return false;
  const {
    node: clipBookmarkNode,
    pos: clipBookmarkPos,
    href,
    hrefBackup,
    title,
    highlights
  } = result;
  tr.setMeta(ANALYTICS_META, "Clip content from Clip Bookmark");
  return chain().insertContentAt(
    {
      from: clipBookmarkPos,
      to: clipBookmarkPos + clipBookmarkNode.nodeSize
    },
    {
      type: SeshatNodes.WRAPPING_BLOCK,
      content: getSeshatContentFromHtml({
        content: "",
        schema: editor.schema
      }),
      attrs: {
        [BlockAttrsParams.BLOCK_UUID]: generateBlockId(editor),
        ...clipBookmarkNode.attrs,
        type: BlockTypes.CLIP_CONTENT,
        nodeViewType: void 0,
        href,
        hrefBackup,
        title,
        highlights
      }
    }
  ).run();
};
const retrieveClipBookmarkAndHref = (doc) => {
  var _a2, _b2;
  const clipBookmarkNode = (_a2 = findChildren(
    doc,
    (node2) => (node2 == null ? void 0 : node2.attrs.nodeViewType) === NodeViewTypes.CLIP_BOOKMARK
  )) == null ? void 0 : _a2[0];
  if (!clipBookmarkNode)
    return;
  const { node, pos } = clipBookmarkNode;
  const { href, hrefBackup, title, highlights } = (_b2 = findChildren(
    node,
    (node2) => node2.type.name === NodeViewTypes.CLIP_BOOKMARK
  )) == null ? void 0 : _b2[0].node.attrs;
  return {
    node,
    pos,
    href,
    hrefBackup,
    title,
    highlights
  };
};
const ClipBookmarkBlock = Node$1.create({
  name: NodeViewTypes.CLIP_BOOKMARK,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: false,
  addAttributes() {
    return {
      title: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      favicon: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      href: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      hrefBackup: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      highlights: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      hasError: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      video: {
        default: void 0,
        keepOnSplit: true
      }
    };
  },
  addCommands() {
    return {
      insertClipBookmark,
      replaceClipBookmarkByClipContent
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes), ["div"]];
  }
});
const onEnterOnTaskEditable = () => ({
  tr,
  chain,
  state,
  commands
}) => {
  const { selection } = tr;
  const { $from } = selection;
  const block = getCurrentBlock(tr.doc, $from.pos);
  if (!block)
    return false;
  if (isBlockSelection(state.selection))
    return false;
  if (block.node.attrs.type !== BlockTypes.TASK_EDITABLE)
    return false;
  const nodeIsEmpty = $from.node().textContent.length < 1;
  if (nodeIsEmpty)
    return commands.resetBlock();
  return chain().insertCardLink({
    cardType: "task",
    value: block.node.textContent,
    blockId: block.node.attrs[BlockAttrsParams.BLOCK_UUID]
  }).focus(block.to + SESHAT_CONTENT_DEPTH + 1).deleteBlock().insertBlock({ type: BlockTypes.TASK_EDITABLE }).unsetBlockSelection().run();
};
const onEscapeOrSelectPrevNextOnTaskEditable = (onCompletionReturn = true) => ({ tr, commands }) => {
  const { selection } = tr;
  const { $from } = selection;
  const block = getCurrentBlock(tr.doc, $from.pos);
  if ((block == null ? void 0 : block.node.attrs.type) !== BlockTypes.TASK_EDITABLE) {
    return false;
  }
  const nodeIsEmpty = $from.node().textContent.length < 1;
  if (nodeIsEmpty) {
    return commands.resetBlock();
  }
  commands.insertCardLink({
    cardType: "task",
    value: block.node.textContent,
    blockId: block.node.attrs[BlockAttrsParams.BLOCK_UUID]
  });
  return onCompletionReturn;
};
const turnInTaskUndoneInputRule = () => new InputRule({
  find: /^\[\]/,
  handler: ({ match, chain }) => {
    chain().command(({ tr, dispatch }) => {
      tr.deleteRange(
        tr.selection.from - match[0].length + 1,
        tr.selection.from
      );
      dispatch == null ? void 0 : dispatch(tr);
      return true;
    }).updateBlockAttributes({ type: BlockTypes.TASK_EDITABLE }).run();
  }
});
const getTaskEditableBlocksFromDoc = (doc) => {
  return findChildren(doc, isHighlightsBlockNode$1).map(
    (node) => NodeSelection.create(doc, node.pos)
  );
};
const isHighlightsBlockNode$1 = (node) => node.attrs.type === BlockTypes.TASK_EDITABLE;
function turnTaskEditableIntoCardLink(taskEditableNode, state) {
  const { tr } = state;
  const blockId = taskEditableNode.node.attrs[BlockAttrsParams.BLOCK_UUID];
  const cardLinkNode = getCardLinkNode({
    schema: state.schema,
    blockId,
    text: taskEditableNode.node.textContent
  });
  tr.delete(taskEditableNode.$from.pos, taskEditableNode.$to.pos);
  tr.insert(taskEditableNode.$from.pos, cardLinkNode);
  return tr;
}
function getCardLinkNode({
  schema,
  blockId,
  text
}) {
  const textContent = text ? [schema.text(text)] : void 0;
  const cardLink = schema.nodes[NodeViewTypes.CARD_LINK].create(
    {
      cardType: "task",
      value: text
    },
    textContent
  );
  return wrapNodeViewContentIntoBlock({
    node: cardLink,
    schema,
    blockAttrs: {
      type: BlockTypes.CARD_LINK,
      [BlockAttrsParams.BLOCK_UUID]: blockId,
      value: text
    }
  });
}
const taskEditableFocusObserverPluginKey = new PluginKey(
  "taskEditableFocusObserverPluginKey"
);
const taskEditableSelectionObserverPlugin = new Plugin({
  key: taskEditableFocusObserverPluginKey,
  appendTransaction(_trs, _, state) {
    var _a2;
    const { tr } = state;
    const $taskEditableBlocks = getTaskEditableBlocksFromDoc(state.doc);
    const selectionBlock = getCurrentBlock(state.doc, tr.selection.from);
    const selectionBlockId = selectionBlock == null ? void 0 : selectionBlock.node.attrs[BlockAttrsParams.BLOCK_UUID];
    for (const taskEditableBlock of $taskEditableBlocks) {
      const taskEditableId = (_a2 = taskEditableBlock.node) == null ? void 0 : _a2.attrs[BlockAttrsParams.BLOCK_UUID];
      if (taskEditableId !== selectionBlockId) {
        return !!taskEditableBlock.node.textContent ? turnTaskEditableIntoCardLink(taskEditableBlock, state) : tr.delete(taskEditableBlock.$from.pos, taskEditableBlock.$to.pos);
      }
    }
    return;
  }
});
const TaskEditableBlock = Extension$1.create({
  name: BlockTypes.TASK_EDITABLE,
  addCommands() {
    return {
      onEnterOnTaskEditable,
      onEscapeOrSelectPrevNextOnTaskEditable
    };
  },
  addInputRules() {
    return [turnInTaskUndoneInputRule()];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.onEnterOnTaskEditable()
        ]);
      },
      [shortcutConfig.selectNextBlock]: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.onEscapeOrSelectPrevNextOnTaskEditable(false)
        ]);
      },
      [shortcutConfig.selectPrevBlock]: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.onEscapeOrSelectPrevNextOnTaskEditable(false)
        ]);
      }
    };
  },
  addProseMirrorPlugins() {
    return [taskEditableSelectionObserverPlugin];
  }
});
const ToggleBlock = Extension$1.create({
  name: BlockTypes.TOGGLE_LIST,
  addInputRules() {
    return [
      new InputRule({
        find: /^(>\s)$/,
        handler: ({ state, match, chain }) => {
          const {
            selection: { $from }
          } = state;
          chain().deleteRange({
            from: $from.pos - match[0].length + 1,
            to: $from.pos
          }).updateBlockAttributes({
            type: BlockTypes.TOGGLE_LIST,
            collapsed: false
          });
        }
      })
    ];
  }
});
const TableOfContentsBlock = Node$1.create({
  name: NodeViewTypes.TABLE_OF_CONTENTS,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: true,
  addOptions() {
    return {
      class: "table_of_contents"
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(this.options, HTMLAttributes), ["div"]];
  },
  addCommands() {
    return {
      setTableOfContents: () => ({ commands }) => {
        const node = this.type.create();
        return commands.insertNodeViewContent({ node });
      }
    };
  }
});
const getBlocksOfType = ({
  content,
  includeInType
}) => {
  return (content == null ? void 0 : content.reduce((result, node) => {
    var _a2;
    if (node.attrs && node.attrs["type"] && ((_a2 = node.attrs) == null ? void 0 : _a2.type.includes(includeInType))) {
      return [...result, node];
    }
    if (!node.content)
      return result;
    return [
      ...result,
      ...getBlocksOfType({
        content: node.content.content,
        includeInType
      })
    ];
  }, [])) || [];
};
const HEADING_QUERY = "heading";
const getHeadingForTableOfContents = ({
  editor
}) => {
  const editorNodeContent = editor.view.state.doc.content;
  const firstNodeContent = editorNodeContent.content;
  const headingNodes = getBlocksOfType({
    content: firstNodeContent,
    includeInType: HEADING_QUERY
  });
  return headingNodes.map((node) => {
    const jsonNode = node.toJSON();
    return {
      ...jsonNode,
      text: node.textContent
    };
  });
};
const insertCardLink = (props) => ({
  tr,
  chain,
  state
}) => {
  var _a2, _b2, _c2, _d2, _e2;
  const { selection } = tr;
  const { $from } = selection;
  const node = $from.node();
  const pos = $from.start();
  const block = getCurrentBlock(tr.doc, $from.pos);
  if (!block || !(node == null ? void 0 : node.textContent))
    return true;
  const NestedCardLink = state.schema.nodes[NodeViewTypes.CARD_LINK].create(
    {
      ...props,
      cardType: (_a2 = props.cardType) != null ? _a2 : "note",
      value: (_b2 = props.value) != null ? _b2 : block.node.textContent.trim(),
      [BlockAttrsParams.BLOCK_UUID]: (_c2 = props.blockId) != null ? _c2 : block.node.attrs[BlockAttrsParams.BLOCK_UUID]
    },
    node.content
  );
  const runningChain = chain().insertNodeViewContent({
    node: NestedCardLink,
    blockAttrs: {
      value: (_d2 = props.value) != null ? _d2 : block.node.textContent.trim(),
      type: BlockTypes.CARD_LINK,
      [BlockAttrsParams.BLOCK_UUID]: (_e2 = props.blockId) != null ? _e2 : block.node.attrs[BlockAttrsParams.BLOCK_UUID]
    }
  }).focus(pos).deleteBlock();
  if (props.cardType === "task")
    runningChain.setNodeSelection(pos);
  if (props.cardType === "note")
    runningChain.focus(pos + 2);
  return runningChain.run();
};
const onEnterOnTaskNestedCardLink = () => ({
  chain,
  state
}) => {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
  if (!isBlockSelection(state.selection) || state.selection.list().length !== 1) {
    return false;
  }
  const firstBlock = state.selection.firstBlock();
  const { node, to, from } = firstBlock;
  const cardLinkBlock = (_e2 = (_d2 = (_c2 = (_b2 = (_a2 = node == null ? void 0 : node.content.content) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.content.content) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.content.content) == null ? void 0 : _e2[0];
  const cardLinkType = (_f2 = cardLinkBlock == null ? void 0 : cardLinkBlock.attrs) == null ? void 0 : _f2.cardType;
  const cardLinkText = (_g2 = cardLinkBlock == null ? void 0 : cardLinkBlock.content.content[0]) == null ? void 0 : _g2.text;
  if ((node == null ? void 0 : node.attrs.type) !== BlockTypes.CARD_LINK) {
    return false;
  }
  if (cardLinkType !== "task" || !cardLinkText)
    return false;
  chain().deleteRange({
    from,
    to
  }).insertContentAt(from, {
    type: SeshatNodes.BLOCK,
    content: [
      {
        type: SeshatNodes.BLOCK_CONTENT,
        content: [
          {
            type: SeshatNodes.CONTENT
          }
        ]
      }
    ],
    attrs: {
      type: BlockTypes.TASK_EDITABLE,
      [BlockAttrsParams.BLOCK_UUID]: node.attrs[BlockAttrsParams.BLOCK_UUID]
    }
  }).focus(from + 3).insertContent(cardLinkText).setTextSelection(
    TextSelection.create(
      state.doc,
      from + SESHAT_CONTENT_DEPTH + 1,
      from + SESHAT_CONTENT_DEPTH + 1 + cardLinkText.length
    )
  ).run();
  return true;
};
const openSelectedCard = () => ({ state, dispatch }) => {
  if (!isBlockSelection(state.selection))
    return false;
  if (state.selection.list().length > 1)
    return false;
  const { node, from } = state.selection.firstBlock();
  const blockId = node.attrs[BlockAttrsParams.BLOCK_UUID];
  if (node.attrs.type !== BlockTypes.CARD_LINK || !blockId)
    return false;
  const cardLinkView = document.querySelector(`[data-card-link="${blockId}"`);
  if (!cardLinkView)
    return false;
  dispatch == null ? void 0 : dispatch(setCaretNearbyTransaction({ state, tr: state.tr, pos: from }));
  setTimeout(() => {
    var _a2;
    return (_a2 = cardLinkView.click) == null ? void 0 : _a2.call(cardLinkView);
  });
  return true;
};
const CardLinkBlock = Node$1.create({
  name: NodeViewTypes.CARD_LINK,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  draggable: true,
  content: "inline*",
  addAttributes() {
    return {
      cardType: {
        default: "note"
      },
      value: {
        default: void 0
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "card_link_component"
      }
    ];
  },
  addCommands() {
    return {
      insertCardLink,
      openSelectedCard,
      onEnterOnTaskNestedCardLink
    };
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.onEnterOnTaskNestedCardLink()
        ]);
      },
      "Mod-Enter": () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.openSelectedCard()
        ]);
      },
      Space: () => {
        return this.editor.commands.first(({ commands }) => [
          () => commands.openSelectedCard()
        ]);
      }
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["card_link_component", mergeAttributes(HTMLAttributes)];
  }
});
const createCardLink = ({
  attrs,
  schema
}) => {
  var _a2, _b2, _c2, _d2;
  const cardLink = (_a2 = schema.nodes[NodeViewTypes.CARD_LINK]) == null ? void 0 : _a2.create();
  const seshatNodeViewContent = (_b2 = schema.nodes[SeshatNodes.CONTENT_NODE_VIEW]) == null ? void 0 : _b2.create({}, cardLink);
  const seshatBlockContent = (_c2 = schema.nodes[SeshatNodes.BLOCK_CONTENT]) == null ? void 0 : _c2.create(
    {},
    seshatNodeViewContent
  );
  return (_d2 = schema.nodes[SeshatNodes.BLOCK]) == null ? void 0 : _d2.create(
    { type: BlockTypes.CARD_LINK, ...attrs },
    seshatBlockContent
  );
};
const isDropTargetValid = (target, $initialBlock) => {
  const { $block, isOutsideEditor } = target;
  if ($block.from === 0)
    return false;
  if (isSameBlock($initialBlock, $block))
    return false;
  if (isHighlightsBlockDragged($initialBlock) && isClipContentTarget($block))
    return false;
  if (isClipDragged($initialBlock) && isClipContentTarget($block))
    return false;
  if (isContentEditableFalseTarget($block))
    return false;
  if (isHighlightsBlock$3($block))
    return false;
  if (isCardLinkDragged($initialBlock) && !isAtRootDepth($block))
    return false;
  if ((isCardLinkDragged($initialBlock) || isCardLinkTarget($block)) && isOutsideEditor)
    return false;
  return !isBlockLineWithMaxColumnCount($block);
};
const getInitialBlock = (view, content) => {
  var _a2, _b2;
  if (!content)
    return (_a2 = view.dragging) == null ? void 0 : _a2.block;
  const blockId = (_b2 = content.firstChild) == null ? void 0 : _b2.attrs[BlockAttrsParams.BLOCK_UUID];
  const block = getSeshatBlockByBlockId(view.state.doc, blockId);
  if (!block)
    return void 0;
  return BlockSelection.createFromPosition(
    view.state.doc,
    block.pos
  ).firstBlock();
};
const isBlockLineWithMaxColumnCount = ($block) => {
  const blockLine = findAncestor(
    $block.$from,
    (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.BLOCK_LINE
  );
  return blockLine && blockLine.node.childCount >= MAX_COLUMNS;
};
const isHighlightsBlock$3 = ($block) => {
  return !!findAncestor(
    $block.$from,
    (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHTS
  );
};
const isHighlightsBlockDragged = ($block) => {
  return ($block == null ? void 0 : $block.node.attrs.type) === BlockTypes.HIGHLIGHTS;
};
const isClipDragged = ($block) => {
  var _a2;
  const nodeType = (_a2 = $block == null ? void 0 : $block.node.attrs.nodeViewType) != null ? _a2 : $block == null ? void 0 : $block.node.attrs.type;
  return !!nodeType && clipBlocks.includes(nodeType);
};
const isClipContent$1 = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.CLIP_CONTENT;
const isClipContentTarget = ($block) => {
  return !!findAncestor($block.$from, isClipContent$1);
};
const isCardLinkDragged = ($block) => {
  return ($block == null ? void 0 : $block.node.attrs.type) === BlockTypes.CARD_LINK;
};
const isCardLinkTarget = ($block) => $block.node.attrs.type === BlockTypes.CARD_LINK;
const isAtRootDepth = ($block) => $block.$from.depth === 1;
const isSameBlock = (b1, b2) => b1 && b2 && b1.from <= b2.from && b2.to <= b1.to;
const isContentEditableFalseTarget = ($block) => !!findAncestor($block.$from, (node) => isContentEditableFalse(node));
const findDropPosition = (view, event, content) => {
  const target = findBlockAtMousePosition(view, event);
  const $initialBlock = getInitialBlock(view, content);
  if (!target || !isDropTargetValid(target, $initialBlock))
    return null;
  const { $block } = target;
  if (isCardLinkTarget($block) || isCardLinkDragged($initialBlock))
    return insertAsBlockBefore($block);
  if (isLeftColumnInsert(target))
    return insertAsColumn$1($block, "left");
  if (isRightColumnInsert(target))
    return insertAsColumn$1($block, "right");
  if (isWrappingBlock($block)) {
    if (isContentEditableFalse($block.node) || $block.node.attrs.type === BlockTypes.HIGHLIGHTS || $block.node.attrs.type === BlockTypes.BLOCK_LINE)
      return insertAsBlockBefore($block);
    else
      return insertAsNestedBlock($block);
  }
  if (isInFirstHalfOfBlock(view, target))
    return insertAsBlockBefore($block);
  return isIndentedInsert(view, target) && !isContentEditableFalse($block.node) ? insertAsIndentedBlock($block) : insertAsBlockAfter($block);
};
const isLeftColumnInsert = (target) => {
  const isBlockColumn2 = target.$block.node.attrs.type === BlockTypes.BLOCK_COLUMN;
  return isBlockColumn2 || target.isOutsideEditor === "left";
};
const isRightColumnInsert = (target) => {
  return target.isOutsideEditor === "right";
};
const isInFirstHalfOfBlock = (view, target) => {
  var _a2;
  const blockDOM = view.nodeDOM(target.$block.from);
  const blockRect = (_a2 = blockDOM == null ? void 0 : blockDOM.getBoundingClientRect) == null ? void 0 : _a2.call(blockDOM);
  const blockHeight = blockRect.bottom - blockRect.top;
  return blockRect && target.clientY < blockRect.top + blockHeight / 2;
};
const isIndentedInsert = (view, target) => {
  var _a2;
  const blockDOM = view.nodeDOM(target.$block.from);
  const blockRect = (_a2 = blockDOM == null ? void 0 : blockDOM.getBoundingClientRect) == null ? void 0 : _a2.call(blockDOM);
  return blockRect ? blockRect.left + INDENTATION_PADDING < target.clientX : false;
};
const isWrappingBlock = ($block) => getNodeTypeByBlockType($block.node.attrs.type) === SeshatNodes.WRAPPING_BLOCK;
class DropCursor {
  constructor(view) {
    this.view = view;
    this.dropPos = null;
    this.element = null;
    this.handlers = [
      "dragover",
      "dragend",
      "drop",
      "dragleave"
    ].map((name) => {
      const handler = (e) => this[name](e);
      view.dom.addEventListener(name, handler);
      return { name, handler };
    });
  }
  destroy() {
    this.handlers.forEach(
      ({ name, handler }) => this.view.dom.removeEventListener(name, handler)
    );
  }
  setDropPos(pos) {
    var _a2;
    this.dropPos = pos;
    if (pos === null && ((_a2 = this.element) == null ? void 0 : _a2.parentNode)) {
      this.element.parentNode.removeChild(this.element);
      this.element = null;
    } else {
      this.updateDropCursor();
    }
  }
  hasDropPosChanged(newPos) {
    var _a2, _b2, _c2;
    return (newPos == null ? void 0 : newPos.column) !== ((_a2 = this.dropPos) == null ? void 0 : _a2.column) || (newPos == null ? void 0 : newPos.indented) !== ((_b2 = this.dropPos) == null ? void 0 : _b2.indented) || (newPos == null ? void 0 : newPos.pos) !== ((_c2 = this.dropPos) == null ? void 0 : _c2.pos);
  }
  getVerticalOverlay(dropPos) {
    var _a2;
    const { pos, column } = dropPos;
    const blockDOM = this.view.nodeDOM(pos);
    if (!(blockDOM instanceof HTMLElement))
      return;
    const blockRect = (_a2 = blockDOM.getBoundingClientRect) == null ? void 0 : _a2.call(blockDOM);
    const x = column === "left" ? blockRect.left : blockRect.right;
    return {
      left: x - 1,
      right: x + 1,
      top: blockRect.top,
      bottom: blockRect.bottom
    };
  }
  getHorizontalOverlay(dropPos) {
    var _a2;
    const { doc } = this.view.state;
    let { pos, indented } = dropPos;
    const isInsertAtEnd = !doc.nodeAt(pos);
    if (isInsertAtEnd) {
      const $block = getCurrentBlock(doc, pos);
      if (!$block)
        return;
      pos = $block.from;
    }
    const blockDOM = this.view.nodeDOM(pos);
    if (!(blockDOM instanceof HTMLElement))
      return;
    const blockRect = (_a2 = blockDOM.getBoundingClientRect) == null ? void 0 : _a2.call(blockDOM);
    const style = window.getComputedStyle(blockDOM);
    let paddingLeft = parseInt(style.paddingLeft, 10);
    if (blockDOM.getAttribute("type") === BlockTypes.CLIP_CONTENT)
      paddingLeft = 0;
    const y = isInsertAtEnd ? blockRect.bottom : blockRect.top;
    const left = indented ? blockRect.left + paddingLeft + INDENTATION_PADDING : blockRect.left + paddingLeft;
    return {
      right: blockRect.right,
      left,
      top: y - 1,
      bottom: y + 1
    };
  }
  getOverlayCoords(dropPos) {
    return dropPos.column ? this.getVerticalOverlay(dropPos) : this.getHorizontalOverlay(dropPos);
  }
  updateDropCursor() {
    if (this.dropPos) {
      const overlayRect = this.getOverlayCoords(this.dropPos);
      const domParent = this.view.dom.offsetParent;
      if (!this.element && domParent) {
        const div = document.createElement("div");
        this.element = domParent.appendChild(div);
        this.element.classList.add(SeshatCssClass.DROPCURSOR);
      }
      const domParentIsStaticBody = domParent === document.body && window.getComputedStyle(domParent).position === "static";
      let parentLeft, parentTop;
      if (!domParent || domParentIsStaticBody) {
        parentLeft = -window.pageXOffset;
        parentTop = -window.pageYOffset;
      } else {
        const rect = domParent.getBoundingClientRect();
        parentLeft = rect.left - domParent.scrollLeft;
        parentTop = rect.top - domParent.scrollTop;
      }
      if (this.element && overlayRect) {
        this.element.style.top = `${overlayRect.top - parentTop}px`;
        this.element.style.height = `${overlayRect.bottom - overlayRect.top}px`;
        this.element.style.left = `${overlayRect.left - parentLeft}px`;
        this.element.style.width = `${overlayRect.right - overlayRect.left}px`;
      }
    }
  }
  dragover(event) {
    if (!this.view.editable)
      return;
    const dropPosition = findDropPosition(this.view, event);
    if (this.hasDropPosChanged(dropPosition)) {
      this.setDropPos(dropPosition);
    } else if (!dropPosition) {
      this.setDropPos(null);
    }
  }
  dragend(_) {
    this.setDropPos(null);
  }
  drop(_) {
    this.setDropPos(null);
  }
  dragleave(event) {
    if (event.target === this.view.dom)
      this.setDropPos(null);
  }
}
const createColumnNode = (schema, content, attrs) => {
  var _a2;
  return (_a2 = schema.nodes[SeshatNodes.WRAPPING_BLOCK]) == null ? void 0 : _a2.create(
    {
      type: BlockTypes.BLOCK_COLUMN,
      ...attrs
    },
    content
  );
};
const insertColumnWithBlockLineWrapper = ({
  schema,
  tr,
  content,
  dropPos
}) => {
  var _a2;
  const $block = BlockSelection.createFromPosition(
    tr.doc,
    dropPos.pos
  ).firstBlock();
  const columnNode = createColumnNode(schema, $block.node);
  const columnNodeDragged = createColumnNode(schema, content);
  const blockLineContent = dropPos.column === "left" ? [columnNodeDragged, columnNode] : [columnNode, columnNodeDragged];
  const blockLineNode = (_a2 = schema.nodes[SeshatNodes.WRAPPING_BLOCK]) == null ? void 0 : _a2.create(
    {
      type: BlockTypes.BLOCK_LINE
    },
    blockLineContent
  );
  return tr.delete($block.from, $block.to).insert(dropPos.pos, blockLineNode);
};
const insertAsColumn = ({
  tr,
  schema,
  dropPos,
  content
}) => {
  var _a2, _b2;
  if (!dropPos)
    return tr;
  const { parent: parentNode } = tr.doc.resolve(dropPos.pos);
  const hasBlockLineWrapper = (parentNode == null ? void 0 : parentNode.attrs.type) === BlockTypes.BLOCK_LINE;
  if (!hasBlockLineWrapper)
    return insertColumnWithBlockLineWrapper({ schema, tr, content, dropPos });
  const columnNodeDragged = createColumnNode(schema, content);
  const columnBeforeSize = (_b2 = (_a2 = tr.doc.nodeAt(dropPos.pos)) == null ? void 0 : _a2.nodeSize) != null ? _b2 : 0;
  const insertPos = dropPos.column === "left" ? dropPos.pos : dropPos.pos + columnBeforeSize;
  return tr.insert(insertPos, columnNodeDragged);
};
const dropHandleHandler = (view, event, slice, moved, options) => {
  var _a2, _b2;
  event.preventDefault();
  const contentToInsert = slice.content;
  const dragEvent = event;
  const hasFiles = (_a2 = dragEvent == null ? void 0 : dragEvent.dataTransfer) == null ? void 0 : _a2.files.length;
  const isExternalContent = !moved;
  const dropPosition = findDropPosition(view, dragEvent, contentToInsert);
  if (!dropPosition)
    return true;
  if (isExternalContent && hasFiles && (options == null ? void 0 : options.file))
    return handleExternalFileDrop({
      view,
      dropPosition,
      files: (_b2 = dragEvent == null ? void 0 : dragEvent.dataTransfer) == null ? void 0 : _b2.files,
      options: options.file
    });
  return handleDroppedSeshatBlocks({ view, contentToInsert, dropPosition });
};
const handleExternalFileDrop = ({
  view,
  files,
  dropPosition,
  options
}) => {
  if (!files)
    return true;
  const insertPos = dropPosition.indented ? dropPosition.pos - 1 : dropPosition.pos;
  uploadAndInsertFile({
    view,
    files,
    insertPos,
    onUpload: options.onUpload
  });
  return true;
};
const handleDroppedSeshatBlocks = ({
  view,
  contentToInsert,
  dropPosition
}) => {
  if (!contentToInsert)
    return true;
  const content = contentToInsert;
  const { state, dispatch } = view;
  let { tr, schema } = state;
  tr = deleteInitialBlock(tr, content);
  dropPosition.pos = tr.mapping.map(dropPosition.pos);
  if (dropPosition.column) {
    tr = insertAsColumn({ tr, schema, content, dropPos: dropPosition });
  } else {
    tr.insert(dropPosition.pos, content);
  }
  tr = selectBlockAfterDrop(tr, content);
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const getDraggedBlock = (tr, content) => {
  var _a2;
  const draggedBlockId = (_a2 = content.firstChild) == null ? void 0 : _a2.attrs[BlockAttrsParams.BLOCK_UUID];
  return getSeshatBlockByBlockId(tr.doc, draggedBlockId);
};
const deleteInitialBlock = (tr, content) => {
  const block = getDraggedBlock(tr, content);
  return block ? tr.delete(block.pos, block.pos + block.node.nodeSize) : tr;
};
const selectBlockAfterDrop = (tr, content) => {
  const block = getDraggedBlock(tr, content);
  return block ? tr.setSelection(BlockSelection.createFromPosition(tr.doc, block.pos)) : tr;
};
const DROP_HANDLE_EXTENSION = new PluginKey("drop-handle-extension");
const DropHandleExtension = (options) => Extension$1.create({
  name: "DropHandleExtension",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: DROP_HANDLE_EXTENSION,
        view(view) {
          return new DropCursor(view);
        },
        props: {
          handleDrop: (...args) => dropHandleHandler(...args, options)
        }
      })
    ];
  }
});
const ReadLaterDecorationExtension = Node$1.create({
  name: NodeViewTypes.READ_LATER_DECORATION,
  group: `${SeshatNodeGroups.NODE_VIEW}`,
  atom: true,
  selectable: true,
  draggable: true,
  addAttributes() {
    return {
      cardUuid: {
        default: null
      },
      parentCardUuid: {
        default: null
      }
    };
  },
  renderHTML() {
    return ["div"];
  }
});
const isHighlightElementBeingMoved = (block) => {
  if (block.node.attrs.type === BlockTypes.HIGHLIGHT_NOTE)
    return true;
  if (block.node.attrs.type === BlockTypes.HIGHLIGHT)
    return true;
  if (isHighlightBlockquote$1(block))
    return true;
  return false;
};
const isHighlightBlockquote$1 = (block) => block.node.attrs.type === BlockTypes.BLOCKQUOTE && block.$from.node(block.depth - 1).attrs.type === BlockTypes.HIGHLIGHT;
const insertAbove = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionEnd = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.to) != null ? _b2 : blockSelection.firstBlock().to;
  tr.delete(selectionStart, selectionEnd);
  tr.insert(block.from, blockSelection.getFragment());
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from - block.node.nodeSize,
    initialSelection.to - block.node.nodeSize
  ) : TextSelection.create(tr.doc, initialSelection.from - block.node.nodeSize);
  tr.setSelection(updatedSelection);
  return tr;
};
const insertInColumnBefore = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionEnd = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.to) != null ? _b2 : blockSelection.firstBlock().to;
  tr.delete(selectionStart, selectionEnd);
  tr.insert(block.to - 1, blockSelection.getFragment());
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from - 2,
    initialSelection.to - 2
  ) : TextSelection.create(tr.doc, initialSelection.from - 2);
  tr.setSelection(updatedSelection);
  return tr;
};
const insertIndent = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2, _c2, _d2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionDepth = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.depth) != null ? _b2 : blockSelection.firstBlock().depth;
  const selectionEnd = (_d2 = (_c2 = blockSelection.lastBlock()) == null ? void 0 : _c2.to) != null ? _d2 : blockSelection.firstBlock().to;
  tr.delete(selectionStart, selectionEnd);
  tr.insert(block.to, blockSelection.getFragment());
  const offset = selectionDepth - block.depth - 1;
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from + offset,
    initialSelection.to + offset
  ) : TextSelection.create(tr.doc, initialSelection.from + offset);
  tr.setSelection(updatedSelection);
  return tr;
};
const isContentEditableFalse = (node) => isContentEditableFalseBlockType.includes(node == null ? void 0 : node.attrs.type) || (node == null ? void 0 : node.attrs.contentEditable) === false;
const getPreviousBlock = (doc, pos, predicate, options) => {
  const currentBlock = getCurrentBlock(doc, pos);
  if (!currentBlock)
    return void 0;
  for (let i = currentBlock.from - 1; i >= 1; i--) {
    const node = doc.nodeAt(i);
    const $i = doc.resolve(i);
    if (!isBlock(node, predicate))
      continue;
    if (isNonSelectableChildOfParent(doc, i, currentBlock.depth - 1))
      continue;
    if ((options == null ? void 0 : options.ignoreChildren) && currentBlock.depth <= $i.depth)
      continue;
    return {
      node,
      depth: $i.depth,
      from: i,
      $from: $i,
      to: i + node.nodeSize,
      $to: doc.resolve(i + node.nodeSize)
    };
  }
  return void 0;
};
const isNonSelectableChildOfParent = (doc, pos, depth) => {
  const $pos = doc.resolve(pos);
  if ($pos.depth <= depth)
    return false;
  const parentPos = $pos.before(depth + 1);
  const parent = doc.nodeAt(parentPos);
  return parent && (isContentEditableFalse(parent) || parent.attrs.collapsed === true);
};
const findHighlightsBlockAncestor = (block) => {
  if (!block)
    return void 0;
  return findAncestor(block.$from, (node) => {
    return (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHTS;
  });
};
const maybeSkipHighlightsBlocks = ({
  doc,
  block
}) => {
  while (block) {
    let highlightsBlock = findHighlightsBlockAncestor(block);
    if (!highlightsBlock)
      break;
    const { depth } = highlightsBlock;
    const highlightsBlockStart = block.$from.start(depth);
    block = getPreviousBlock(doc, highlightsBlockStart);
  }
  return block;
};
const findCardLinksInSelection = (blockSelection) => {
  return blockSelection.list().some((b) => b.node.attrs.type === BlockTypes.CARD_LINK);
};
const maybeSkipIndentedBlock = ({
  doc,
  block,
  blockSelection
}) => {
  return findCardLinksInSelection(blockSelection) ? getPreviousBlock(doc, blockSelection.from + 1, void 0, {
    ignoreChildren: true
  }) : block;
};
const moveUp = ({ editor }) => {
  var _a2;
  const { dispatch } = editor.view;
  let { tr, doc } = editor.state;
  const isBlockSelectionActive = isBlockSelection(editor.state.selection);
  if (!isBlockSelectionActive && !editor.state.selection.empty)
    return true;
  const blockSelection = isBlockSelectionActive ? editor.state.selection : BlockSelection.createFromTextSelection(doc, editor.state.selection);
  const firstBlock = blockSelection.firstBlock();
  if (isCaretWithinHighlightBlockquote(firstBlock.$from))
    return true;
  if (isAtStartOfHighlightNote(doc, firstBlock))
    return true;
  if (isHighlightElementBeingMoved(firstBlock))
    return true;
  let prevBlock = getPreviousBlock(doc, firstBlock.from, (node) => {
    return node.attrs.type !== BlockTypes.BLOCK_LINE;
  });
  prevBlock = maybeSkipIndentedBlock({ doc, block: prevBlock, blockSelection });
  prevBlock = maybeSkipHighlightsBlocks({ doc, block: prevBlock });
  if (!prevBlock || prevBlock.from === 0)
    return true;
  if (prevBlock.depth + 1 < firstBlock.depth) {
    const blockType = (_a2 = doc.nodeAt(firstBlock.from - 1)) == null ? void 0 : _a2.attrs.type;
    return getNodeTypeByBlockType(blockType) === SeshatNodes.WRAPPING_BLOCK ? editor.commands.unwrapBlock({ ignoreAtStart: true }) : editor.commands.outdentBlock();
  }
  if (prevBlock.node.attrs.type === BlockTypes.BLOCK_COLUMN) {
    dispatch == null ? void 0 : dispatch(insertInColumnBefore({ tr, blockSelection, block: prevBlock }));
    return true;
  }
  if (firstBlock.depth < prevBlock.depth + 1) {
    dispatch == null ? void 0 : dispatch(insertIndent({ tr, blockSelection, block: prevBlock }));
    return true;
  }
  dispatch == null ? void 0 : dispatch(insertAbove({ tr, blockSelection, block: prevBlock }));
  return true;
};
const isAtStartOfHighlightNote = (doc, block) => {
  var _a2;
  return ((_a2 = doc.nodeAt(block.from - 1)) == null ? void 0 : _a2.attrs.type) === BlockTypes.HIGHLIGHT_NOTE;
};
const insertAsChild = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2, _c2, _d2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionEnd = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.to) != null ? _b2 : blockSelection.firstBlock().to;
  const insertPos = block.node.type.name === SeshatNodes.WRAPPING_BLOCK ? block.from + 1 : block.from + ((_d2 = (_c2 = block.node.firstChild) == null ? void 0 : _c2.nodeSize) != null ? _d2 : 0) + 1;
  tr.insert(insertPos, blockSelection.getFragment());
  tr.delete(selectionStart, selectionEnd);
  const offset = insertPos - block.from;
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from + offset,
    initialSelection.to + offset
  ) : TextSelection.create(tr.doc, initialSelection.from + offset);
  tr.setSelection(updatedSelection);
  return tr;
};
const insertBelow = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionEnd = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.to) != null ? _b2 : blockSelection.firstBlock().to;
  tr.insert(block.to, blockSelection.getFragment());
  tr.delete(selectionStart, selectionEnd);
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from + block.node.nodeSize,
    initialSelection.to + block.node.nodeSize
  ) : TextSelection.create(tr.doc, initialSelection.from + block.node.nodeSize);
  tr.setSelection(updatedSelection);
  return tr;
};
const insertInColumnAfter = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionEnd = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.to) != null ? _b2 : blockSelection.firstBlock().to;
  tr.insert(block.from + 1, blockSelection.getFragment());
  tr.delete(selectionStart, selectionEnd);
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from + 2,
    initialSelection.to + 2
  ) : TextSelection.create(tr.doc, initialSelection.from + 2);
  tr.setSelection(updatedSelection);
  return tr;
};
const insertOutdent = ({
  tr,
  blockSelection,
  block
}) => {
  var _a2, _b2, _c2, _d2;
  const initialSelection = tr.selection;
  const selectionStart = blockSelection.firstBlock().from;
  const selectionDepth = (_b2 = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.depth) != null ? _b2 : blockSelection.firstBlock().depth;
  const selectionEnd = (_d2 = (_c2 = blockSelection.lastBlock()) == null ? void 0 : _c2.to) != null ? _d2 : blockSelection.firstBlock().to;
  tr.insert(block.from, blockSelection.getFragment());
  tr.delete(selectionStart, selectionEnd);
  const offset = selectionDepth - block.depth - 1;
  const updatedSelection = isBlockSelection(tr.selection) ? BlockSelection.createFromRange(
    tr.doc,
    initialSelection.from + offset,
    initialSelection.to + offset
  ) : TextSelection.create(tr.doc, initialSelection.from + offset);
  tr.setSelection(updatedSelection);
  return tr;
};
const findBlockLineAncestor = (block) => {
  if (!block)
    return void 0;
  return findAncestor(block.$from, (node) => {
    return (node == null ? void 0 : node.attrs.type) === BlockTypes.BLOCK_LINE;
  });
};
const maybeSkipBlockLine = ({
  doc,
  block,
  blockSelection
}) => {
  const containsCardLink = findCardLinksInSelection(blockSelection);
  const blockLine = findBlockLineAncestor(block);
  if (!block || !containsCardLink || !blockLine)
    return block;
  const blockLineStart = block.$from.before(blockLine.depth);
  let nextBlock = getCurrentBlock(doc, blockLineStart);
  while ((nextBlock == null ? void 0 : nextBlock.node.attrs.type) === BlockTypes.BLOCK_LINE) {
    nextBlock = getCurrentBlock(doc, nextBlock.to + 1);
  }
  return nextBlock ? getPreviousBlock(doc, nextBlock.from, void 0, {
    ignoreChildren: true
  }) : void 0;
};
const moveDown = ({ editor }) => {
  var _a2;
  const { dispatch } = editor.view;
  let { doc, tr } = editor.state;
  const isBlockSelectionActive = isBlockSelection(editor.state.selection);
  if (!isBlockSelectionActive && !editor.state.selection.empty)
    return true;
  const blockSelection = isBlockSelectionActive ? editor.state.selection : BlockSelection.createFromTextSelection(doc, editor.state.selection);
  const firstBlock = blockSelection.firstBlock();
  const lastBlock = (_a2 = blockSelection.lastBlock()) != null ? _a2 : firstBlock;
  if (lastBlock.to === doc.nodeSize - SESHAT_ROOT_DEPTH)
    return true;
  if (isCaretWithinHighlightBlockquote(lastBlock.$from))
    return true;
  if (isAtEndOfHighlightNote(lastBlock))
    return true;
  if (isHighlightElementBeingMoved(lastBlock))
    return true;
  let nextBlock = getNextBlock(doc, lastBlock.to, (node) => {
    return node.attrs.type !== BlockTypes.BLOCK_LINE;
  });
  nextBlock = maybeSkipBlockLine({ doc, block: nextBlock, blockSelection });
  if (!nextBlock)
    return true;
  if (nextBlock.node.attrs.type === BlockTypes.BLOCK_COLUMN) {
    dispatch == null ? void 0 : dispatch(insertInColumnAfter({ tr, blockSelection, block: nextBlock }));
    return true;
  }
  if (nextBlock.depth + 1 < lastBlock.depth) {
    dispatch == null ? void 0 : dispatch(insertOutdent({ tr, blockSelection, block: nextBlock }));
    return true;
  }
  if (hasChildren(nextBlock.node) && isChildInsertAllowed(blockSelection, nextBlock.node)) {
    dispatch == null ? void 0 : dispatch(insertAsChild({ tr, blockSelection, block: nextBlock }));
    return true;
  }
  dispatch == null ? void 0 : dispatch(insertBelow({ tr, blockSelection, block: nextBlock }));
  return true;
};
const isChildInsertAllowed = (blockSelection, node) => {
  return !findCardLinksInSelection(blockSelection) && !isContentEditableFalse(node) && node.attrs.type !== BlockTypes.HIGHLIGHTS && node.attrs.type !== BlockTypes.BLOCK_LINE;
};
const isAtEndOfHighlightNote = (block) => {
  var _a2;
  const parent = block.$from.node(block.depth - 1);
  if (parent.attrs.type !== BlockTypes.HIGHLIGHT_NOTE)
    return false;
  return ((_a2 = parent.lastChild) == null ? void 0 : _a2.attrs[BlockAttrsParams.BLOCK_UUID]) === block.node.attrs[BlockAttrsParams.BLOCK_UUID];
};
const MoveBlockExtension = Extension$1.create({
  name: "MoveBlockExtension",
  addKeyboardShortcuts() {
    return {
      [shortcutConfig.moveUp]: moveUp,
      [shortcutConfig.moveDown]: moveDown
    };
  }
});
const MentionPlaceholderExtensionKey = "mention-placeholder";
const getPluginStateValue = (state, key) => {
  return key.getState(state);
};
const setPluginStateValue = (view, key, value) => {
  var _a2, _b2;
  return (_b2 = view.dispatch) == null ? void 0 : _b2.call(view, (_a2 = view.state) == null ? void 0 : _a2.tr.setMeta(key, value));
};
const hideSelectionDecoration = (doc) => {
  return Decoration.node(0, doc.content.size, {
    class: "ProseMirror-hideselection"
  });
};
const PREVENT_EDITOR_INPUT_PLUGIN = "prevent-editor-input-plugin";
const PREVENT_EDITOR_INPUT_PLUGIN_KEY = new PluginKey(
  PREVENT_EDITOR_INPUT_PLUGIN
);
const preventEditorInputPlugin = new Plugin({
  key: PREVENT_EDITOR_INPUT_PLUGIN_KEY,
  state: {
    init() {
      return { preventTextInput: false };
    },
    apply(tr, pluginState) {
      const value = tr.getMeta(PREVENT_EDITOR_INPUT_PLUGIN);
      if (value === void 0)
        return pluginState;
      return { preventTextInput: value };
    }
  },
  props: {
    decorations: (state) => {
      return PREVENT_EDITOR_INPUT_PLUGIN_KEY.getState(state).preventTextInput ? DecorationSet.create(state.doc, [hideSelectionDecoration(state.doc)]) : void 0;
    },
    handleTextInput(view) {
      const state = PREVENT_EDITOR_INPUT_PLUGIN_KEY.getState(view.state);
      return state.preventTextInput;
    }
  }
});
const insertMentionPlaceholderTransaction = ({
  type,
  char,
  placeholder,
  range,
  tr,
  originalValue
}) => {
  const node = type.create({ char, placeholder, originalValue });
  const isInputRuleInitiated = range.from !== range.to;
  if (isInputRuleInitiated)
    tr.delete(range.from, range.to);
  return tr.insert(range.from, node).setMeta(MentionPlaceholderExtensionKey, true).setMeta(PREVENT_EDITOR_INPUT_PLUGIN, true);
};
const getSelectedText = (selection) => {
  const nodeStartPosition = selection.$head.start();
  return selection.$head.parent.textBetween(
    selection.$from.pos - nodeStartPosition,
    selection.$to.pos - nodeStartPosition
  );
};
const getEndPosition = ({
  selection,
  lastCharElement,
  isBracketBefore
}) => {
  const nodeStartPosition = selection.$head.start();
  const isEndBracketAfter = selection.$head.parent.textBetween(
    selection.$from.pos - nodeStartPosition,
    selection.$to.pos - nodeStartPosition + (isBracketBefore ? lastCharElement.length : 0)
  ).endsWith("]");
  return isEndBracketAfter ? selection.to + 1 : selection.to;
};
const isBracketBeforeSelection = ({
  selection,
  firstCharElement
}) => {
  var _a2;
  const isSelectionAtStartOfLine = !selection.$from.nodeBefore;
  return !firstCharElement && isSelectionAtStartOfLine || ((_a2 = selection.$from.nodeBefore) == null ? void 0 : _a2.textContent.endsWith(firstCharElement));
};
const insertMentionPlaceholderOnTextSelectionTransaction = ({
  tr,
  type,
  char,
  placeholder,
  forceInsert
}) => {
  const chars = char.split("");
  const lastCharElement = chars.pop();
  const firstCharElement = chars.join();
  if (!lastCharElement)
    return false;
  const { selection } = tr;
  const isBracketBefore = isBracketBeforeSelection({
    selection,
    firstCharElement
  });
  if (!forceInsert && (selection.empty || !isBracketBefore))
    return false;
  return insertMentionPlaceholderTransaction({
    tr,
    char,
    placeholder,
    type,
    originalValue: getSelectedText(selection) || "",
    range: {
      from: isBracketBefore ? selection.from - 1 : selection.from,
      to: getEndPosition({ selection, lastCharElement, isBracketBefore })
    }
  });
};
const handleBracketsOnSelectionPlugin = (mention) => new Plugin({
  key: new PluginKey("BRACKET_FOR_MENTION_PLACEHOLDER" + mention.name),
  props: {
    handleKeyPress: handleKeyPress({
      type: mention.type,
      char: mention.char,
      placeholder: mention.placeholder
    })
  }
});
const handleKeyPress = ({
  type,
  char,
  placeholder
}) => (view, event) => {
  const { key } = event;
  const lastCharElement = char.split("").pop();
  if (key !== lastCharElement)
    return false;
  const tr = insertMentionPlaceholderOnTextSelectionTransaction({
    tr: view.state.tr,
    forceInsert: false,
    placeholder,
    type,
    char
  });
  if (!tr)
    return false;
  view.dispatch(tr);
  return true;
};
const MentionPlaceholderNodes = (options) => {
  var _a2, _b2;
  return (_b2 = (_a2 = options == null ? void 0 : options.mentions) == null ? void 0 : _a2.items.map(
    (mention) => Node$1.create({
      name: mention.name + "placeholder",
      inline: true,
      selectable: true,
      atom: true,
      group: "inline",
      priority: 1e3,
      addOptions() {
        return mention;
      },
      addAttributes() {
        return {
          char: {
            default: void 0
          },
          placeholder: {
            default: void 0
          },
          originalValue: {
            default: void 0
          }
        };
      },
      renderHTML() {
        return ["span"];
      },
      addCommands() {
        if (!mention.isDefault)
          return {};
        return {
          insertMentionPlaceholderOnTextSelection: ({
            type,
            char,
            placeholder
          }) => ({
            dispatch,
            tr
          }) => {
            const transaction = insertMentionPlaceholderOnTextSelectionTransaction(
              {
                type: type != null ? type : this.type,
                placeholder: placeholder != null ? placeholder : mention.placeholder,
                char: char != null ? char : mention.char,
                tr,
                forceInsert: true
              }
            );
            if (!transaction)
              return false;
            dispatch == null ? void 0 : dispatch(transaction);
            return true;
          },
          insertMentionPlaceholder: ({
            type,
            char,
            placeholder
          }) => ({
            tr,
            dispatch
          }) => {
            dispatch == null ? void 0 : dispatch(
              insertMentionPlaceholderTransaction({
                tr,
                type: type != null ? type : this.type,
                char: char != null ? char : mention.char,
                originalValue: "",
                placeholder: placeholder != null ? placeholder : mention.placeholder,
                range: { from: tr.selection.head, to: tr.selection.anchor }
              })
            );
            return true;
          }
        };
      },
      addProseMirrorPlugins() {
        return [
          ...mention.char === "#" ? [preventEditorInputPlugin] : [],
          ...mention.handleWrappingKeyDown ? [handleBracketsOnSelectionPlugin({ ...mention, type: this.type })] : []
        ];
      },
      addInputRules() {
        const regexExp = mention.char === "[[" ? new RegExp(
          "((\\s|^)" + mention.char.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&") + ")$",
          "gm"
        ) : new RegExp(
          "((\\s|^)" + mention.char.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&") + ")(\\w+)$",
          "gm"
        );
        return [
          new InputRule({
            find: regexExp,
            handler: ({ match, range, commands }) => {
              commands.command(({ dispatch, tr }) => {
                var _a3;
                const isInvalidPos = range.from < SESHAT_ROOT_DEPTH || !tr.doc.nodeAt(range.from);
                if (isInvalidPos)
                  return false;
                dispatch == null ? void 0 : dispatch(
                  insertMentionPlaceholderTransaction({
                    tr,
                    type: this.type,
                    char: match[1],
                    placeholder: mention.placeholder,
                    originalValue: (_a3 = match[3]) != null ? _a3 : "",
                    range
                  })
                );
                return true;
              });
            }
          })
        ];
      }
    })
  )) != null ? _b2 : [];
};
const MODIFICATION_STEPS = [
  AddMarkStep,
  RemoveMarkStep,
  ReplaceStep,
  ReplaceAroundStep
];
const isModificationStep = (step) => {
  return MODIFICATION_STEPS.some(
    (ModificationStep) => step instanceof ModificationStep
  );
};
const isModificationWithinNode = (node, step) => node.$from.pos < step.from && step.to < node.$to.pos;
const isReplacementAcrossNode = (node, step) => step instanceof ReplaceStep && step.slice.size === 0 && step.from <= node.$from.pos && node.$to.pos <= step.to;
const wasTransactionDispatchedBySyncPlugin = (tr) => tr.getMeta(clipObserverPluginKey) || tr.getMeta(highlightsBlocksObserverPluginKey);
const wasTransactionDispatchedByBlockIdPlugin = (tr) => tr.getMeta(pluginKey);
const wasTransactionDispatchedByMentionPlugin = (tr) => tr.getMeta(MentionPlaceholderExtensionKey);
const IgnoreContentEditableFalse = "ignoreContentEditableFalse";
const ContentEditableExtension = Extension$1.create({
  name: "contentEditable",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("contentEditable"),
        filterTransaction: (tr) => {
          if (!tr.docChanged)
            return true;
          if (tr.getMeta(IgnoreContentEditableFalse))
            return true;
          return !tr.steps.some((step, i) => {
            const doc = tr.docs.length && tr.docs[i];
            if (!doc || !isModificationStep(step))
              return false;
            return !!findAncestor(
              doc.resolve(step.from),
              (node) => isContentEditableFalse(node)
            );
          });
        }
      })
    ];
  }
});
const insertClipTitle = ({
  clipUuid,
  title
}) => ({ editor, tr }) => {
  var _a2;
  const { node, pos } = ((_a2 = findChildren(
    tr.doc,
    (node2) => node2.attrs.type === BlockTypes.CLIP_CONTENT && node2.attrs[BlockAttrsParams.BLOCK_UUID] === clipUuid
  )) == null ? void 0 : _a2[0]) || {};
  if (!node || !pos)
    return false;
  const block = createSeshatBlock({
    schema: editor.state.schema,
    attrs: { type: BlockTypes.CLIP_CONTENT_TITLE },
    content: title
  });
  tr.insert(pos + 1, block);
  tr.setMeta(IgnoreContentEditableFalse, true);
  return true;
};
const insertClipVideo = ({
  content,
  href,
  ...props
}) => ({ chain }) => {
  const url = urlMediaParser(href);
  return chain().focus().insertClip({
    ...props,
    href,
    content: content + `<iframe src="${url}" alt="${props.hrefBackup}"/>`
  }).run();
};
const getClipPositions = ({
  doc,
  clipId
}) => {
  if (!clipId) {
    return NodeSelection.create(doc, 0);
  }
  const clip = getSeshatBlockByBlockId(doc, clipId);
  if (!clip)
    return void 0;
  return NodeSelection.create(doc, clip.pos);
};
const getHighlightsFromClipContent = ({
  doc,
  clipId
}) => {
  const clipPos = getClipPositions({ doc, clipId });
  if (!clipPos)
    return void 0;
  const { $from, $to } = clipPos;
  let highlights = [];
  doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
    const highlightMark = getHighlightMarkFromNode(node);
    if (highlightMark)
      highlights = addHighlightToHighlightsArray({ highlights, node, pos });
  });
  return highlights;
};
const addHighlightToHighlightsArray = ({
  highlights,
  node,
  pos
}) => {
  const highlightMark = getHighlightMarkFromNode(node);
  const highlightId = highlightMark == null ? void 0 : highlightMark.attrs[MarkAttrsParams.HIGHLIGHT_UUID];
  const highlightNote = highlightMark == null ? void 0 : highlightMark.attrs[MarkAttrsParams.HIGHLIGHT_NOTE];
  if (!highlightId)
    return highlights;
  const index = getHighlightsArrayIndex(highlights, highlightId);
  if (index === -1) {
    highlights.push({
      [MarkAttrsParams.HIGHLIGHT_UUID]: highlightId,
      [MarkAttrsParams.HIGHLIGHT_NOTE]: highlightNote,
      from: pos,
      to: pos + node.nodeSize
    });
  } else {
    highlights[index].to = pos + node.nodeSize;
  }
  return highlights;
};
const getHighlightsArrayIndex = (highlights, id) => highlights.map((h) => h[MarkAttrsParams.HIGHLIGHT_UUID]).indexOf(id);
const getHighlightsFromAttrs = (highlights) => highlights ? {
  highlights: ((highlights == null ? void 0 : highlights.content) || []).length,
  notes: ((highlights == null ? void 0 : highlights.content) || []).filter(
    (highlight2) => {
      var _a2;
      return ((_a2 = highlight2 == null ? void 0 : highlight2.content) == null ? void 0 : _a2.length) === 2;
    }
  ).length
} : {
  highlights: 0,
  notes: 0
};
const findFirstHighlight = ({
  doc
}) => {
  let found;
  doc.descendants((node, pos) => {
    if (found)
      return false;
    if (node.attrs.type === BlockTypes.HIGHLIGHT) {
      found = { node, pos };
      return true;
    }
    return;
  });
  return found;
};
const findHighlight = ({
  doc,
  highlightId
}) => {
  let found;
  doc.descendants((node) => {
    if (found)
      return false;
    if (node.attrs.type === BlockTypes.HIGHLIGHT && node.attrs.highlightId === highlightId) {
      found = node;
      return true;
    }
    return;
  });
  return found;
};
const findHighlightBlockQuote = (highlightNode) => {
  let found;
  highlightNode == null ? void 0 : highlightNode.descendants((node) => {
    if (found)
      return false;
    if (node.type.name === SeshatNodes.WRAPPING_BLOCK && node.attrs.type === BlockTypes.BLOCKQUOTE) {
      found = node;
      return true;
    }
    return;
  });
  return found;
};
const findHighlightBlockQuoteParagraph = (highlightNode) => {
  let found;
  highlightNode == null ? void 0 : highlightNode.descendants((node) => {
    if (found)
      return false;
    if (node.type.name === SeshatNodes.BLOCK && node.attrs.type === BlockTypes.PARAGRAPH) {
      found = node;
      return true;
    }
    return;
  });
  return found;
};
const createHighlightsFromClipContent = ({
  doc,
  schema,
  clipId
}) => {
  const highlights = getHighlightsFromClipContent({ doc, clipId });
  if (!highlights)
    return void 0;
  return highlights.map((highlight2) => {
    return createHighlightNode({ schema, doc, highlight: highlight2 });
  });
};
const createHighlightNode = ({
  schema,
  doc,
  highlight: highlight2
}) => {
  const matchingHighlightNodeInContent = findHighlight({
    doc,
    highlightId: highlight2.highlightId
  });
  const quote = createBlockquoteFromHighlight({
    schema,
    doc,
    highlight: highlight2,
    matchingHighlightNodeInContent
  });
  const content = highlight2.highlightNote ? [quote, Node.fromJSON(schema, highlight2.highlightNote)] : [quote];
  return schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    {
      ...matchingHighlightNodeInContent == null ? void 0 : matchingHighlightNodeInContent.attrs,
      type: BlockTypes.HIGHLIGHT,
      [BlockAttrsParams.HIGHLIGHT_UUID]: highlight2.highlightId
    },
    content
  );
};
const maybeMatchTheHighlightBlockquoteBlocksWithCurrentContent = ({
  content,
  matchingBlockquoteNodeInContent
}) => content.content.map(
  (node, index) => {
    var _a2, _b2;
    return node.type.create(
      {
        ...node.attrs,
        [BlockAttrsParams.BLOCK_UUID]: (_b2 = (_a2 = matchingBlockquoteNodeInContent == null ? void 0 : matchingBlockquoteNodeInContent.content.content) == null ? void 0 : _a2[index]) == null ? void 0 : _b2.attrs[BlockAttrsParams.BLOCK_UUID]
      },
      node.content
    );
  }
);
const createBlockquoteFromHighlight = ({
  schema,
  doc,
  highlight: highlight2,
  matchingHighlightNodeInContent
}) => {
  var _a2;
  const { content } = doc.slice(highlight2.from, highlight2.to);
  let contentNodes = content.content;
  const matchingBlockquoteNodeInContent = findHighlightBlockQuote(
    matchingHighlightNodeInContent
  );
  if (((_a2 = content.firstChild) == null ? void 0 : _a2.type.spec.group) !== SeshatNodeGroups.BLOCK) {
    contentNodes = wrapFragmentInDefaultSeshatBlock({
      schema,
      content,
      matchingBlockquoteNodeInContent
    });
  } else {
    contentNodes = maybeMatchTheHighlightBlockquoteBlocksWithCurrentContent({
      content,
      matchingBlockquoteNodeInContent
    });
  }
  return schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    { ...matchingBlockquoteNodeInContent == null ? void 0 : matchingBlockquoteNodeInContent.attrs, type: BlockTypes.BLOCKQUOTE },
    contentNodes
  );
};
const wrapFragmentInDefaultSeshatBlock = ({
  schema,
  content,
  matchingBlockquoteNodeInContent
}) => {
  const matchingParagraphNodeInContent = findHighlightBlockQuoteParagraph(
    matchingBlockquoteNodeInContent
  );
  const contentWithBlockWrapper = createSeshatBlock({
    attrs: {
      ...matchingParagraphNodeInContent == null ? void 0 : matchingParagraphNodeInContent.attrs,
      type: BlockTypes.PARAGRAPH
    },
    content: [...content.content],
    schema
  });
  return Fragment.from(contentWithBlockWrapper).content;
};
const createHighlightsFromPaywallClipContent = ({
  schema,
  clip
}) => {
  const highlightsBlock = clip.attrs.highlights;
  if (!highlightsBlock)
    return void 0;
  return Node.fromJSON(schema, highlightsBlock).content.content;
};
const getHighlightsFromClipContentById = ({
  clip,
  highlightId
}) => {
  return findChildren(clip, (node) => {
    return hasMarksWithGivenHighlightId(node, highlightId);
  });
};
const hasMarksWithGivenHighlightId = (node, highlightId) => node.marks.some(
  (mark) => mark.attrs[MarkAttrsParams.HIGHLIGHT_UUID] === highlightId
);
const getNodeWithBlockId = ({
  clip,
  start,
  end
}) => {
  const clipHighlightedNode = [];
  clip.node.nodesBetween(start - clip.pos, end - clip.pos, (node) => {
    if (node.attrs[BlockAttrsParams.BLOCK_UUID]) {
      clipHighlightedNode.push(node);
    }
  });
  return clipHighlightedNode;
};
const getPositionOfTheNodeWithBlockIdAfterClipModification = ({
  start,
  end,
  highlightsBlock,
  tr
}) => {
  const connectedClipId = highlightsBlock == null ? void 0 : highlightsBlock.node.attrs.connectedClip;
  const clipAfterModification = getSeshatBlockByBlockId(
    tr.doc,
    connectedClipId
  );
  const blockPos = [];
  clipAfterModification == null ? void 0 : clipAfterModification.node.nodesBetween(
    start - clipAfterModification.pos,
    end - clipAfterModification.pos,
    (node, pos) => {
      if (node.attrs[BlockAttrsParams.BLOCK_UUID]) {
        blockPos.push(pos + clipAfterModification.pos);
      }
    }
  );
  return blockPos;
};
const syncClipContent = ({
  tr,
  schema,
  highlightsBlock,
  clip
}) => {
  let newTr = tr;
  let diff2 = 0;
  const highlightMarkType = schema.marks[MarkTypes.HIGHLIGHT];
  newTr.removeMark(clip.pos, clip.pos + clip.node.nodeSize, highlightMarkType);
  highlightsBlock.node.content.forEach((highlight2) => {
    const highlightId = highlight2.attrs[MarkAttrsParams.HIGHLIGHT_UUID];
    if (!highlightId)
      return;
    const associatedClipHighlights = getHighlightsFromClipContentById({
      clip: clip.node,
      highlightId
    });
    if (!associatedClipHighlights.length)
      return;
    const oldMark = getHighlightMarkFromNode(associatedClipHighlights[0].node);
    if (!oldMark)
      return;
    const updatedContent = getBlockquoteContentFromHighlight(highlight2);
    const updatedMark = highlightMarkType.create({
      ...oldMark.attrs,
      [MarkAttrsParams.HIGHLIGHT_NOTE]: getNoteFromHighlight(highlight2)
    });
    const { start, end } = getStartAndEndOfClipHighlight({
      clipPos: clip.pos,
      clipHighlights: associatedClipHighlights
    });
    if (updatedContent.size === 0) {
      newTr = newTr.removeMark(start + diff2, end + diff2, highlightMarkType);
      return;
    }
    const contentDiff = updatedContent.size - (end - start);
    const nodeWidthBlockIdInClipBeforeModification = getNodeWithBlockId({
      start: start + diff2,
      end: end + diff2,
      clip
    });
    newTr = newTr.replace(start + diff2, end + diff2, updatedContent).addMark(start + diff2, end + diff2 + contentDiff, updatedMark);
    const blockPos = getPositionOfTheNodeWithBlockIdAfterClipModification({
      start: start + diff2,
      end: end + diff2,
      tr: newTr,
      highlightsBlock
    });
    blockPos.forEach((pos, index) => {
      var _a2;
      if (!((_a2 = nodeWidthBlockIdInClipBeforeModification[index]) == null ? void 0 : _a2.attrs))
        return;
      newTr = newTr.setNodeMarkup(
        pos + 1,
        void 0,
        nodeWidthBlockIdInClipBeforeModification[index].attrs
      );
    });
    diff2 += contentDiff;
  });
  return newTr;
};
const getStartAndEndOfClipHighlight = ({
  clipPos,
  clipHighlights
}) => {
  const correctedClipPos = clipPos + 1;
  const firstClipHighlight = clipHighlights[0];
  const lastClipHighlight = clipHighlights[clipHighlights.length - 1];
  return {
    start: correctedClipPos + firstClipHighlight.pos,
    end: correctedClipPos + lastClipHighlight.pos + lastClipHighlight.node.nodeSize
  };
};
const syncPaywallClipContent = ({
  tr,
  highlightsBlock,
  clip
}) => {
  var _a2;
  const highlights = (_a2 = tr.doc.nodeAt(highlightsBlock.pos)) != null ? _a2 : highlightsBlock.node;
  return tr.setNodeMarkup(clip.pos, void 0, {
    ...clip.node.attrs,
    highlights: highlights.toJSON()
  });
};
const insertBlockquoteInHighlight = ({
  content
}) => ({ tr, commands }) => {
  var _a2;
  const highlight2 = findFirstHighlight({ doc: tr.doc });
  if (!highlight2)
    return false;
  const blockquoteInHighlight = highlight2.node.firstChild;
  const highlightSize = (_a2 = blockquoteInHighlight == null ? void 0 : blockquoteInHighlight.nodeSize) != null ? _a2 : 0;
  return commands.replaceWith({
    from: highlight2.pos + 2,
    to: highlight2.pos + 2 + highlightSize - 2,
    content
  });
};
const getDefaultHighlightColor = () => {
  var _a2;
  const defaultColor = (_a2 = GroupHighlightColors.find(
    (item) => item.title.toLowerCase() === "yellow"
  )) == null ? void 0 : _a2.color;
  return defaultColor != null ? defaultColor : "";
};
const isHighlightMarkAllowed = (node) => {
  var _a2;
  return node.type.spec.marks === "_" || !!((_a2 = node.type.spec.marks) == null ? void 0 : _a2.includes(MarkTypes.HIGHLIGHT));
};
const setHighlight = (attrs) => ({
  commands,
  state,
  dispatch
}) => {
  commands.markAsAnnotation();
  if (isBlockSelection(state.selection)) {
    return setMarkInBlockSelection({
      state,
      dispatch,
      blockSelection: state.selection,
      attrs
    });
  } else {
    return setMarkInInlineContent({ commands, attrs });
  }
};
const setMarkInBlockSelection = ({
  state,
  dispatch,
  blockSelection,
  attrs
}) => {
  var _a2, _b2;
  const { tr } = state;
  const schema = state.schema;
  const newMark = schema.marks[MarkTypes.HIGHLIGHT].create({
    ...attrs,
    [MarkAttrsParams.HIGHLIGHT_UUID]: (_a2 = attrs == null ? void 0 : attrs.highlightId) != null ? _a2 : generateRandomId(),
    [MarkAttrsParams.HIGHLIGHT_COLOR]: (_b2 = attrs == null ? void 0 : attrs.color) != null ? _b2 : getDefaultHighlightColor()
  });
  blockSelection.list().forEach((block) => {
    tr.doc.nodesBetween(block.from, block.to, (node, pos) => {
      if (!isHighlightMarkAllowed(node))
        return;
      const isInSet = newMark.type.isInSet(node.marks);
      if (isInSet) {
        tr.removeMark(pos, pos + node.nodeSize, newMark.type);
        tr.addMark(pos, pos + node.nodeSize, newMark);
      } else {
        tr.addMark(pos, pos + node.nodeSize, newMark);
      }
    });
  });
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const setMarkInInlineContent = ({
  commands,
  attrs
}) => {
  var _a2, _b2;
  return commands.setMark(MarkTypes.HIGHLIGHT, {
    ...attrs,
    [MarkAttrsParams.HIGHLIGHT_UUID]: (_a2 = attrs == null ? void 0 : attrs.highlightId) != null ? _a2 : generateRandomId(),
    [MarkAttrsParams.HIGHLIGHT_COLOR]: (_b2 = attrs == null ? void 0 : attrs.color) != null ? _b2 : getDefaultHighlightColor()
  });
};
const isHighlightMark = (mark) => mark.type.name === MarkTypes.HIGHLIGHT;
const toggleHighlight = (attrs) => ({
  commands,
  state,
  dispatch
}) => {
  commands.markAsAnnotation();
  if (isBlockSelection(state.selection)) {
    return toggleMarkInBlockSelection({
      state,
      dispatch,
      blockSelection: state.selection,
      attrs
    });
  } else {
    return toggleMarkInInlineContent({ state, commands, attrs });
  }
};
const toggleMarkInBlockSelection = ({
  state,
  dispatch,
  blockSelection,
  attrs
}) => {
  var _a2;
  const { tr } = state;
  const schema = state.schema;
  const range = { from: blockSelection.from, to: blockSelection.to };
  const newMark = schema.marks[MarkTypes.HIGHLIGHT].create({
    ...attrs,
    [MarkAttrsParams.HIGHLIGHT_UUID]: generateRandomId(),
    [MarkAttrsParams.HIGHLIGHT_COLOR]: (_a2 = attrs == null ? void 0 : attrs.color) != null ? _a2 : getDefaultHighlightColor()
  });
  const shouldRemoveHighlightMark = findChildrenInRange(tr.doc, range, hasNoHighlights).length === 0;
  blockSelection.list().forEach((block) => {
    tr.doc.nodesBetween(block.from, block.to, (node, pos) => {
      if (!isHighlightMarkAllowed(node))
        return;
      const hasHighlightMarkAlready = newMark.type.isInSet(node.marks);
      if (shouldRemoveHighlightMark && hasHighlightMarkAlready) {
        tr.removeMark(pos, pos + node.nodeSize, newMark.type);
        return;
      }
      if (!shouldRemoveHighlightMark && hasHighlightMarkAlready) {
        tr.removeMark(pos, pos + node.nodeSize, newMark.type);
        tr.addMark(pos, pos + node.nodeSize, newMark);
        return;
      }
      tr.addMark(pos, pos + node.nodeSize, newMark);
    });
  });
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const hasNoHighlights = (node) => {
  return isHighlightMarkAllowed(node) && !node.marks.filter(isHighlightMark).length;
};
const toggleMarkInInlineContent = ({
  state,
  commands,
  attrs
}) => {
  var _a2;
  const { $anchor, $head } = state.selection;
  const marks = $anchor.marksAcross($head);
  const highlights = marks == null ? void 0 : marks.filter(isHighlightMark);
  const highlightId = (highlights == null ? void 0 : highlights.length) ? highlights[0].attrs[MarkAttrsParams.HIGHLIGHT_UUID] : generateRandomId();
  return commands.toggleMark(MarkTypes.HIGHLIGHT, {
    ...attrs,
    [MarkAttrsParams.HIGHLIGHT_UUID]: highlightId,
    [MarkAttrsParams.HIGHLIGHT_COLOR]: (_a2 = attrs == null ? void 0 : attrs.color) != null ? _a2 : getDefaultHighlightColor()
  });
};
const getHighlightMarkFromNode = (node) => {
  var _a2;
  return node ? (_a2 = node.marks.filter(isHighlightMark)) == null ? void 0 : _a2[0] : void 0;
};
const unsetHighlight = () => ({
  commands,
  state,
  dispatch
}) => {
  commands.markAsAnnotation();
  if (isBlockSelection(state.selection)) {
    return unsetMarkInBlockSelection({
      state,
      dispatch,
      blockSelection: state.selection
    });
  } else {
    return unsetMarkInTextSelection({ state, dispatch });
  }
};
const unsetMarkInTextSelection = ({
  state,
  dispatch
}) => {
  const { tr } = state;
  const highlight2 = state.schema.marks[MarkTypes.HIGHLIGHT];
  tr.removeMark(state.selection.from, state.selection.to, highlight2);
  if (!isHighlightSplitted(state)) {
    dispatch == null ? void 0 : dispatch(tr);
    return true;
  }
  const $posBefore = tr.doc.resolve(tr.selection.from - 1);
  const highlightBefore = getMarkRange($posBefore, highlight2);
  if (!highlightBefore) {
    dispatch == null ? void 0 : dispatch(tr);
    return true;
  }
  const oldMark = getHighlightMarkFromNode(tr.selection.$from.nodeBefore);
  const updatedMark = highlight2.create({
    ...oldMark == null ? void 0 : oldMark.attrs,
    [MarkAttrsParams.HIGHLIGHT_NOTE]: void 0,
    [MarkAttrsParams.HIGHLIGHT_UUID]: generateRandomId()
  });
  tr.addMark(highlightBefore.from, highlightBefore.to, updatedMark);
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const isHighlightSplitted = (state) => {
  const nodeBefore = state.selection.$from.nodeBefore;
  const nodeAfter = state.selection.$to.nodeAfter;
  if (!nodeBefore || !nodeAfter)
    return false;
  const highlight2 = state.schema.marks[MarkTypes.HIGHLIGHT];
  return highlight2.isInSet(nodeAfter.marks) && highlight2.isInSet(nodeBefore.marks);
};
const unsetMarkInBlockSelection = ({
  state,
  dispatch,
  blockSelection
}) => {
  const { tr } = state;
  const schema = state.schema;
  const mark = schema.marks[MarkTypes.HIGHLIGHT];
  blockSelection.list().forEach((block) => {
    tr.doc.nodesBetween(block.from, block.to, (node, pos) => {
      if (isHighlightMarkAllowed(node) && mark.isInSet(node.marks))
        tr.removeMark(pos, pos + node.nodeSize, mark);
    });
  });
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const getLazyColor = (hsl) => {
  let lightness = Math.floor(hsl.l), saturation = Math.floor(hsl.s), hue = Math.floor(hsl.h);
  if (saturation === 0 && hue === 0 && lightness >= 80)
    return;
  if (saturation <= 10 && lightness <= 70 || saturation === 0) {
    return "Gray";
  } else if (hue >= 0 && hue <= 15 || hue >= 346) {
    return "Red";
  } else if (hue >= 16 && hue <= 35) {
    if (saturation < 90) {
      return "Brown";
    } else {
      return "Orange";
    }
  } else if (hue >= 36 && hue <= 54) {
    if (saturation < 90) {
      return "Brown";
    } else {
      return "Yellow";
    }
  } else if (hue >= 55 && hue <= 165) {
    return "Green";
  } else if (hue >= 166 && hue <= 260) {
    return "Blue";
  } else if (hue >= 261 && hue <= 290) {
    return "Purple";
  } else if (hue >= 291 && hue <= 345) {
    return "Pink";
  }
  return;
};
const rgbToHsl = (rgbArr) => {
  let r1 = Number(rgbArr[0]) / 255, g1 = Number(rgbArr[1]) / 255, b1 = Number(rgbArr[2]) / 255;
  let maxColor = Math.max(r1, g1, b1), minColor = Math.min(r1, g1, b1);
  let L = (maxColor + minColor) / 2, S = 0, H = 0;
  if (maxColor !== minColor) {
    if (L < 0.5) {
      S = (maxColor - minColor) / (maxColor + minColor);
    } else {
      S = (maxColor - minColor) / (2 - maxColor - minColor);
    }
    if (r1 === maxColor) {
      H = (g1 - b1) / (maxColor - minColor);
    } else if (g1 === maxColor) {
      H = 2 + (b1 - r1) / (maxColor - minColor);
    } else {
      H = 4 + (r1 - g1) / (maxColor - minColor);
    }
  }
  L = L * 100;
  S = S * 100;
  H = H * 60;
  if (H < 0) {
    H += 360;
  }
  return { h: H, s: S, l: L };
};
const EVERNOTE_HIGHLIGHT = "span[data-highlight]";
const isSpanFromTwitter = (htmlNode) => htmlNode.style.fontFamily.includes("TwitterChirp");
const highlightParseRules = () => [
  { tag: "highlight" },
  {
    tag: EVERNOTE_HIGHLIGHT,
    priority: 55,
    getAttrs: (node) => {
      const htmlNode = node;
      const color = htmlNode.getAttribute("data-highlight");
      const colorTranslation = GroupHighlightColors.find(
        (item) => item.title.toLowerCase() === color
      );
      if (!colorTranslation)
        return false;
      htmlNode.setAttribute(
        "style",
        `background-color: ${colorTranslation.color};`
      );
      return {
        type: MarkTypes.HIGHLIGHT,
        highlightId: generateRandomId(),
        color: colorTranslation.color
      };
    }
  },
  {
    tag: "span",
    style: "background-color",
    priority: 55,
    getAttrs: (node) => {
      let htmlNode = node;
      const color = htmlNode.style.backgroundColor;
      if (isSpanFromTwitter(htmlNode))
        return false;
      const rgb = color.replace(/[^0-9,]/g, "").split(",");
      const nameColor = getLazyColor(rgbToHsl(rgb));
      const colorTranslation = GroupHighlightColors.find(
        (item) => item.title === nameColor
      );
      if (!colorTranslation)
        return false;
      return {
        type: MarkTypes.HIGHLIGHT,
        highlightId: generateRandomId(),
        color: colorTranslation.color
      };
    }
  }
];
const inputRegex = /(?:^|\s)((?:==)((?:[^~]+))(?:==))$/gm;
const pasteRegex = /(?:^|\s)((?:==)((?:[^~]+))(?:==))/gm;
const pasteRegexForRoam = /(?:^|\s)((?:\^\^)((?:[^~]+))(?:\^\^))/gm;
const HighlightMark = Mark.create({
  priority: 1e5,
  name: MarkTypes.HIGHLIGHT,
  addAttributes() {
    return {
      [MarkAttrsParams.HIGHLIGHT_UUID]: {
        default: void 0,
        keepOnSplit: true
      },
      [MarkAttrsParams.HIGHLIGHT_NOTE]: {
        default: void 0,
        keepOnSplit: true,
        rendered: false
      },
      [MarkAttrsParams.HIGHLIGHT_COLOR]: {
        default: void 0,
        parseHTML: (element) => element.getAttribute("data-color") || element.style.backgroundColor,
        renderHTML: (attributes) => attributes.color && {
          "data-color": attributes.color,
          style: `background-color: ${attributes.color}`
        }
      }
    };
  },
  parseHTML() {
    return highlightParseRules();
  },
  renderHTML({ HTMLAttributes }) {
    return ["highlight", mergeAttributes(HTMLAttributes), 0];
  },
  addPasteRules() {
    return [
      markPasteRule({ find: pasteRegex, type: this.type }),
      markPasteRule({ find: pasteRegexForRoam, type: this.type })
    ];
  },
  addInputRules() {
    return [
      markInputRule({
        find: inputRegex,
        type: this.type,
        getAttributes: () => ({
          [MarkAttrsParams.HIGHLIGHT_UUID]: generateRandomId()
        })
      })
    ];
  },
  addCommands() {
    return {
      setHighlight,
      toggleHighlight,
      unsetHighlight,
      insertBlockquoteInHighlight
    };
  }
});
const getHighlightIdFromNode = (node) => {
  var _a2;
  return isHighlightMarkAllowed(node) ? (_a2 = getHighlightMarkFromNode(node)) == null ? void 0 : _a2.attrs[MarkAttrsParams.HIGHLIGHT_UUID] : node == null ? void 0 : node.attrs[BlockAttrsParams.HIGHLIGHT_UUID];
};
const getNoteFromHighlight = (highlight2) => {
  var _a2;
  if (((_a2 = highlight2.lastChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.HIGHLIGHT_NOTE && highlight2.lastChild.lastChild) {
    return highlight2.lastChild.toJSON();
  } else {
    return void 0;
  }
};
const generateSearchIndex = (clip) => {
  const clipContentTextNodes = extractTextNodes(clip);
  const clipContentImageNodes = extractImageNodes(clip);
  const searchableClipText = new Fuse(clipContentTextNodes, {
    includeMatches: true,
    ignoreLocation: true,
    threshold: 0.1,
    keys: ["node.textContent"]
  });
  const searchableClipImages = new Fuse(clipContentImageNodes, {
    includeMatches: true,
    ignoreLocation: true,
    threshold: 0,
    keys: ["node.attrs.src"]
  });
  return {
    searchableClipImages,
    searchableClipText
  };
};
const extractTextNodes = (clip) => {
  const textNodes = [];
  clip.node.content.nodesBetween(0, clip.node.content.size, (node, pos) => {
    if (node.type.name === SeshatNodes.CONTENT) {
      textNodes.push({ node, pos: clip.pos + pos });
    }
  });
  return textNodes;
};
const extractImageNodes = (clip) => {
  const imageNodes = [];
  clip.node.content.nodesBetween(0, clip.node.content.size, (node, pos) => {
    if (node.type.name === SeshatInlineNodes.EXTERNAL_IMAGE) {
      imageNodes.push({ node, pos: clip.pos + pos });
    }
  });
  return imageNodes;
};
const highlightMatchingClipContent = ({
  tr,
  searchableClipText,
  searchableClipImages,
  blockquote,
  highlightNote,
  highlight: highlight2
}) => {
  let newTr = tr;
  let matched = false;
  blockquote.node.content.forEach((childNode) => {
    const imageNode = getNestedImageNode(childNode);
    if (imageNode) {
      const updated = highlighters.highlightImageNode({
        tr: newTr,
        searchableClipImages,
        imageNode,
        highlight: highlight2,
        highlightNote
      });
      newTr = updated.tr;
      matched = updated.matched;
    } else {
      const updated = highlighters.replaceAndHighlightTextNode({
        tr: newTr,
        blockNode: childNode,
        searchableClipText,
        highlight: highlight2,
        highlightNote
      });
      newTr = updated.tr;
      matched = updated.matched;
    }
  });
  return { newTr, matched };
};
const isImageNode = (node) => node.type.name === SeshatInlineNodes.EXTERNAL_IMAGE;
const getNestedImageNode = (node) => {
  let imageNode;
  node.nodesBetween(0, node.content.size, (node2, _, parent) => {
    var _a2;
    if (!isImageNode(node2) || ((_a2 = parent == null ? void 0 : parent.childCount) != null ? _a2 : 0) > 1)
      return;
    imageNode = node2;
  });
  return imageNode;
};
const replaceAndHighlightTextNode = ({
  tr,
  searchableClipText,
  blockNode,
  highlight: highlight2,
  highlightNote
}) => {
  const searchResult = searchableClipText.search(blockNode.textContent);
  if (!searchResult.length)
    return { tr, matched: false };
  const {
    node: foundClipContentNode,
    pos: foundClipContentPos
  } = searchResult[0].item;
  const blockquoteContent = blockNode.slice(
    SESHAT_CONTENT_DEPTH,
    blockNode.content.size - SESHAT_CONTENT_DEPTH
  );
  const offset = findSubstringOffset(
    foundClipContentNode.textContent,
    blockNode.textContent
  );
  if (!offset)
    return { tr, matched: false };
  const diff2 = blockquoteContent.size - (offset.end - offset.start);
  const clipNodeContentStart = foundClipContentPos + SESHAT_CONTENT_DEPTH;
  const replacedContentStart = clipNodeContentStart + offset.start;
  const replacedContentEnd = clipNodeContentStart + offset.end;
  tr.replace(replacedContentStart, replacedContentEnd, blockquoteContent);
  tr.addMark(replacedContentStart, replacedContentEnd + diff2, highlight2);
  if (highlightNote)
    tr.delete(
      highlightNote.pos,
      highlightNote.pos + highlightNote.node.nodeSize
    );
  return { tr, matched: true };
};
const hasSrc = (node, src) => node.attrs.src === src;
const highlightImageNode = ({
  tr,
  searchableClipImages,
  imageNode,
  highlight: highlight2,
  highlightNote
}) => {
  const imgSrc = imageNode.attrs.src;
  const searchResult = searchableClipImages.search(imgSrc);
  if (!searchResult.length)
    return { tr, matched: false };
  const imagesWithSrc = findChildren(tr.doc, (node2) => hasSrc(node2, imgSrc));
  const updatedClipImageNode = imagesWithSrc.filter(
    (node2) => !getNearestHighlightBlock(tr.doc.resolve(node2.pos))
  );
  if (!updatedClipImageNode.length)
    return { tr, matched: false };
  const { node, pos } = updatedClipImageNode == null ? void 0 : updatedClipImageNode[0];
  tr.addMark(pos, pos + node.nodeSize, highlight2);
  if (highlightNote)
    tr.delete(
      highlightNote.pos,
      highlightNote.pos + highlightNote.node.nodeSize
    );
  return { tr, matched: true };
};
const highlighters = {
  highlightImageNode,
  replaceAndHighlightTextNode
};
const matchHighlightsWithClipContent = () => ({
  state,
  dispatch,
  tr
}) => {
  dispatch == null ? void 0 : dispatch(matchHighlightsWithClipContentTransaction({ tr, state }));
  return false;
};
const matchHighlightsWithClipContentTransaction = ({
  tr,
  state
}) => {
  var _a2, _b2;
  const { schema } = state;
  const clip = (_a2 = findChildren(tr.doc, isClipContent)) == null ? void 0 : _a2[0];
  const highlightsBlock = (_b2 = findChildren(tr.doc, isHighlightsBlock$2)) == null ? void 0 : _b2[0];
  if (!clip || !highlightsBlock)
    return tr;
  if (clip && isClipWithAttributesSync(clip.node))
    return addHighlightsInHighlightsAttributeTransaction({ state, tr });
  const { searchableClipImages, searchableClipText } = generateSearchIndex(
    clip
  );
  const mappingBlockIdHighlightId = {};
  highlightsBlock.node.content.forEach((node) => {
    var _a3, _b3, _c2;
    const blockId = node.attrs[BlockAttrsParams.BLOCK_UUID];
    const highlightBlock = getSeshatBlockByBlockId(tr.doc, blockId);
    if (!highlightBlock)
      return;
    let highlightId = getHighlightIdFromClip(clip.node, highlightBlock.node);
    if (highlightId) {
      mappingBlockIdHighlightId[blockId] = highlightId;
      return;
    }
    const blockquote = (_a3 = findChildren(highlightBlock.node, isBlockquote)) == null ? void 0 : _a3[0];
    const note = (_b3 = findChildren(highlightBlock.node, isHighlightNote$1)) == null ? void 0 : _b3[0];
    highlightId = (_c2 = getHighlightIdFromNode(highlightBlock.node)) != null ? _c2 : generateRandomId();
    let { newTr, matched } = highlightMatchingClipContent({
      tr,
      searchableClipText,
      searchableClipImages,
      blockquote,
      highlight: schema.marks[MarkTypes.HIGHLIGHT].create({
        [MarkAttrsParams.HIGHLIGHT_UUID]: highlightId,
        [MarkAttrsParams.HIGHLIGHT_COLOR]: getDefaultHighlightColor(),
        [MarkAttrsParams.HIGHLIGHT_NOTE]: note ? note.node.toJSON() : void 0
      })
    });
    tr = newTr;
    if (matched) {
      mappingBlockIdHighlightId[blockId] = highlightId;
      tr.setNodeMarkup(highlightBlock.pos, void 0, {
        ...highlightBlock.node.attrs,
        highlightId
      });
    } else {
      tr = turnHighlightIntoBlockquote({ tr, schema, block: highlightBlock });
    }
  });
  const didHighlightsMatch = Object.values(mappingBlockIdHighlightId).some(
    (highlightId) => highlightId !== void 0
  );
  if (didHighlightsMatch && !hasConnectedClip(highlightsBlock.node)) {
    tr.setNodeMarkup(highlightsBlock.pos, void 0, {
      ...highlightsBlock.node.attrs,
      connectedClip: clip.node.attrs[BlockAttrsParams.BLOCK_UUID]
    });
  }
  if (didHighlightsMatch && !!clip.node.attrs.highlights) {
    tr.setNodeMarkup(clip.pos, void 0, {
      ...clip.node.attrs,
      highlights: void 0
    });
  }
  return tr.setMeta(IgnoreContentEditableFalse, true);
};
const isHighlightsBlock$2 = (node) => node.attrs.type === BlockTypes.HIGHLIGHTS;
const isClipContent = (node) => node.attrs.type === BlockTypes.CLIP_CONTENT;
const isBlockquote = (node) => node.attrs.type === BlockTypes.BLOCKQUOTE;
const isHighlightNote$1 = (node) => node.attrs.type === BlockTypes.HIGHLIGHT_NOTE;
const hasConnectedClip = (highlightsBlock) => !!highlightsBlock.attrs.connectedClip;
const getHighlightIdFromClip = (clip, highlight2) => {
  const highlightId = highlight2.attrs[BlockAttrsParams.HIGHLIGHT_UUID];
  if (!highlightId)
    return void 0;
  const clipContentHighlights = findChildren(clip, (node) => {
    const highlightMark = getHighlightMarkFromNode(node);
    return (highlightMark == null ? void 0 : highlightMark.attrs[MarkAttrsParams.HIGHLIGHT_UUID]) === highlightId;
  });
  return !!clipContentHighlights.length ? highlightId : void 0;
};
const turnHighlightIntoBlockquote = ({
  tr,
  block,
  schema
}) => {
  const blockquote = tr.doc.slice(
    block.pos + 1,
    block.pos + block.node.firstChild.nodeSize
  ).content;
  const note = getNoteFromHighlight(block.node);
  const noteContent = note ? Node.fromJSON(schema, note).content.content : void 0;
  const $highlight = tr.doc.resolve(block.pos);
  tr.insert(
    $highlight.after(),
    Fragment.fromArray([...blockquote.content, ...noteContent != null ? noteContent : []])
  );
  tr.delete(block.pos, block.pos + block.node.nodeSize);
  return tr;
};
const setClipContentStatus = ({
  attrs,
  scrollIntoView = true
}) => ({ commands, tr }) => {
  const result = getClipContent(tr.doc);
  if (!result)
    return false;
  const { node: seshatBlock, pos } = result;
  commands.updateBlockAttributesAt({
    pos,
    attrs: {
      ...seshatBlock.attrs,
      ...attrs
    },
    scrollIntoView
  });
  return true;
};
const CLIP_CONTENT_FIRST_POSITION_DEEP$1 = SESHAT_CONTENT_DEPTH + 2;
const toggleClipContentEditable = () => ({ chain, tr }) => {
  const result = getCurrentBlock(
    tr.doc,
    tr.selection.from,
    (node) => node.attrs.type === BlockTypes.CLIP_CONTENT
  );
  if (!result)
    return false;
  const { node: seshatBlock, from: editAttrPos } = result;
  const currentContentEditableStatus = seshatBlock.attrs.contentEditable;
  chain().updateBlockAttributesAt({
    pos: editAttrPos,
    attrs: {
      ...seshatBlock.attrs,
      contentEditable: !currentContentEditableStatus
    },
    scrollIntoView: true
  });
  if (!currentContentEditableStatus)
    chain().unsetBlockSelection().focus(editAttrPos + CLIP_CONTENT_FIRST_POSITION_DEEP$1);
  else
    chain().focus(editAttrPos).selectCurrentBlock();
  chain().scrollIntoView().run();
  return true;
};
const isClipContentEditableFalse = (node) => node.attrs.type === BlockTypes.CLIP_CONTENT && node.attrs.contentEditable === false;
const CLIP_CONTENT_FIRST_POSITION_DEEP = SESHAT_CONTENT_DEPTH + 2;
const turnClipContentToEditableTrueOnSelection = () => ({
  state,
  chain
}) => {
  if (!isBlockSelection(state.selection) || state.selection.list().length !== 1) {
    return false;
  }
  const node = state.selection.firstBlock().node;
  if (!(node && isClipContentEditableFalse(node)))
    return false;
  chain().updateBlockAttributesAt({
    pos: state.selection.from,
    attrs: {
      ...node.attrs,
      contentEditable: true
    },
    scrollIntoView: true
  }).unsetBlockSelection().focus(state.selection.from + CLIP_CONTENT_FIRST_POSITION_DEEP).scrollIntoView().run();
  return true;
};
const getSeshatBlockByBlockId = (doc, id) => {
  if (!id)
    return void 0;
  const blocks = findChildren(doc, (node) => {
    return node.attrs[BlockAttrsParams.BLOCK_UUID] === id;
  });
  return blocks.length ? blocks[0] : void 0;
};
const clipContentTitleObserverKey = new PluginKey(
  "clipContentTitleObserverKey"
);
const clipContentTitleObserver = new Plugin({
  key: clipContentTitleObserverKey,
  appendTransaction(trs, _, newState) {
    const hasDocChanged = trs.some((tr2) => tr2.docChanged);
    if (!hasDocChanged)
      return;
    let { doc, tr } = newState;
    const clipIds = getTouchedClipIds(trs);
    clipIds.modified.forEach((clipId) => {
      const clip = getSeshatBlockByBlockId(doc, clipId);
      if (!clip)
        return;
      const firstBlock = clip.node.content.content[0];
      if ((firstBlock == null ? void 0 : firstBlock.attrs.type) === BlockTypes.HEADING_1) {
        const from = clip.pos + 1;
        const to = from + firstBlock.nodeSize;
        const clipContentTitle = createSeshatBlock({
          schema: newState.schema,
          content: firstBlock.textContent || "",
          attrs: { type: BlockTypes.CLIP_CONTENT_TITLE }
        });
        tr.replaceWith(from, to, clipContentTitle);
      }
    });
    return tr;
  }
});
const handleEnterOnSelectedClip = ({
  editor,
  goToClip
}) => {
  var _a2, _b2;
  if (!goToClip)
    return false;
  const node = (_b2 = (_a2 = editor.state) == null ? void 0 : _a2.selection) == null ? void 0 : _b2.$from.nodeAfter;
  const blockId = node == null ? void 0 : node.attrs[BlockAttrsParams.BLOCK_UUID];
  if (!blockId || node.attrs.type !== BlockTypes.CLIP_CONTENT || node.attrs.status !== CardClipStatus.LATER)
    return false;
  goToClip(blockId);
  return true;
};
const ClipContentBlock = (options) => Extension$1.create({
  name: BlockTypes.CLIP_CONTENT,
  addCommands() {
    return {
      addHighlightsInHighlightsAttribute,
      matchHighlightsWithClipContent,
      insertClip,
      turnClipContentToEditableTrueOnSelection,
      toggleClipContentEditable,
      insertClipVideo,
      insertClipTitle,
      setClipContentStatus
    };
  },
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        var _a2, _b2;
        return handleEnterOnSelectedClip({
          editor,
          goToClip: (_b2 = (_a2 = options == null ? void 0 : options.clip) == null ? void 0 : _a2.content) == null ? void 0 : _b2.goToClip
        });
      },
      t: () => this.editor.commands.turnClipContentToEditableTrueOnSelection()
    };
  },
  addProseMirrorPlugins() {
    return [clipContentTitleObserver];
  }
});
const getClipContent = (doc) => {
  var _a2;
  return (_a2 = findChildren(
    doc,
    (node) => node.attrs.type === BlockTypes.CLIP_CONTENT
  )) == null ? void 0 : _a2[0];
};
const isEmptyClip = (node) => node.attrs.type === BlockTypes.CLIP_CONTENT && !!!node.textContent && node.nodeSize === 8;
const isCaretInEmptyClip = (state) => {
  const { $anchor } = state.selection;
  return $anchor.depth >= 5 && isEmptyClip($anchor.node($anchor.depth - 3));
};
function getClipContentBlock({
  pos,
  doc
}) {
  const block = getCurrentBlock(doc, pos);
  if (!block)
    return void 0;
  if (block.node.attrs.type === BlockTypes.CLIP_CONTENT) {
    return block.node;
  }
  const ancestor = doc.resolve(pos).node(block.depth - 1);
  if ((ancestor == null ? void 0 : ancestor.attrs.type) === BlockTypes.CLIP_CONTENT) {
    return ancestor;
  }
  return void 0;
}
const maybeAddMissingMarksInClipContent = ({
  tr,
  clipId
}) => {
  const highlights = getHighlightsFromClipContent({ doc: tr.doc, clipId });
  if (!highlights)
    return tr;
  highlights.forEach((highlight2) => {
    tr.doc.nodesBetween(highlight2.from, highlight2.to, (node, pos) => {
      if (!isHighlightMarkAllowed(node) || getHighlightMarkFromNode(node))
        return;
      const previousNode = tr.doc.nodeAt(highlight2.from);
      const mark = getHighlightMarkFromNode(previousNode);
      if (mark)
        tr.addMark(pos, pos + node.nodeSize, mark);
    });
  });
  return tr;
};
const getHighlightsBlocksFromDoc = (doc) => {
  return findChildren(doc, isHighlightsBlockNode).map(
    (node) => NodeSelection.create(doc, node.pos)
  );
};
const isHighlightsBlockNode = (node) => node.attrs.type === BlockTypes.HIGHLIGHTS;
const createHighlightsBlock = ({
  doc,
  schema,
  clip
}) => {
  if (!clip || isClipAlreadyConnected({ doc, clip: clip.node }))
    return createHighlightsBlockNode({ schema, content: void 0 });
  const clipId = clip.node.attrs[BlockAttrsParams.BLOCK_UUID];
  if (clip.node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOK) {
    const kindleHighlights = getHighlightsFromClipBook(clip.node);
    return createHighlightsBlockNode({
      schema,
      connectedClipId: clipId,
      content: kindleHighlights ? createHighlightsFromKindleHighlights({
        schema,
        kindleHighlights
      }) : void 0
    });
  }
  if (clip.node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOKMARK) {
    return createHighlightsBlockFromClipBookmark({
      schema,
      clip: clip.node
    });
  }
  if (clip.node.attrs.type === BlockTypes.CLIP_CONTENT) {
    return createHighlightsBlockNode({
      schema,
      connectedClipId: clipId,
      content: isClipWithAttributesSync(clip.node) ? createHighlightsFromPaywallClipContent({ schema, clip: clip.node }) : createHighlightsFromClipContent({ doc, schema, clipId })
    });
  }
  return createHighlightsBlockNode({ schema, content: void 0 });
};
const createHighlightsBlockNode = ({
  schema,
  connectedClipId,
  content
}) => {
  return schema.nodes[SeshatNodes.WRAPPING_BLOCK].create(
    {
      type: BlockTypes.HIGHLIGHTS,
      connectedClip: connectedClipId,
      collapsed: false
    },
    content
  );
};
const isClipAlreadyConnected = ({
  doc,
  clip
}) => {
  if (!clip)
    return false;
  const highlightsBlocks = getHighlightsBlocksFromDoc(doc);
  return highlightsBlocks.some(
    (highlightsBlock) => highlightsBlock.node.attrs.connectedClip === clip.attrs[BlockAttrsParams.BLOCK_UUID]
  );
};
const insertHighlightsBlock = ({
  pos,
  collapsed
} = {}) => ({ dispatch, state }) => dispatch == null ? void 0 : dispatch(insertHighlightsBlockHelper({ state, pos, collapsed }));
const insertHighlightsBlockHelper = ({
  state,
  existingTr,
  pos,
  collapsed
}) => {
  var _a2;
  let newTr = existingTr != null ? existingTr : state.tr;
  const { $from } = newTr.selection;
  let insertPos = pos;
  if (!insertPos) {
    const block = getCurrentBlock(newTr.doc, $from.pos);
    if (block && isSeshatBlockEmpty(block.node)) {
      newTr = deleteBlockTransaction({ tr: newTr });
      insertPos = $from.start(block.depth) - 1;
    } else {
      insertPos = $from.end((_a2 = block == null ? void 0 : block.depth) != null ? _a2 : 0) + 1;
    }
  }
  return insertHighlightsBlockTransaction({
    state,
    tr: newTr,
    pos: insertPos,
    selection: state.selection,
    collapsed
  });
};
const getInsertPos = ({
  pos,
  clip,
  $from
}) => {
  if (pos)
    return pos;
  if (clip)
    return clip.pos;
  return $from.pos;
};
const insertHighlightsBlockTransaction = ({
  tr,
  state,
  pos,
  selection,
  collapsed
}) => {
  const { schema } = state;
  const { $from } = selection;
  const clip = getNearestClip({ doc: tr.doc, from: pos != null ? pos : $from.pos });
  if (clip && isClipAlreadyConnected({ doc: tr.doc, clip: clip.node }))
    return tr;
  const highlightsBlock = createHighlightsBlock({ doc: tr.doc, schema, clip });
  if (!highlightsBlock)
    return tr;
  let insertPos = getInsertPos({ pos, clip, $from });
  tr.insert(insertPos, highlightsBlock);
  if (collapsed)
    tr.setNodeMarkup(insertPos, void 0, {
      ...highlightsBlock.attrs,
      collapsed: true
    });
  tr.removeMark(
    insertPos,
    insertPos + highlightsBlock.nodeSize,
    schema.marks[MarkTypes.HIGHLIGHT]
  );
  let caretPos = insertPos;
  if (!!highlightsBlock.childCount) {
    caretPos = insertPos + highlightsBlock.content.size - SESHAT_CONTENT_DEPTH - 2;
  }
  tr = setCaretNearbyTransaction({ state, tr, pos: caretPos });
  return tr.setMeta(highlightsBlocksObserverPluginKey, true);
};
const liftBlockOutOfHighlights = () => ({ state, chain }) => {
  const { doc, selection } = state.tr;
  const blockSelection = BlockSelection.createFromPosition(doc, selection.from);
  const block = blockSelection.firstBlock();
  const highlightsBlock = findAncestor(selection.$from, isHighlightsBlock$1);
  if (!highlightsBlock)
    return false;
  const insertPos = selection.$from.after(highlightsBlock.depth);
  return chain().insertContentAt(insertPos, generateEmptyBlock(block.node.attrs)).focus(insertPos + SESHAT_CONTENT_DEPTH + 1).deleteRange({ from: block.from - 1, to: block.to + 1 }).run();
};
const isHighlightsBlock$1 = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHTS;
const removeOrphanHighlightsBlock = () => ({
  state,
  tr,
  dispatch
}) => {
  const highlightsBlocks = findChildren(
    state.doc,
    (node) => node.attrs.type === BlockTypes.HIGHLIGHTS
  );
  highlightsBlocks.forEach(({ node, pos }) => {
    const connectedClipId = node.attrs.connectedClip;
    if (!connectedClipId)
      return;
    const connectedClip = getSeshatBlockByBlockId(state.doc, connectedClipId);
    if (!connectedClip) {
      tr.deleteRange(pos, pos + node.nodeSize);
    }
  });
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const getClipsFromDoc = (doc) => {
  return findChildren(doc, isSeshatBlockClip).map(
    (node) => NodeSelection.create(doc, node.pos)
  );
};
const getConnectedHighlightsBlockByClipId = (doc, clipId) => {
  if (!clipId)
    return void 0;
  const blocks = findChildren(doc, (node) => {
    return !!clipId && node.attrs.connectedClip === clipId;
  });
  return blocks.length ? blocks[0] : void 0;
};
const syncHighlightsBlocksAfterClipModification = () => ({
  state,
  tr,
  dispatch
}) => {
  const clips = getClipsFromDoc(tr.doc).map(
    (clip) => {
      var _a2;
      return (_a2 = clip.node.attrs) == null ? void 0 : _a2[BlockAttrsParams.BLOCK_UUID];
    }
  );
  dispatch == null ? void 0 : dispatch(
    syncHighlightsBlocksAfterClipModificationTransaction({
      state,
      modifiedClips: clips
    })
  );
  return true;
};
const syncHighlightsBlocksAfterClipModificationTransaction = ({
  state,
  initialSelection,
  modifiedClips
}) => {
  let { tr, schema } = state;
  modifiedClips.forEach((clipId) => {
    const clip = getSeshatBlockByBlockId(tr.doc, clipId);
    let block = getConnectedHighlightsBlockByClipId(tr.doc, clipId);
    if (!clip)
      return;
    let highlights;
    if (clip.node.attrs.type === BlockTypes.CLIP_CONTENT) {
      if (isClipWithAttributesSync(clip.node))
        return;
      tr = maybeAddMissingMarksInClipContent({ tr, clipId });
      highlights = createHighlightsFromClipContent({
        doc: tr.doc,
        schema,
        clipId
      });
      const isFirstHighlightAndNotHighlightsBlock = !block && (highlights == null ? void 0 : highlights.length) === 1;
      if (isFirstHighlightAndNotHighlightsBlock) {
        tr = insertHighlightsBlockTransaction({
          tr,
          state,
          selection: tr.selection,
          pos: clip.pos
        });
        block = getConnectedHighlightsBlockByClipId(tr.doc, clipId);
      }
    } else if (clip.node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOK && block) {
      const newHighlightsNodes = createNewHighlightsFromKindleHighlights({
        schema,
        block,
        clip
      });
      if (newHighlightsNodes) {
        highlights = [...block.node.content.content, ...newHighlightsNodes];
      }
    }
    if (!block)
      return;
    const wrappedContentStart = block.pos + 1;
    const wrappedContentEnd = block.pos + block.node.nodeSize - 1;
    const filteredHighlights = highlights == null ? void 0 : highlights.filter((h) => !isEmptyHighlight(h));
    const newContent = filteredHighlights ? new Slice(Fragment.from(filteredHighlights), 0, 0) : void 0;
    tr.replace(wrappedContentStart, wrappedContentEnd, newContent);
    if (newContent)
      tr.removeMark(
        wrappedContentStart,
        wrappedContentStart + newContent.size,
        schema.marks[MarkTypes.HIGHLIGHT]
      );
  });
  if (initialSelection)
    tr.setSelection(initialSelection.map(tr.doc, tr.mapping));
  tr.setMeta(clipObserverPluginKey, true);
  tr.setMeta(IgnoreContentEditableFalse, true);
  return tr;
};
const isEmptyHighlight = (node) => {
  const EMPTY_SESHAT_BLOCK_SIZE = 6;
  const HIGHLIGHT_WRAPPER_SIZE = 4;
  return node.nodeSize <= EMPTY_SESHAT_BLOCK_SIZE + HIGHLIGHT_WRAPPER_SIZE;
};
const turnHighlightsBlocksIntoBlockquotes = () => ({
  state,
  dispatch
}) => {
  let tr = unwrapHighlightsBlock(state.tr);
  if (!tr)
    return false;
  tr = unwrapHighlightNote(tr);
  if (!tr)
    return false;
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const unwrapHighlightsBlock = (tr) => {
  const { selection } = tr;
  const highlightsBlock = findAncestor(selection.$from, isHighlightsBlock);
  if (!highlightsBlock)
    return false;
  const startPos = selection.$from.before(highlightsBlock.depth + 1) + 1;
  const endPos = selection.$from.end(highlightsBlock.depth + 1) - 1;
  const range = tr.doc.resolve(startPos).blockRange(tr.doc.resolve(endPos));
  if (!range)
    return false;
  return tr.lift(range, 1);
};
const unwrapHighlightNote = (tr) => {
  const [highlightNoteWithPos] = findChildren(tr.doc, isHighlightNote);
  if (!highlightNoteWithPos)
    return false;
  const { pos, node } = highlightNoteWithPos;
  const startPos = pos + SESHAT_CONTENT_DEPTH;
  const endPos = startPos + node.nodeSize - SESHAT_CONTENT_DEPTH - 1;
  const range = tr.doc.resolve(startPos).blockRange(tr.doc.resolve(endPos));
  if (!range)
    return false;
  return tr.lift(range, 1);
};
const isHighlightsBlock = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHTS;
const isHighlightNote = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHT_NOTE;
const turnHighlightsBlockHighlightsIntoBlockquotes = ({
  state,
  removedClips
}) => {
  let { tr, doc } = state;
  removedClips.forEach((clipId) => {
    const block = getConnectedHighlightsBlockByClipId(doc, clipId);
    if (!block)
      return;
    const $block = NodeSelection.create(doc, block.pos);
    const { content: highlightBlockNodes } = $block.node;
    tr = removeWrappingBlock({
      tr,
      blockStart: $block.$from.pos,
      blockEnd: $block.$to.pos,
      content: highlightBlockNodes
    });
    let removedWrappersCount = 0;
    highlightBlockNodes.forEach((node, parentOffset) => {
      var _a2;
      const deletedPosCount = removedWrappersCount * 2;
      const highlightStart = $block.$from.pos + parentOffset - deletedPosCount;
      const highlightEnd = highlightStart + node.nodeSize - 1;
      tr = removeWrappingBlock({
        tr,
        blockStart: highlightStart,
        blockEnd: highlightEnd,
        content: node.content
      });
      const blockquote = node.firstChild;
      const note = ((_a2 = node.lastChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.HIGHLIGHT_NOTE ? node.lastChild : void 0;
      if (blockquote && note) {
        removedWrappersCount++;
        tr = removeWrappingBlock({
          tr,
          blockStart: highlightStart + blockquote.nodeSize,
          blockEnd: highlightEnd,
          content: note.content
        });
      }
      removedWrappersCount++;
    });
  });
  return tr.setMeta(clipObserverPluginKey, true);
};
const removeWrappingBlock = ({
  tr,
  blockStart,
  blockEnd,
  content
}) => tr.replace(blockStart, blockEnd, new Slice(content, 0, 0));
const getTouchedClipIds = (trs) => {
  const clipIds = {
    removed: [],
    modified: []
  };
  trs.forEach((tr) => {
    if (wasTransactionDispatchedBySyncPlugin(tr))
      return;
    if (wasTransactionDispatchedByBlockIdPlugin(tr))
      return;
    if (wasTransactionDispatchedByMentionPlugin(tr))
      return;
    tr.steps.forEach((step, i) => {
      const doc = tr.docs.length && tr.docs[i];
      if (!doc || !isModificationStep(step))
        return;
      const clips = getClipsFromDoc(doc);
      clips.forEach((clip) => {
        const clipId = clip.node.attrs[BlockAttrsParams.BLOCK_UUID];
        if (!clipId)
          return;
        if (isModificationWithinNode(clip, step) && !clipIds.modified.includes(clipId))
          clipIds.modified.push(clipId);
        if (isReplacementAcrossNode(clip, step) && !clipIds.removed.includes(clipId))
          clipIds.removed.push(clipId);
      });
    });
  });
  return clipIds;
};
const isUndoAction = (trs) => {
  return trs.some((tr) => {
    var _a2;
    return ((_a2 = tr.getMeta("history$")) == null ? void 0 : _a2.redo) === false;
  });
};
const clipObserverPlugin = new Plugin({
  key: clipObserverPluginKey,
  appendTransaction(trs, _, state) {
    var _a2;
    const hasDocChanged = trs.some((tr) => tr.docChanged);
    if (!hasDocChanged || isUndoAction(trs))
      return;
    const clipIds = getTouchedClipIds(trs);
    if (clipIds.removed.length) {
      return turnHighlightsBlockHighlightsIntoBlockquotes({
        state,
        removedClips: clipIds.removed
      });
    }
    if (clipIds.modified.length) {
      return syncHighlightsBlocksAfterClipModificationTransaction({
        state,
        initialSelection: (_a2 = trs == null ? void 0 : trs[0]) == null ? void 0 : _a2.selection,
        modifiedClips: clipIds.modified
      });
    }
    return;
  }
});
const getBlockquoteContentFromHighlight = (highlight2) => {
  var _a2;
  if (((_a2 = highlight2.firstChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.BLOCKQUOTE && highlight2.firstChild.firstChild) {
    const startOfBlockquoteContent = SESHAT_CONTENT_DEPTH * 2;
    const endOfBlockquoteContent = highlight2.firstChild.nodeSize - SESHAT_CONTENT_DEPTH * 2;
    return highlight2.slice(startOfBlockquoteContent, endOfBlockquoteContent);
  } else {
    return new Slice(Fragment.from(), 0, 0);
  }
};
const removeEmptyHighlightsFromHighlightsBlock = ({
  tr,
  highlightsBlock
}) => {
  if (!(highlightsBlock == null ? void 0 : highlightsBlock.node.content))
    return tr;
  let newTr = tr;
  highlightsBlock.node.content.forEach((highlight2, offset) => {
    if (hasVideoHighlighBlockquote(highlight2))
      return;
    const content = getBlockquoteContentFromHighlight(highlight2);
    if (content.size !== 0)
      return;
    const blockStart = highlightsBlock.pos + offset + 1;
    const blockEnd = blockStart + highlight2.nodeSize;
    newTr = newTr.delete(blockStart, blockEnd);
  });
  return newTr;
};
const hasVideoHighlighBlockquote = (highlight2) => {
  var _a2;
  return !!highlight2.attrs.timestamp && ((_a2 = highlight2.firstChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.BLOCKQUOTE;
};
const removeEmptyNotesFromHighlightsBlock = ({
  tr,
  highlightsBlock
}) => {
  if (!(highlightsBlock == null ? void 0 : highlightsBlock.node.content))
    return tr;
  let newTr = tr;
  let $rangesToDelete = [];
  highlightsBlock.node.content.forEach((highlight2, offset) => {
    var _a2, _b2;
    const hasNote = ((_a2 = highlight2.lastChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.HIGHLIGHT_NOTE;
    if (!hasNote)
      return;
    const hasNoteContent = (_b2 = highlight2.lastChild) == null ? void 0 : _b2.childCount;
    if (hasNoteContent)
      return;
    const blockquoteSize = highlight2.firstChild.nodeSize;
    const noteStart = highlightsBlock.pos + offset + blockquoteSize + 1;
    const noteEnd = noteStart + highlight2.lastChild.nodeSize;
    $rangesToDelete.push({
      $from: newTr.doc.resolve(noteStart),
      $to: newTr.doc.resolve(noteEnd)
    });
  });
  $rangesToDelete.forEach(($range) => {
    newTr.delete($range.$from.pos, $range.$to.pos);
  });
  return newTr;
};
const syncClipAfterHighlightsBlockModification = ({
  state,
  initialSelection,
  modifiedHighlightsBlocks
}) => {
  let { tr, schema } = state;
  modifiedHighlightsBlocks.forEach((blockId) => {
    let highlightsBlock = getSeshatBlockByBlockId(tr.doc, blockId);
    if (!highlightsBlock)
      return;
    tr = removeEmptyHighlightsFromHighlightsBlock({ tr, highlightsBlock });
    tr = removeEmptyNotesFromHighlightsBlock({ tr, highlightsBlock });
    const connectedClipId = highlightsBlock == null ? void 0 : highlightsBlock.node.attrs.connectedClip;
    if (!connectedClipId)
      return;
    const clip = getSeshatBlockByBlockId(tr.doc, connectedClipId);
    if (!clip)
      return;
    if (clip.node.attrs.type === BlockTypes.CLIP_CONTENT) {
      tr = isClipWithAttributesSync(clip.node) ? syncPaywallClipContent({ tr, highlightsBlock, clip }) : syncClipContent({ tr, schema, highlightsBlock, clip });
    }
    if (clip.node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOKMARK) {
      tr = syncClipBookmark({ tr, highlightsBlock, clip });
    }
    if (clip.node.attrs.nodeViewType === NodeViewTypes.CLIP_BOOK) {
      tr = syncClipBookmark({ tr, highlightsBlock, clip });
    }
  });
  if (initialSelection)
    tr.setSelection(initialSelection.map(tr.doc, tr.mapping));
  tr.setMeta(highlightsBlocksObserverPluginKey, true);
  tr.setMeta(IgnoreContentEditableFalse, true);
  return tr;
};
const getTouchedHighlightsBlockIds = (trs) => {
  const highlightsBlockIds = [];
  trs.forEach((tr) => {
    if (wasTransactionDispatchedBySyncPlugin(tr))
      return;
    if (wasTransactionDispatchedByBlockIdPlugin(tr))
      return;
    if (wasTransactionDispatchedByMentionPlugin(tr))
      return;
    tr.steps.forEach((step, i) => {
      const doc = tr.docs.length && tr.docs[i];
      if (!doc || !isModificationStep(step))
        return;
      const blocks = getHighlightsBlocksFromDoc(doc);
      blocks.forEach((block) => {
        if (isReplacementAcrossNode(block, step))
          return;
        const blockId = block.node.attrs[BlockAttrsParams.BLOCK_UUID];
        if (isModificationWithinNode(block, step) && !highlightsBlockIds.includes(blockId))
          highlightsBlockIds.push(blockId);
      });
    });
  });
  return highlightsBlockIds;
};
const highlightsBlocksObserverPlugin = new Plugin({
  key: highlightsBlocksObserverPluginKey,
  appendTransaction(trs, _, state) {
    var _a2;
    const hasDocChanged = trs.some((tr) => tr.docChanged);
    if (!hasDocChanged || isUndoAction(trs))
      return;
    const highlightsBlockIds = getTouchedHighlightsBlockIds(trs);
    if (highlightsBlockIds.length) {
      return syncClipAfterHighlightsBlockModification({
        state,
        initialSelection: (_a2 = trs == null ? void 0 : trs[0]) == null ? void 0 : _a2.selection,
        modifiedHighlightsBlocks: highlightsBlockIds
      });
    }
    return;
  }
});
const HighlightsBlock = Extension$1.create({
  name: BlockTypes.HIGHLIGHTS,
  addCommands() {
    return {
      insertHighlightsBlock,
      insertHighlightNote,
      removeOrphanHighlightsBlock,
      liftBlockOutOfHighlights,
      turnHighlightsBlocksIntoBlockquotes,
      syncHighlightsBlocksAfterClipModification
    };
  },
  addProseMirrorPlugins() {
    return [clipObserverPlugin, highlightsBlocksObserverPlugin];
  }
});
const isCaretWithinHighlightBlockquote = ($from) => {
  var _a2, _b2, _c2;
  const highlightBlock = getNearestHighlightBlock($from);
  if (!highlightBlock)
    return false;
  if (((_a2 = highlightBlock.node.lastChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.BLOCKQUOTE)
    return true;
  const highlightBlockStart = $from.start(highlightBlock.depth) + 1;
  const blockquoteSize = (_c2 = (_b2 = highlightBlock.node.firstChild) == null ? void 0 : _b2.content.size) != null ? _c2 : 0;
  const blockquoteEnd = highlightBlockStart + blockquoteSize;
  return highlightBlockStart <= $from.pos && $from.pos < blockquoteEnd;
};
const isCaretWithinHighlightNote = ($from) => {
  var _a2, _b2, _c2;
  const highlightBlock = getNearestHighlightBlock($from);
  if (!highlightBlock)
    return false;
  if (((_a2 = highlightBlock.node.lastChild) == null ? void 0 : _a2.attrs.type) === BlockTypes.BLOCKQUOTE)
    return false;
  const highlightBlockStart = $from.start(highlightBlock.depth) + 1;
  const highlightBlockEnd = $from.end(highlightBlock.depth) - 1;
  const blockquoteSize = (_c2 = (_b2 = highlightBlock.node.firstChild) == null ? void 0 : _b2.content.size) != null ? _c2 : 0;
  const noteStart = highlightBlockStart + blockquoteSize + 1;
  return noteStart <= $from.pos && $from.pos < highlightBlockEnd;
};
const isEmptyHighlightsBlock = (node) => {
  return (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHTS && node.childCount === 0;
};
const getClipByHrefAndEmpty = ({
  doc,
  from,
  href
}) => {
  for (let i = 0; i <= doc.nodeSize - SESHAT_CONTENT_DEPTH; i++) {
    const node = doc.nodeAt(i);
    if (isSeshatBlockClip$1({ node, href })) {
      return { node, pos: i };
    }
  }
  for (let i = from; i >= 0; i--) {
    const node = doc.nodeAt(i);
    if (isSeshatBlockClip$1({ node, href })) {
      return { node, pos: i };
    }
  }
  return void 0;
};
const isSeshatBlockClip$1 = ({
  node,
  href
}) => {
  var _a2;
  if ((node == null ? void 0 : node.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return false;
  if (!!node.textContent)
    return false;
  const nodeType = (_a2 = node == null ? void 0 : node.attrs.nodeViewType) != null ? _a2 : node == null ? void 0 : node.attrs.type;
  return nodeType && (node == null ? void 0 : node.attrs.href) === href && clipBlocks.includes(nodeType);
};
const isAtom = (node) => {
  if (!node)
    return false;
  return isEmptyHighlightsBlock(node) || isContentEditableFalse(node) || node.isAtom;
};
const isCardTitleNode = (resolvedPos) => {
  var _a2, _b2;
  const seshatBlock = getNearestSeshatBlockParentSelection({
    $from: resolvedPos
  });
  return seshatBlock.depth === 1 && ((_b2 = (_a2 = seshatBlock.node) == null ? void 0 : _a2.attrs) == null ? void 0 : _b2.type) === BlockTypes.CARD_CONTENT;
};
const hasSelectableText$1 = (node) => {
  var _a2;
  return !isAtom(node) && ((_a2 = node.firstChild) == null ? void 0 : _a2.type.name) === SeshatNodes.BLOCK_CONTENT;
};
const hasSelectableChildren$1 = (node) => {
  return node.type.spec.group === SeshatNodeGroups.BLOCK && !isAtom(node) && !node.attrs.collapsed;
};
const getForwardSeshatBlockContent = ({
  $from
}) => {
  const previousSibling = getShallowPreviousTarget({ $from });
  if (!previousSibling)
    return;
  let lastDeepPreviousTarget;
  $from.doc.nodesBetween(
    previousSibling.pos,
    previousSibling.pos + previousSibling.node.nodeSize,
    (node, pos, parent) => {
      if (node.type.name === SeshatNodes.BLOCK_CONTENT)
        return false;
      if (hasSelectableText$1(node)) {
        lastDeepPreviousTarget = {
          node: node.firstChild,
          pos: pos + 1,
          parentNode: node,
          textSelectable: true
        };
      } else {
        lastDeepPreviousTarget = {
          node,
          pos,
          parentNode: parent,
          textSelectable: false
        };
      }
      return hasSelectableChildren$1(node);
    }
  );
  return lastDeepPreviousTarget;
};
const getShallowPreviousTarget = ({ $from }) => {
  var _a2;
  let { depth } = getNearestSeshatBlockParentSelection({ $from });
  let currentParentNode;
  let currentTarget;
  let parentTargetPosition;
  let parentDepth = depth - 1;
  while (depth >= SESHAT_ROOT_DEPTH) {
    parentDepth = depth - 1;
    const seshatBlockNodeStart = $from.start(depth);
    currentParentNode = $from.node(parentDepth);
    const parentNodeStart = $from.start(parentDepth);
    let gap = 1;
    while (!currentTarget && !currentParentNode.attrs.collapsed) {
      const currentPreviousSibling = currentParentNode == null ? void 0 : currentParentNode.childBefore(
        seshatBlockNodeStart - parentNodeStart - gap
      );
      if (!currentPreviousSibling.node)
        break;
      currentTarget = currentPreviousSibling;
      parentTargetPosition = parentNodeStart;
      gap += (_a2 = currentPreviousSibling == null ? void 0 : currentPreviousSibling.node) == null ? void 0 : _a2.nodeSize;
    }
    depth--;
  }
  if ((currentTarget == null ? void 0 : currentTarget.node) && parentTargetPosition !== void 0) {
    return {
      node: currentTarget.node,
      pos: parentTargetPosition + currentTarget.offset
    };
  }
  return void 0;
};
const getDirectPreviousSibling = ({ $from }) => {
  const { depth } = getNearestSeshatBlockParentSelection({ $from });
  const seshatBlockNodeStart = $from.start(depth);
  let parentDepth = depth - 1;
  const parentNode = $from.node(parentDepth);
  const parentNodeStart = $from.start(parentDepth);
  const previousSibling = parentNode.childBefore(
    seshatBlockNodeStart - parentNodeStart - 1 || 0
  );
  return {
    node: previousSibling.node,
    pos: parentNodeStart + previousSibling.offset,
    parentNode
  };
};
const getPreviousSibling = ({
  $from
}) => {
  let previousSibling;
  let parentNodeStart;
  const { depth } = getNearestSeshatBlockParentSelection({ $from });
  const seshatBlockNodeStart = $from.start(depth);
  let parentDepth = depth - 1;
  while ((!(previousSibling == null ? void 0 : previousSibling.node) || parentNodeStart === void 0) && parentDepth >= 0) {
    const parentNode = $from.node(parentDepth != null ? parentDepth : 0);
    parentNodeStart = $from.start(parentDepth != null ? parentDepth : 0);
    previousSibling = parentNode.childBefore(
      seshatBlockNodeStart - (parentNodeStart != null ? parentNodeStart : 0) - 1 || 0
    );
    parentDepth -= 1;
  }
  return {
    node: previousSibling == null ? void 0 : previousSibling.node,
    offset: previousSibling == null ? void 0 : previousSibling.offset,
    index: previousSibling == null ? void 0 : previousSibling.index,
    parentNodeStart
  };
};
const getNodeFromPosition = (state, position) => {
  const $pos = state.doc.resolve(position);
  const { parent, parentOffset } = $pos;
  return { ...parent.childAfter(parentOffset), parentOffset };
};
const hasChildren = (node) => {
  return node.content.content.some(
    (childNode) => (childNode == null ? void 0 : childNode.type.spec.group) === SeshatNodeGroups.BLOCK
  );
};
const unsetBlockSelection = () => ({ state, tr, dispatch }) => {
  if (!isBlockSelection(state.selection))
    return false;
  const lastBlock = state.selection.lastBlock();
  if (!lastBlock)
    return false;
  if (isAtom(lastBlock.node)) {
    tr.insert(lastBlock.to, createSeshatBlock({ schema: state.schema }));
  }
  const caretPos = lastBlock.node.type.name === SeshatNodes.BLOCK ? getEndOfBlockContent(lastBlock) - 1 : lastBlock.to - 1;
  dispatch == null ? void 0 : dispatch(setCaretNearbyTransaction({ state, tr, pos: caretPos }));
  return true;
};
const getEndOfBlockContent = (block) => {
  var _a2, _b2;
  return block.from + ((_b2 = (_a2 = block.node.firstChild) == null ? void 0 : _a2.nodeSize) != null ? _b2 : 0);
};
const isSelectableBlock = (node) => {
  if (excludedFromBlockSelection.includes(node.attrs.type))
    return false;
  return true;
};
const selectCurrentBlock = () => ({ tr, view }) => {
  const block = getCurrentBlock(tr.doc, tr.selection.from, isSelectableBlock);
  if (!block)
    return false;
  tr.setSelection(BlockSelection.createFromRange(tr.doc, block.from, block.to));
  view.dispatch(tr);
  return true;
};
const selectNextBlock = (options) => ({
  state,
  dispatch
}) => {
  if (!isBlockSelection(state.selection))
    return false;
  const { tr, doc, selection } = state;
  const nextBlock = getNextBlock(doc, selection.to, isSelectableBlock, {
    ignoreChildren: (options == null ? void 0 : options.expand) ? true : false
  });
  if (!nextBlock)
    return true;
  const newSelectionFrom = nextBlock.depth < selection.$from.depth ? selection.$from.before(selection.$from.depth) : selection.from;
  const newSelection = (options == null ? void 0 : options.expand) ? BlockSelection.createFromRange(doc, newSelectionFrom, nextBlock.to) : BlockSelection.createFromPosition(doc, nextBlock.from);
  dispatch == null ? void 0 : dispatch(tr.setSelection(newSelection).scrollIntoView());
  return true;
};
const selectPrevBlock = (options) => ({
  state,
  dispatch
}) => {
  if (!isBlockSelection(state.selection))
    return false;
  const { tr, doc, selection } = state;
  const prevBlock = getPreviousBlock(doc, selection.from, isSelectableBlock, {
    ignoreChildren: (options == null ? void 0 : options.expand) ? true : false
  });
  if (!prevBlock)
    return !!(options == null ? void 0 : options.expand);
  const newSelection = (options == null ? void 0 : options.expand) ? BlockSelection.createFromRange(doc, prevBlock.from, selection.to) : BlockSelection.createFromPosition(doc, prevBlock.from);
  dispatch == null ? void 0 : dispatch(tr.setSelection(newSelection).scrollIntoView());
  return true;
};
const deleteBlockSelection = () => ({
  state,
  tr,
  dispatch
}) => {
  const { selection, doc } = state;
  if (!isBlockSelection(selection))
    return false;
  const rangeToDelete = { from: selection.from, to: selection.to };
  while (containsAllContentOfWrappingBlock({ doc, range: rangeToDelete })) {
    rangeToDelete.from--;
    rangeToDelete.to++;
  }
  tr.delete(rangeToDelete.from, rangeToDelete.to);
  const caretPos = state.selection.from;
  tr = setCaretNearbyTransaction({ state, tr, pos: caretPos });
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const containsAllContentOfWrappingBlock = ({
  doc,
  range
}) => {
  if (range.from <= 1)
    return false;
  const nodeBefore = doc.nodeAt(range.from - 1);
  if ((nodeBefore == null ? void 0 : nodeBefore.type.name) !== SeshatNodes.WRAPPING_BLOCK)
    return false;
  if ((nodeBefore == null ? void 0 : nodeBefore.attrs.type) === BlockTypes.HIGHLIGHTS)
    return false;
  return range.to === range.from + nodeBefore.content.size;
};
const selectBlockContent = () => ({ state, tr, dispatch }) => {
  const { selection } = state;
  if (isBlockSelection(selection))
    return false;
  const start = selection.$anchor.start(selection.$anchor.depth);
  const end = selection.$anchor.end(selection.$anchor.depth);
  const isEmptyBlock = start === end;
  if (!isEmptyBlock && isBlockContentAlreadySelected(selection, start, end))
    return false;
  const selectedContent = isEmptyBlock ? BlockSelection.createFromPosition(state.doc, start) : TextSelection.create(state.doc, start, end);
  dispatch == null ? void 0 : dispatch(tr.setSelection(selectedContent));
  return true;
};
const isBlockContentAlreadySelected = (selection, start, end) => selection.$anchor.pos === start && selection.$head.pos === end;
const selectNextNonEditableBlock = () => ({ chain, state }) => {
  const block = getCurrentBlock(state.doc, state.selection.from);
  const nextBlock = block && getNextBlock(state.doc, block.to);
  if (!nextBlock || !isAtom(nextBlock.node))
    return false;
  return chain().selectBlock({ pos: nextBlock.from }).scrollIntoView().run();
};
const selectPrevNonEditableBlock = () => ({ tr, chain }) => {
  const prevBlock = getPreviousBlock(tr.doc, tr.selection.from);
  if (!prevBlock || !isAtom(prevBlock.node))
    return false;
  return chain().selectBlock({ pos: prevBlock.from }).scrollIntoView().run();
};
const selectEditorContent = () => ({ state, dispatch }) => {
  let firstBlock = 0;
  const { tr } = state;
  for (let i = 1; i < tr.doc.nodeSize; i++) {
    const node = state.doc.nodeAt(i);
    if (node && node.type.spec.group === SeshatNodeGroups.BLOCK) {
      firstBlock = i;
      break;
    }
  }
  const isCardTitleSelected = tr.selection.head < firstBlock;
  if (isCardTitleSelected)
    return true;
  tr.setSelection(
    BlockSelection.createFromRange(tr.doc, firstBlock, tr.doc.nodeSize - 3)
  );
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const escapeBlockSelection = () => ({
  state,
  chain,
  commands
}) => {
  if (isBlockSelection(state.selection) || isCardTitleNode(state.selection.$from)) {
    return chain().unsetBlockSelection().blur().run();
  } else {
    return commands.selectCurrentBlock();
  }
};
const selectBlock = ({ pos } = {}) => ({
  tr,
  view
}) => {
  tr.setSelection(
    BlockSelection.createFromPosition(tr.doc, pos != null ? pos : tr.selection.from)
  );
  view.dispatch(tr);
  return true;
};
const getBlockSelectionDecorations = (state) => {
  if (!isBlockSelection(state.selection))
    return null;
  const decorations = state.selection.list().map(
    ({ from, to }) => Decoration.node(from, to, {
      class: `${SeshatCssClass.SELECTED_BLOCK}`
    })
  );
  return DecorationSet.create(state.doc, [
    hideSelectionDecoration(state.doc),
    ...decorations
  ]);
};
const SelectionBoxSelector = "data-selection-box";
class SelectionBox {
  constructor(view) {
    var _a2;
    this.box = null;
    this.box = document.createElement("div");
    this.box.setAttribute(SelectionBoxSelector, "true");
    (_a2 = view.dom.parentElement) == null ? void 0 : _a2.appendChild(this.box);
    this.dom = view.dom;
    this.offsetElement = this.box.offsetParent;
    this.setInitDecorations();
  }
  setInitDecorations() {
    var _a2, _b2, _c2, _d2;
    (_a2 = this.box) == null ? void 0 : _a2.style.setProperty("border", "1px solid rgb(114, 114, 115)");
    (_b2 = this.box) == null ? void 0 : _b2.style.setProperty("position", "absolute");
    (_c2 = this.box) == null ? void 0 : _c2.style.setProperty("background", "rgba(50, 51, 56, .6)");
    (_d2 = this.box) == null ? void 0 : _d2.style.setProperty("transition", "all 0");
  }
  remove() {
    var _a2;
    (_a2 = this.box) == null ? void 0 : _a2.remove();
  }
  calculatePosition({
    startCoords,
    endCoords
  }) {
    var _a2, _b2, _c2, _d2;
    const domRect = this.dom.getBoundingClientRect();
    const offsetRect = this.offsetElement.getBoundingClientRect();
    const x3 = Math.min(startCoords.x, endCoords.x) + domRect.x - offsetRect.x;
    const x4 = Math.max(startCoords.x, endCoords.x) + domRect.x - offsetRect.x;
    const y3 = Math.min(startCoords.y, endCoords.y) + domRect.y - offsetRect.y;
    const y4 = Math.max(startCoords.y, endCoords.y) + domRect.y - offsetRect.y;
    (_a2 = this.box) == null ? void 0 : _a2.style.setProperty("left", x3 + "px");
    (_b2 = this.box) == null ? void 0 : _b2.style.setProperty("top", y3 + "px");
    (_c2 = this.box) == null ? void 0 : _c2.style.setProperty("width", x4 - x3 + "px");
    (_d2 = this.box) == null ? void 0 : _d2.style.setProperty("height", y4 - y3 + "px");
  }
}
const MouseBlockSelectionPluginKey = new PluginKey("MouseBlockSelectionPlugin");
const MouseBlockSelectionPlugin = () => {
  let startCoords;
  let endCoords;
  let selectionBox;
  const stopSelection = () => {
    startCoords = void 0;
    endCoords = void 0;
    selectionBox == null ? void 0 : selectionBox.remove();
    selectionBox = void 0;
  };
  return new Plugin({
    key: MouseBlockSelectionPluginKey,
    filterTransaction(tr) {
      return !selectionBox || tr.getMeta(MouseBlockSelectionPluginKey);
    },
    view(view) {
      const onMouseMove = (e) => {
        if (!startCoords)
          return false;
        const docHeight = document.body.scrollTop + document.body.clientHeight;
        if (docHeight <= e.y)
          return false;
        selectionBox = selectionBox != null ? selectionBox : new SelectionBox(view);
        endCoords = getMouseEventRectInView(e, view);
        if (startCoords.x === endCoords.x && startCoords.y === endCoords.y)
          return false;
        selectionBox.calculatePosition({ startCoords, endCoords });
        const blocksPositions = getBlocksPositionsUnderSelection(
          view,
          startCoords,
          endCoords
        );
        const { state, dispatch } = view;
        const { doc, tr } = state;
        if (!blocksPositions.length) {
          const defaultSelection = TextSelection.create(doc, 0);
          dispatch == null ? void 0 : dispatch(tr.setSelection(defaultSelection));
        }
        const blockSelection = BlockSelection.createFromPositions(
          doc,
          blocksPositions
        );
        tr.setSelection(blockSelection);
        tr.setMeta(MouseBlockSelectionPluginKey, true);
        dispatch == null ? void 0 : dispatch(tr);
        return true;
      };
      const addEvent = (e) => {
        const target = e.target;
        if (!(target == null ? void 0 : target.classList.contains("ProseMirror")))
          return;
        if ((target == null ? void 0 : target.getAttribute(ANNOTATION_MODE_ATTRIBUTE)) === "true")
          return;
        if (isBlockSelection(view.state.selection))
          removeEvent();
        startCoords = getMouseEventRectInView(e, view);
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("contextmenu", stopSelection);
        window.addEventListener("mouseup", stopSelection);
      };
      const removeEvent = () => {
        setTimeout(() => {
          window.removeEventListener("mousemove", onMouseMove);
          window.removeEventListener("contextmenu", stopSelection);
          window.removeEventListener("mouseup", stopSelection);
        }, 100);
      };
      window.addEventListener("mousedown", addEvent);
      window.addEventListener("mouseup", removeEvent);
      return {
        destroy: () => {
          window.removeEventListener("mousedown", addEvent);
          window.removeEventListener("mouseup", removeEvent);
          window.removeEventListener("mousemove", onMouseMove);
          window.removeEventListener("contextmenu", stopSelection);
          window.removeEventListener("mouseup", stopSelection);
        }
      };
    },
    props: {
      decorations(state) {
        return getBlockSelectionDecorations(state);
      },
      handleDOMEvents: {
        click() {
          stopSelection();
          return false;
        }
      }
    }
  });
};
const SESHAT_SELECTABLE_SELECTOR = '.seshat_block:not([type="seshatCardContent"])';
const getMouseEventRectInView = (e, view) => {
  const viewDomRect = view.dom.getBoundingClientRect();
  return { x: e.clientX - viewDomRect.left, y: e.clientY - viewDomRect.top };
};
const getBlocksPositionsUnderSelection = (view, { x: x1, y: y1 }, { x: x2, y: y2 }) => {
  const rootRect = {
    top: Math.min(y1, y2),
    left: Math.min(x1, x2),
    bottom: Math.max(y1, y2),
    right: Math.max(x1, x2)
  };
  const viewDomRect = view.dom.getBoundingClientRect();
  const blocks = document.querySelectorAll(SESHAT_SELECTABLE_SELECTOR);
  const domBlocks = Array.from(blocks).filter((block) => {
    const blockRect = block.getBoundingClientRect();
    const blockRectInView = {
      top: blockRect.top - viewDomRect.top,
      left: blockRect.left - viewDomRect.left,
      right: blockRect.right - viewDomRect.left,
      bottom: blockRect.bottom - viewDomRect.top
    };
    return isOverLapping(rootRect, blockRectInView);
  }).filter((domBlock) => domBlock);
  return domBlocks.map((dom) => view.posAtDOM(dom, 0) - 1);
};
const isOverLapping = (rect1, rect2) => {
  return !(rect1.right < rect2.left || rect1.left > rect2.right || rect1.bottom < rect2.top || rect1.top > rect2.bottom);
};
const BlockSelectionExtension = Extension$1.create({
  name: "BlockSelectionExtension",
  addCommands() {
    return {
      unsetBlockSelection,
      selectBlock,
      selectCurrentBlock,
      selectNextBlock,
      selectNextNonEditableBlock,
      selectPrevBlock,
      selectPrevNonEditableBlock,
      deleteBlockSelection,
      selectBlockContent,
      selectEditorContent,
      escapeBlockSelection
    };
  },
  addKeyboardShortcuts() {
    return {
      Escape: () => {
        return this.editor.commands.first(({ commands: commands2 }) => [
          () => commands2.onEscapeOrSelectPrevNextOnTaskEditable(true),
          () => commands2.escapeBlockSelection()
        ]);
      },
      [shortcutConfig.selectNextBlock]: () => {
        return this.editor.commands.first(({ commands: commands2 }) => [
          () => commands2.selectNextBlock(),
          () => commands2.selectNextNonEditableBlock(),
          () => commands2.insertTrailingLineOnArrowDown()
        ]);
      },
      [shortcutConfig.selectPrevBlock]: () => {
        return this.editor.commands.first(({ commands: commands2 }) => [
          () => commands2.selectPrevBlock(),
          () => commands2.selectPrevNonEditableBlock()
        ]);
      },
      [shortcutConfig.expandNextBlock]: () => {
        return this.editor.commands.first(({ commands: commands2, state }) => [
          () => !isBlockSelection(state.selection) ? commands2.selectCurrentBlock() : false,
          () => commands2.selectNextBlock({ expand: true })
        ]);
      },
      [shortcutConfig.expandPrevBlock]: () => {
        return this.editor.commands.first(({ commands: commands2, state }) => [
          () => !isBlockSelection(state.selection) ? commands2.selectCurrentBlock() : false,
          () => commands2.selectPrevBlock({ expand: true })
        ]);
      },
      [shortcutConfig.selectAll]: () => {
        return this.editor.commands.first(({ commands: commands2 }) => [
          () => commands2.selectBlockContent(),
          () => commands2.selectEditorContent()
        ]);
      }
    };
  },
  onBlur() {
    this.editor.commands.unsetBlockSelection();
  },
  addProseMirrorPlugins() {
    return [
      MouseBlockSelectionPlugin(),
      new Plugin({
        props: {
          handleDOMEvents: {
            keypress(view, event) {
              if (isBlockSelection(view.state.selection)) {
                return preventDefaultKeyBehavior(event);
              }
              return false;
            }
          }
        }
      })
    ];
  }
});
const duplicateBlock = () => ({ tr, dispatch, state }) => {
  const { doc } = state;
  const blockSelection = isBlockSelection(state.selection) ? state.selection : BlockSelection.createFromTextSelection(doc, state.selection);
  const highlightAncestor = findAncestor(blockSelection.$from, isHighlight);
  if (highlightAncestor)
    return true;
  const slice = resetAttrsInSlice(state.schema, blockSelection.content());
  const contentToInsert = slice.content.firstChild;
  if (!contentToInsert)
    return true;
  tr.insert(blockSelection.to, contentToInsert.content);
  tr.setSelection(
    BlockSelection.createFromRange(
      tr.doc,
      blockSelection.from + contentToInsert.content.size,
      blockSelection.to + contentToInsert.content.size
    )
  ).scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const isHighlight = (node) => (node == null ? void 0 : node.attrs.type) === BlockTypes.HIGHLIGHT;
const focusAtSelectionEnd = () => ({ commands, state }) => commands.focus(state.selection.to);
const focusLastPosition = () => ({ chain, tr }) => {
  const selection = Selection.atEnd(tr.doc);
  return chain().insertContentAt(selection.to, " ").focus(selection.to).deleteRange({ from: selection.to, to: selection.to + 1 }).run();
};
const indentBlock = () => ({ state, tr, dispatch }) => {
  const blockSelection = isBlockSelection(state.selection) ? state.selection : BlockSelection.createFromTextSelection(state.doc, state.selection);
  if (!isIndentationAllowed(blockSelection))
    return true;
  tr.delete(blockSelection.from, blockSelection.to);
  tr.insert(blockSelection.from - 1, blockSelection.getFragment());
  const updatedRange = {
    from: state.selection.from - 1,
    to: state.selection.to - 1
  };
  const updatedSelection = isBlockSelection(state.selection) ? BlockSelection.createFromRange(tr.doc, updatedRange.from, updatedRange.to) : TextSelection.create(tr.doc, updatedRange.from, updatedRange.to);
  tr.setSelection(updatedSelection);
  tr = uncollapseNewParentBlock({ tr, blockSelection });
  if (!isBlockSelection(state.selection))
    tr = liftChildrenToInitialDepth({ tr, blockSelection });
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const isIndentationAllowed = (selection) => {
  const containsInAllowedBlocks = selection.list().some(({ node }) => disabledIndent.includes(node.attrs.type));
  if (containsInAllowedBlocks)
    return false;
  const { nodeBefore } = selection.firstBlock().$from;
  if ((nodeBefore == null ? void 0 : nodeBefore.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return false;
  if (nodeBefore.attrs.type === BlockTypes.HIGHLIGHTS)
    return false;
  if (nodeBefore.attrs.type === BlockTypes.CARD_LINK)
    return false;
  if (nodeBefore.attrs.type === BlockTypes.BLOCK_LINE)
    return false;
  if (isContentEditableFalse(nodeBefore))
    return false;
  return true;
};
const liftChildrenToInitialDepth = ({
  tr,
  blockSelection
}) => {
  const singleBlock = blockSelection.list().length === 1 && blockSelection.firstBlock();
  if (!singleBlock || singleBlock.node.childCount === 1)
    return tr;
  const childStart = singleBlock.from + singleBlock.node.firstChild.nodeSize;
  const childEnd = singleBlock.to - 2;
  const children = tr.doc.slice(childStart, childEnd);
  tr.insert(singleBlock.to - 1, children.content);
  tr.delete(childStart, childEnd);
  return tr;
};
const uncollapseNewParentBlock = ({
  tr,
  blockSelection
}) => {
  const { nodeBefore } = blockSelection.$from;
  if (!nodeBefore || !isBlockCollapsible(nodeBefore))
    return tr;
  const parentPos = blockSelection.from - nodeBefore.nodeSize;
  return tr.setNodeMarkup(parentPos, void 0, {
    ...nodeBefore.attrs,
    collapsed: false
  });
};
const insertBlock = (attrs) => ({
  chain,
  tr
}) => {
  var _a2, _b2, _c2, _d2, _e2;
  const { selection, doc } = tr;
  const { $from } = selection;
  const { depth } = $from;
  const contentEnd = $from.end();
  const block = getCurrentBlock(doc, $from.pos);
  let type = (_a2 = block == null ? void 0 : block.node.attrs.type) != null ? _a2 : BlockTypes.PARAGRAPH;
  const isRegularBlock = ((_b2 = block == null ? void 0 : block.node) == null ? void 0 : _b2.type.name) === SeshatNodes.BLOCK;
  const isWrappingBlock2 = ((_c2 = block == null ? void 0 : block.node) == null ? void 0 : _c2.type.name) === SeshatNodes.WRAPPING_BLOCK;
  const insertPosition = isWrappingBlock2 || isRegularBlock ? block.to : contentEnd + depth;
  const focusPosition = insertPosition + SESHAT_CONTENT_DEPTH;
  const finalAttrs = {
    type,
    [BlockAttrsParams.CONTEXT_UUID]: (_e2 = (_d2 = block == null ? void 0 : block.node) == null ? void 0 : _d2.attrs) == null ? void 0 : _e2[BlockAttrsParams.CONTEXT_UUID],
    ...attrs || {}
  };
  return chain().insertContentAt(insertPosition, generateEmptyBlock(finalAttrs)).focus(focusPosition).scrollIntoView().run();
};
const insertSoftBreak = () => ({ dispatch, tr }) => {
  tr.insertText("\n").scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const insertSoftBreakOnEnter = () => ({ tr, commands }) => {
  const { selection } = tr;
  const { $from } = selection;
  const depth = $from.depth;
  const parentSeshatBlockDepth = depth - 2;
  const seshatBlockNode = $from.node(parentSeshatBlockDepth);
  if (!seshatBlockSoftBreakOnEnter.includes(seshatBlockNode == null ? void 0 : seshatBlockNode.attrs.type))
    return false;
  return commands.insertSoftBreak();
};
const insertSoftTab = () => ({ dispatch, tr, state }) => {
  if (isBlockSelection(state.selection))
    return false;
  const { from } = state.selection;
  const block = getCurrentBlock(state.doc, from);
  if (!block || !seshatBlockSoftTab.includes(block.node.attrs.type))
    return false;
  tr.insertText("	").scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const onBackspace = () => ({ tr, commands, chain }) => {
  const { selection, doc } = tr;
  const { $from } = selection;
  const isAtStart = $from.parentOffset === 0;
  if (!isAtStart || !selection.empty)
    return false;
  const block = getCurrentBlock(doc, $from.pos);
  if (isAtStartOfHighlightBlockquote({ doc, $from }))
    return true;
  if (isAtStartOfNonEmptyHighlightNote({ doc, $from }))
    return true;
  if (shouldResetBlock({ block, commands }))
    return true;
  return deleteInPreviousSibling({ tr, block, commands, chain });
};
const isAtStartOfHighlightBlockquote = ({
  doc,
  $from
}) => {
  var _a2;
  const wrappingBlockStart = $from.pos - SESHAT_CONTENT_DEPTH - 2;
  const nodeBeforePos = minMax(wrappingBlockStart - 1, 0, doc.nodeSize);
  if (((_a2 = doc.nodeAt(nodeBeforePos)) == null ? void 0 : _a2.attrs.type) === BlockTypes.HIGHLIGHT)
    return true;
  return false;
};
const getHighlightNoteNodeBefore = ({
  doc,
  $from
}) => {
  const wrappingBlockStart = $from.pos - SESHAT_CONTENT_DEPTH - 2;
  const nodeBeforePos = minMax(wrappingBlockStart, 0, doc.nodeSize);
  const nodeBefore = doc.nodeAt(nodeBeforePos);
  return (nodeBefore == null ? void 0 : nodeBefore.attrs.type) === BlockTypes.HIGHLIGHT_NOTE ? nodeBefore : void 0;
};
const isEmptyHighlightNote = (node) => node.childCount === 1 && isSeshatBlockEmpty(node.firstChild);
const isAtStartOfNonEmptyHighlightNote = ({
  doc,
  $from
}) => {
  const highlightNote = getHighlightNoteNodeBefore({ doc, $from });
  return highlightNote && !isEmptyHighlightNote(highlightNote);
};
const isAtStartOfEmptyHighlightNote = ({
  doc,
  $from
}) => {
  const highlightNote = getHighlightNoteNodeBefore({ doc, $from });
  return highlightNote && isEmptyHighlightNote(highlightNote);
};
const shouldResetBlock = ({
  block,
  commands
}) => {
  if ((block == null ? void 0 : block.depth) === SESHAT_ROOT_DEPTH || !seshatBlockResetOnStartBackspace.includes(block == null ? void 0 : block.node.attrs.type))
    return false;
  return commands.resetBlock();
};
const selectPreviousAtomBlock = ({
  $from,
  chain,
  seshatBlockDepth
}) => {
  const isNodeEmpty = $from.node().textContent.length < 1;
  if (!isNodeEmpty)
    return chain().selectPrevNonEditableBlock().run();
  const from = $from.before(seshatBlockDepth);
  const to = $from.after(seshatBlockDepth);
  return chain().selectPrevNonEditableBlock().deleteRange({ from, to }).run();
};
const selectPreviousHighlights = ({
  $from,
  chain,
  seshatBlockDepth,
  blockBefore
}) => {
  const highlightsPos = blockBefore.from;
  const isNodeEmpty = $from.node().textContent.length < 1;
  if (!isNodeEmpty)
    return chain().selectBlock({ pos: highlightsPos }).run();
  const from = $from.before(seshatBlockDepth);
  const to = $from.after(seshatBlockDepth);
  return chain().selectBlock({ pos: highlightsPos }).deleteRange({ from, to }).run();
};
const deleteInPreviousSibling = ({
  tr,
  block,
  commands,
  chain
}) => {
  if (!(block == null ? void 0 : block.node))
    return false;
  const { selection } = tr;
  const { $from } = selection;
  if (selection.empty && block.node.type.spec.group !== SeshatNodeGroups.BLOCK)
    return false;
  const previousTarget = getForwardSeshatBlockContent({ $from });
  if (!(previousTarget == null ? void 0 : previousTarget.node) || !(previousTarget == null ? void 0 : previousTarget.pos))
    return false;
  if (isAtom(previousTarget.node)) {
    return selectPreviousAtomBlock({
      chain,
      $from,
      seshatBlockDepth: block.depth
    });
  }
  const blockBefore = getPreviousBlock(tr.doc, $from.pos, void 0, {
    ignoreChildren: true
  });
  if ((blockBefore == null ? void 0 : blockBefore.node.attrs.type) === BlockTypes.HIGHLIGHTS) {
    return selectPreviousHighlights({
      chain,
      $from,
      seshatBlockDepth: block.depth,
      blockBefore
    });
  }
  return commands.unwrapChildrenAndMoveContentToTarget({
    block,
    previousTarget
  });
};
const onDelete = () => ({ tr, dispatch }) => {
  const { selection } = tr;
  const { $from } = selection;
  const node = $from.node();
  const isAtTheEnd = $from.parentOffset === node.content.size;
  if (!(isAtTheEnd && dispatch))
    return false;
  const block = getCurrentBlock(tr.doc, $from.pos);
  const nextPos = $from.after(block == null ? void 0 : block.depth);
  const nextNode = tr.doc.nodeAt(nextPos);
  if (!nextNode)
    return false;
  if (hasSelectableText(nextNode)) {
    const pos = $from.pos;
    onDeleteAtTheEndWhenNextSiblingIsSeshatBlockWithSeshatContent({
      nextNode,
      tr,
      pos,
      dispatch
    });
  } else if (!isAtom(nextNode)) {
    unwrapNextNode({ nextNode, nextPos, tr, $from, dispatch });
  } else {
    blockSelectNextNode({ nextPos, tr, dispatch });
  }
  return true;
};
const unwrapNextNode = ({
  nextNode,
  nextPos,
  tr,
  $from,
  dispatch
}) => {
  var _a2, _b2, _c2;
  if (((_a2 = nextNode.firstChild) == null ? void 0 : _a2.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return;
  const depth = (_c2 = (_b2 = getCurrentBlock(tr.doc, $from.pos)) == null ? void 0 : _b2.depth) != null ? _c2 : $from.depth;
  const nextNodeStartPos = nextPos + 1;
  const nextNodeEndPos = nextNodeStartPos + nextNode.nodeSize - 2;
  const range = tr.doc.resolve(nextNodeStartPos).blockRange(tr.doc.resolve(nextNodeEndPos));
  if (!range)
    return;
  tr.lift(range, depth - 1);
  dispatch == null ? void 0 : dispatch(tr);
};
const blockSelectNextNode = ({
  nextPos,
  tr,
  dispatch
}) => {
  tr.setSelection(BlockSelection.createFromPosition(tr.doc, nextPos));
  dispatch == null ? void 0 : dispatch(tr);
};
const hasSelectableText = (node) => {
  var _a2;
  return !isAtom(node) && ((_a2 = node.firstChild) == null ? void 0 : _a2.type.name) === SeshatNodes.BLOCK_CONTENT;
};
const onDeleteAtTheEndWhenNextSiblingIsSeshatBlockWithSeshatContent = ({
  nextNode,
  tr,
  pos,
  dispatch
}) => {
  var _a2, _b2;
  const textNode = getSeshatContent(nextNode);
  const nextSiblingStart = pos + SESHAT_CONTENT_DEPTH + 1;
  const nextSiblingEnd = pos + (((_a2 = textNode.node) == null ? void 0 : _a2.nodeSize) || 0) + 2 * (SESHAT_CONTENT_DEPTH + 1);
  tr.delete(nextSiblingStart, nextSiblingEnd).insert(pos, ((_b2 = textNode.node) == null ? void 0 : _b2.content.content) || []).setSelection(TextSelection.create(tr.doc, pos)).scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
};
const isLauncherEditor = (editor) => editor.options.editorProps.attributes.id === LAUNCHER_EDITOR_ID;
const getAllEditors = () => {
  return [...document.querySelectorAll(".ProseMirror")];
};
const getEditorApi = (editorId) => {
  var _a2, _b2;
  let editorElement;
  if (editorId) {
    editorElement = document.getElementById(editorId);
  } else {
    const selection = (_b2 = (_a2 = window.getSelection()) == null ? void 0 : _a2.anchorNode) == null ? void 0 : _b2.parentElement;
    editorElement = selection == null ? void 0 : selection.closest(".ProseMirror");
  }
  return editorElement == null ? void 0 : editorElement.editor;
};
const onEnter = () => ({ editor, tr, commands, chain }) => {
  const { selection, doc } = tr;
  const { $from } = selection;
  const isAtStart = $from.parentOffset === 0;
  const nodeIsEmpty = $from.node().textContent.length < 1;
  const block = getCurrentBlock(doc, $from.pos);
  const type = block == null ? void 0 : block.node.attrs.type;
  const isRoot = (block == null ? void 0 : block.depth) === SESHAT_ROOT_DEPTH;
  if (isRoot && isAtStart) {
    return true;
  }
  if (!(block == null ? void 0 : block.node)) {
    return commands.insertBlock();
  }
  if (isCaretWithinHighlightBlockquote($from)) {
    return commands.insertHighlightNote();
  }
  if (!isRoot && nodeIsEmpty && seshatBlockResetOnEmptyEnter.includes(type)) {
    return commands.resetBlock();
  }
  if (isLauncherEditor(editor) && isAtStartOfEmptyHighlightNote({ doc, $from }))
    return commands.liftBlockOutOfHighlights();
  if (isAtStart && !nodeIsEmpty) {
    return chain().insertContentAt(block.from, [generateEmptyBlock()]).focus(block.from + SESHAT_CONTENT_DEPTH * 3 + 1).run();
  }
  if (!isRoot && nodeIsEmpty && isLastChildOfWrappingBlock({ $from, block })) {
    return commands.outdentBlock();
  }
  return commands.splitBlock();
};
const isLastChildOfWrappingBlock = ({
  $from,
  block
}) => {
  var _a2;
  if (!block)
    return false;
  const parentBlock = $from.node(block.depth - 1);
  if (parentBlock.type.name !== SeshatNodes.WRAPPING_BLOCK)
    return false;
  const isCapture = parentBlock.attrs.type === BlockTypes.CAPTURE;
  if (isCapture)
    return false;
  return ((_a2 = parentBlock.lastChild) == null ? void 0 : _a2.attrs[BlockAttrsParams.BLOCK_UUID]) === block.node.attrs[BlockAttrsParams.BLOCK_UUID];
};
const maybeDoHardBreakDueToBlockType = ({
  block,
  commands
}) => {
  if (!HARD_BREAK_DUE_TO_BLOCK_TYPE.includes(block.attrs.type))
    return false;
  return commands.insertBlock({ type: BlockTypes.PARAGRAPH });
};
const maybeDoHardBreakDueToParentType = ({
  tr,
  schema,
  depth,
  $from,
  dispatch
}) => {
  const parentDeep = depth - 1;
  const parent = $from.node(parentDeep);
  if (!HARD_BREAK_DUE_TO_PARENT_TYPE.includes(parent.attrs.type))
    return false;
  const newBlock = createSeshatBlock({ schema });
  const nodeAfterPos = $from.end(parentDeep) + 1;
  const caretPos = nodeAfterPos + SESHAT_CONTENT_DEPTH;
  tr.insert(nodeAfterPos, newBlock).setSelection(TextSelection.create(tr.doc, caretPos)).scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const onHardBreak = () => ({
  tr,
  dispatch,
  state,
  commands,
  view
}) => {
  if (view.dom.id === LAUNCHER_EDITOR_ID)
    return false;
  const { schema } = state;
  const { selection } = tr;
  const { $from } = selection;
  const block = getCurrentBlock(tr.doc, $from.pos);
  if (!block)
    return false;
  if (maybeDoHardBreakDueToBlockType({ block: block.node, commands }))
    return true;
  if (isCaretWithinHighlightBlockquote($from))
    return commands.insertHighlightNote();
  if (maybeDoHardBreakDueToParentType({
    tr,
    schema,
    depth: block.depth,
    $from,
    dispatch
  }))
    return true;
  return false;
};
const outdentBlock = ({
  stopPropagation
} = {}) => ({ state, tr, dispatch }) => {
  var _a2;
  const blockSel = isBlockSelection(state.selection) ? state.selection : BlockSelection.createFromTextSelection(state.doc, state.selection);
  if (!shouldOutdent(blockSel))
    return stopPropagation != null ? stopPropagation : true;
  const blockSelectionStart = blockSel.firstBlock().$from;
  const lastNode = (_a2 = blockSel.lastBlock()) == null ? void 0 : _a2.node;
  const parentNode = blockSelectionStart.parent;
  const parentNodeEnd = blockSel.from - blockSelectionStart.parentOffset + (parentNode == null ? void 0 : parentNode.nodeSize) - SESHAT_CONTENT_DEPTH;
  let selectionStart = blockSelectionStart.pos;
  let insertPos = parentNodeEnd + 1;
  let offset = 1;
  let fragmentToInsert = blockSel.list().slice(0, -1).reduce((fragment, block) => {
    return fragment.append(Fragment.from(block.node));
  }, Fragment.from());
  const { index } = findChildByBlockId({
    parentNode,
    blockId: lastNode == null ? void 0 : lastNode.attrs[BlockAttrsParams.BLOCK_UUID]
  });
  const nextBlockSiblings = parentNode.content.content.slice(index + 1);
  const outdentBlockNode = lastNode == null ? void 0 : lastNode.type.create(lastNode.attrs, [
    ...lastNode.content.content,
    ...nextBlockSiblings
  ]);
  fragmentToInsert = fragmentToInsert.append(Fragment.from(outdentBlockNode));
  let deleteFrom = selectionStart;
  const previousBlocks = parentNode.content.content.slice(0, index);
  if (previousBlocks.length === 0) {
    deleteFrom -= 1;
  }
  if ((parentNode == null ? void 0 : parentNode.attrs.type) === BlockTypes.BLOCK_COLUMN) {
    insertPos += 1;
    offset += 1;
    deleteFrom -= 1;
  }
  if (isOnlyChildInWrappingBlock(parentNode)) {
    offset -= 2;
  }
  tr.insert(insertPos, fragmentToInsert);
  tr.delete(deleteFrom, parentNodeEnd);
  if (isBlockSelection(state.selection)) {
    tr.setSelection(
      BlockSelection.createFromRange(
        tr.doc,
        state.selection.from + offset,
        state.selection.to + offset
      )
    );
  } else {
    tr.setSelection(
      TextSelection.create(
        tr.doc,
        state.selection.from + offset,
        state.selection.to + offset
      )
    );
  }
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const isOnlyChildInWrappingBlock = (parentNode) => parentNode.type.name === SeshatNodes.WRAPPING_BLOCK && parentNode.childCount === 1;
const isWithinHighlightQuote = (parentNode, $from) => {
  if (parentNode.attrs.type !== BlockTypes.BLOCKQUOTE)
    return false;
  return $from.node($from.depth - 1).attrs.type === BlockTypes.HIGHLIGHT;
};
const shouldOutdent = (blockSelection) => {
  var _a2;
  if (blockSelection.empty)
    return false;
  const $from = blockSelection.firstBlock().$from;
  const parentNode = $from.parent;
  const lastNode = (_a2 = blockSelection.lastBlock()) == null ? void 0 : _a2.node;
  if ((parentNode == null ? void 0 : parentNode.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return false;
  if (parentNode.attrs.type === BlockTypes.HIGHLIGHT_NOTE)
    return false;
  if (isWithinHighlightQuote(parentNode, $from))
    return false;
  if (lastNode && seshatBlockSoftTab.includes(lastNode.attrs.type))
    return false;
  if (isParentRootBlock({ $from, blockDepth: $from.depth })) {
    return false;
  }
  return true;
};
const removeFirstLine = () => ({ tr, dispatch }) => {
  const from = tr.doc.resolve(3);
  const start = from.start();
  const end = from.end();
  tr.deleteRange(start, end);
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const replaceContent = ({
  content,
  emitUpdate,
  parseOptions
}) => ({ commands }) => {
  return commands.setContent(content, emitUpdate, parseOptions);
};
const replaceSelection = ({
  content
}) => ({ tr, dispatch, state }) => {
  if (isBlockSelection(state.selection)) {
    const slice = content ? Slice.fromJSON(state.schema, content) : Slice.empty;
    tr.replace(tr.selection.from, tr.selection.to, slice);
    tr.setSelection(
      BlockSelection.createFromRange(
        tr.doc,
        tr.selection.from,
        tr.selection.from + slice.size
      )
    );
  } else {
    const slice = content ? getInlineContentSlice({ state, content }) : Slice.empty;
    tr.replace(tr.selection.from, tr.selection.to, slice);
    tr.setSelection(
      TextSelection.create(
        tr.doc,
        tr.selection.from,
        tr.selection.from + slice.size
      )
    );
  }
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const getInlineContentSlice = ({
  state,
  content
}) => {
  var _a2;
  const contentToInsert = Array.isArray(content) ? createSeshatBlock({
    schema: state.schema,
    children: Fragment.fromJSON(state.schema, content).content
  }) : Node.fromJSON(state.schema, content);
  let inlineContentDistance = 0;
  for (let pos = 0; pos < contentToInsert.nodeSize; pos++) {
    if ((_a2 = contentToInsert.nodeAt(pos)) == null ? void 0 : _a2.isInline) {
      inlineContentDistance = pos;
      break;
    }
  }
  return contentToInsert.slice(
    inlineContentDistance,
    contentToInsert.nodeSize - inlineContentDistance - SESHAT_CONTENT_DEPTH
  );
};
function elementFromString(value) {
  const wrappedValue = `<body>${value}</body>`;
  return new window.DOMParser().parseFromString(wrappedValue, "text/html").body;
}
const createNodeFromContent = (content, schema, options) => {
  options = {
    slice: true,
    parseOptions: {},
    ...options
  };
  if (typeof content === "object" && content !== null) {
    try {
      if (Array.isArray(content)) {
        return Fragment.fromArray(
          content.map((item) => schema.nodeFromJSON(item))
        );
      }
      return schema.nodeFromJSON(content);
    } catch (error) {
      return createNodeFromContent("", schema, options);
    }
  }
  if (typeof content === "string") {
    const parser = DOMParser.fromSchema(schema);
    return options.slice ? parser.parseSlice(elementFromString(content), options.parseOptions).content : parser.parse(elementFromString(content), options.parseOptions);
  }
  return createNodeFromContent("", schema, options);
};
const replaceWith = ({
  content: value,
  from,
  to
}) => ({ tr, dispatch, editor }) => {
  const content = createNodeFromContent(value, editor.schema, {
    parseOptions: {
      preserveWhitespace: "full"
    }
  });
  if (content.toString() === "<>") {
    return true;
  }
  tr.replaceWith(from, to, content);
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const resetBlock = () => ({ tr, commands }) => {
  const { selection } = tr;
  const { $from } = selection;
  const isAtStart = $from.parentOffset === 0;
  if (!isAtStart)
    return false;
  return commands.updateBlockAttributes({
    type: BlockTypes.PARAGRAPH,
    collapsed: void 0
  });
};
const scrollToBlock = (props) => ({
  view,
  dispatch
}) => {
  dispatch == null ? void 0 : dispatch(scrollToBlockTransaction({ view, ...props }));
  return true;
};
const scrollToBlockTransaction = ({
  view,
  uuid,
  options
}) => {
  var _a2;
  if (!uuid)
    return false;
  const scrollOptions = {
    ...options,
    behavior: (_a2 = options == null ? void 0 : options.behavior) != null ? _a2 : "smooth"
  };
  const block = view.dom.querySelector(
    `div[${BlockAttrsParams.BLOCK_UUID}="${uuid}"]`
  );
  if (!block)
    return false;
  block.scrollIntoView(scrollOptions);
  return true;
};
const splitBlock = () => ({ tr, dispatch, state }) => {
  var _a2, _b2;
  const { selection } = tr;
  const { $from } = selection;
  const block = getCurrentBlock(tr.doc, $from.pos);
  if (!block)
    return false;
  const isRoot = block.depth === SESHAT_ROOT_DEPTH;
  if (isRoot) {
    dispatch == null ? void 0 : dispatch(splitBlockWithChildrenTransaction({ schema: state.schema, tr }));
    return true;
  }
  if (((_a2 = block.node) == null ? void 0 : _a2.attrs.collapsed) || ((_b2 = block.node) == null ? void 0 : _b2.attrs.type) && !seshatBlockChildrenOnEnter[block.node.attrs.type]) {
    dispatch == null ? void 0 : dispatch(splitBlockTransaction({ tr, schema: state.schema }));
  } else {
    dispatch == null ? void 0 : dispatch(splitBlockWithChildrenTransaction({ schema: state.schema, tr }));
  }
  return true;
};
const splitBlockTransaction = ({
  tr,
  schema
}) => {
  var _a2;
  const { selection } = tr;
  const { $from, $to } = selection;
  const contentDepth = $from.depth;
  const seshatBlockDepth = contentDepth - SESHAT_CONTENT_DEPTH;
  const selectionStart = $from.pos;
  const selectionEnd = $to.pos;
  const contentNodeStart = $from.start();
  const seshatBlockEnd = $from.end(seshatBlockDepth);
  const block = getCurrentBlock(tr.doc, $from.pos);
  const blockType = seshatBlockOnEnter[block == null ? void 0 : block.node.attrs.type] || (block == null ? void 0 : block.node.attrs.type);
  const seshatBlock = (_a2 = schema.nodes[getNodeTypeByBlockType(blockType)]) == null ? void 0 : _a2.create(
    {
      ...block == null ? void 0 : block.node.attrs,
      [BlockAttrsParams.BLOCK_UUID]: void 0,
      [BlockAttrsParams.HIGHLIGHT_UUID]: void 0,
      [BlockAttrsParams.CONTEXT_UUID]: block == null ? void 0 : block.node.attrs[BlockAttrsParams.CONTEXT_UUID],
      type: blockType != null ? blockType : BlockTypes.PARAGRAPH
    },
    block ? block.node.content : void 0
  );
  const insertPosition = seshatBlockEnd + 1;
  tr.insert(insertPosition, seshatBlock);
  const contentNodePositionStartOfNewNode = insertPosition + SESHAT_CONTENT_DEPTH + 1;
  const numberOfPositionDeletedInNewNode = selectionEnd - contentNodeStart;
  tr.delete(
    contentNodePositionStartOfNewNode,
    contentNodePositionStartOfNewNode + numberOfPositionDeletedInNewNode
  );
  const endOfOldBlock = insertPosition - 1;
  tr.delete(selectionStart, endOfOldBlock);
  const numberOfPositionDeletedInOldNode = endOfOldBlock - selectionStart;
  tr.setSelection(
    TextSelection.create(
      tr.doc,
      contentNodePositionStartOfNewNode - numberOfPositionDeletedInOldNode + SESHAT_CONTENT_DEPTH
    )
  ).scrollIntoView();
  return tr;
};
const splitBlockWithChildrenTransaction = ({
  tr,
  schema
}) => {
  const { selection } = tr;
  const { $from, $to } = selection;
  const selectionStart = $from.pos;
  const selectionEnd = $to.pos;
  const contentNodeStart = $from.start();
  const contentNodeEnd = $from.end();
  const block = getCurrentBlock(tr.doc, $from.pos);
  const seshatContent = schema.nodes.seshatContent.create(
    {},
    $from.node().content
  );
  const seshatBlockContent = schema.nodes[SeshatNodes.BLOCK_CONTENT].create(
    {},
    seshatContent
  );
  const seshatBlock = schema.nodes[SeshatNodes.BLOCK].create(
    {
      type: BlockTypes.PARAGRAPH,
      [BlockAttrsParams.CONTEXT_UUID]: block == null ? void 0 : block.node.attrs[BlockAttrsParams.CONTEXT_UUID]
    },
    seshatBlockContent
  );
  tr.insert(contentNodeEnd + SESHAT_CONTENT_DEPTH, seshatBlock);
  const newChildDepth = SESHAT_CONTENT_DEPTH + 1;
  const newSeshatBlockContentTemporaryStart = contentNodeEnd + SESHAT_CONTENT_DEPTH + newChildDepth;
  const numberOfPositionDeletedInNewNode = selectionEnd - contentNodeStart;
  tr.delete(
    newSeshatBlockContentTemporaryStart,
    newSeshatBlockContentTemporaryStart + numberOfPositionDeletedInNewNode
  );
  tr.delete(selectionStart, contentNodeEnd);
  const numberOfPositionDeletedInOldNode = contentNodeEnd - selectionStart;
  tr.setSelection(
    TextSelection.create(
      tr.doc,
      newSeshatBlockContentTemporaryStart - numberOfPositionDeletedInOldNode
    )
  ).scrollIntoView();
  return tr;
};
const unwrapBlock = ({
  ignoreAtStart
} = {}) => ({ state, tr, dispatch }) => {
  var _a2;
  const { $from, from } = state.selection;
  const isAtStart = $from.parentOffset === 0;
  if (!isAtStart && !ignoreAtStart)
    return false;
  const previousBlock = getPreviousBlock(state.doc, from);
  const previousBlockType = (_a2 = previousBlock == null ? void 0 : previousBlock.node) == null ? void 0 : _a2.attrs.type;
  if (getNodeTypeByBlockType(previousBlockType) !== SeshatNodes.WRAPPING_BLOCK)
    return false;
  dispatch == null ? void 0 : dispatch(unwrapBlockTransaction({ tr, state }));
  return true;
};
const unwrapBlockTransaction = ({
  state,
  tr
}) => {
  var _a2, _b2, _c2, _d2, _e2;
  const { $from } = tr.selection;
  const previousSibling = getPreviousSibling({ $from });
  const blockSel = isBlockSelection(state.selection) ? state.selection : BlockSelection.createFromTextSelection(state.doc, state.selection);
  const fragment = blockSel.getFragment();
  const isColumn = ((_b2 = (_a2 = previousSibling == null ? void 0 : previousSibling.node) == null ? void 0 : _a2.attrs) == null ? void 0 : _b2.type) === BlockTypes.BLOCK_COLUMN;
  const isLine = ((_d2 = (_c2 = previousSibling == null ? void 0 : previousSibling.node) == null ? void 0 : _c2.attrs) == null ? void 0 : _d2.type) === BlockTypes.BLOCK_LINE;
  const offset = isLine || isColumn ? -2 : -1;
  tr.delete(blockSel.from, blockSel.to);
  tr.insert(blockSel.from + offset, fragment);
  if (((_e2 = previousSibling == null ? void 0 : previousSibling.node) == null ? void 0 : _e2.childCount) === 1) {
    tr.delete(blockSel.to, blockSel.to + 1);
  }
  if (isBlockSelection(state.selection)) {
    tr.setSelection(
      BlockSelection.createFromRange(
        tr.doc,
        blockSel.from + offset,
        blockSel.to + offset
      )
    );
  } else {
    tr.setSelection(
      TextSelection.create(tr.doc, state.selection.from + offset)
    );
  }
  return tr;
};
const unwrapChildrenAndMoveContentToTarget = ({
  previousTarget,
  block
}) => ({
  tr,
  dispatch
}) => {
  if (!block)
    return false;
  const { selection } = tr;
  const { $from } = selection;
  const isEmpty = isSeshatBlockEmpty(block.node);
  const previousNodeDepth = previousTarget.node ? getNodeDepth(previousTarget.node) : 0;
  const offsetToReachEndOfPreviousTarget = isEmpty ? 0 : previousNodeDepth;
  if ((block == null ? void 0 : block.node.firstChild) && block.node.childCount > 1) {
    const firstChildSize = block.node.firstChild.nodeSize;
    const secondChildPos = $from.start(block.depth) + firstChildSize;
    const range = tr.doc.resolve(secondChildPos).blockRange(tr.doc.resolve($from.end(block.depth)));
    if (range)
      tr.lift(range, block.depth - 1);
  }
  const endOfPreviousTarget = previousTarget.pos + previousTarget.node.nodeSize;
  const caretPos = endOfPreviousTarget - previousNodeDepth;
  tr.delete(endOfPreviousTarget - offsetToReachEndOfPreviousTarget, $from.pos);
  tr.setSelection(TextSelection.create(tr.doc, caretPos)).scrollIntoView();
  dispatch == null ? void 0 : dispatch(tr);
  return true;
};
const unwrapInParentBlock = ({
  ignoreAtStart
} = {}) => ({ editor, state, commands }) => {
  const { selection } = state;
  const { $from } = selection;
  const isAtStart = $from.parentOffset === 0;
  if (!isAtStart && !ignoreAtStart)
    return false;
  const wrappingBlock = getWrappingBlock(state);
  if (!wrappingBlock)
    return false;
  const isRootBlock2 = wrappingBlock.depth === SESHAT_ROOT_DEPTH;
  if (isRootBlock2)
    return false;
  if (isLauncherEditor(editor) && isAtStartOfEmptyLastBlockInHighlightNote({ wrappingBlock, state }))
    return commands.liftBlockOutOfHighlights();
  if (!isFirstOrLastItem(wrappingBlock))
    return false;
  if (isHighlightBlockquote(state.doc, wrappingBlock))
    return false;
  return commands.outdentBlock({ stopPropagation: false });
};
const isFirstOrLastItem = (wrappingBlock) => {
  const isLastItem = wrappingBlock.childIndex === wrappingBlock.node.childCount - 1;
  const isFirstItem = wrappingBlock.childIndex === 0;
  return isLastItem || isFirstItem;
};
const isHighlightBlockquote = (doc, wrappingBlock) => {
  if (!wrappingBlock.node || wrappingBlock.node.attrs.type !== BlockTypes.BLOCKQUOTE)
    return false;
  const nodeBefore = doc.nodeAt(minMax(wrappingBlock.pos - 2, 0, doc.nodeSize));
  return (nodeBefore == null ? void 0 : nodeBefore.attrs) && (nodeBefore == null ? void 0 : nodeBefore.attrs.type) === BlockTypes.HIGHLIGHT;
};
const isAtStartOfEmptyLastBlockInHighlightNote = ({
  state,
  wrappingBlock
}) => {
  if (wrappingBlock.node.attrs.type !== BlockTypes.HIGHLIGHT_NOTE)
    return false;
  const isLast = wrappingBlock.childIndex === wrappingBlock.node.childCount - 1;
  if (!isLast)
    return false;
  const isStart = state.selection.$from.parentOffset === 0;
  if (!isStart)
    return false;
  const parent = getCurrentBlock(state.doc, state.selection.from);
  return (parent == null ? void 0 : parent.node) && isSeshatBlockEmpty(parent.node);
};
const getWrappingBlock = (state) => {
  const block = getCurrentBlock(state.doc, state.selection.from);
  if (!block)
    return void 0;
  const parentNode = state.selection.$from.node(block.depth - 1);
  return parentNode.type.name === SeshatNodes.WRAPPING_BLOCK ? {
    node: parentNode,
    pos: state.selection.$from.start(block.depth - 1),
    childIndex: state.selection.$from.index(block.depth - 1),
    depth: block.depth - 1
  } : void 0;
};
const updateBlockAttributesAt = (props) => ({ state, dispatch, tr }) => {
  dispatch == null ? void 0 : dispatch(updateBlockAttributesAtTransaction({ state, tr, ...props }));
  return true;
};
const updateBlockAttributesAtTransaction = ({
  tr,
  pos,
  attrs,
  scrollIntoView
}) => {
  const node = tr.doc.nodeAt(pos);
  if ((node == null ? void 0 : node.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return false;
  tr.setNodeMarkup(pos, void 0, {
    ...node.attrs,
    ...attrs
  });
  if (scrollIntoView)
    tr.scrollIntoView();
  return tr;
};
const wrapIntoBlock = (attrs) => ({
  dispatch,
  tr,
  state
}) => {
  if (getNodeTypeByBlockType(attrs.type) !== SeshatNodes.WRAPPING_BLOCK)
    return false;
  dispatch == null ? void 0 : dispatch(wrapIntoBlockTransaction({ tr, attrs, schema: state.schema }));
  return true;
};
const wrapIntoBlockTransaction = ({
  tr,
  attrs,
  schema
}) => {
  if (getNodeTypeByBlockType(attrs.type) !== SeshatNodes.WRAPPING_BLOCK)
    return tr;
  const block = getCurrentBlock(tr.doc, tr.selection.from);
  if (!block)
    return tr;
  const range = tr.doc.resolve(block.from).blockRange(tr.doc.resolve(block.to));
  if (!range)
    return tr;
  tr.wrap(range, [{ type: schema.nodes[SeshatNodes.WRAPPING_BLOCK], attrs }]);
  tr.scrollIntoView();
  return tr;
};
const seshatBlockCommands = {
  deleteBlock,
  duplicateBlock,
  focusAtSelectionEnd,
  focusLastPosition,
  indentBlock,
  insertBlock,
  insertSoftBreak,
  insertSoftBreakOnEnter,
  insertSoftTab,
  onBackspace,
  onDelete,
  onEnter,
  onHardBreak,
  outdentBlock,
  removeFirstLine,
  resetBlock,
  replaceSelection,
  replaceContent,
  replaceWith,
  scrollToBlock,
  setCaretNearby,
  splitBlock,
  unwrapBlock,
  unwrapChildrenAndMoveContentToTarget,
  unwrapInParentBlock,
  updateBlockAttributes,
  updateBlockAttributesAt,
  wrapIntoBlock
};
const checkNodeHasMark = (node, markType) => {
  var _a2;
  return (_a2 = node == null ? void 0 : node.marks) == null ? void 0 : _a2.some((r2) => {
    var _a3;
    return ((_a3 = r2 == null ? void 0 : r2.type) == null ? void 0 : _a3.name) === markType;
  });
};
class CustomDOMParser extends DOMParser {
  parse(dom, options = {}) {
    return super.parse(dom, { ...options, preserveWhitespace: "full" });
  }
  static fromSchema(schema) {
    return schema.cached.domParser || (schema.cached.domParser = new CustomDOMParser(
      schema,
      CustomDOMParser.schemaRules(schema)
    ));
  }
}
const seshatDOMSerializer = (schema) => {
  return new Plugin({
    key: new PluginKey("seshatDomParser"),
    props: {
      domParser: CustomDOMParser.fromSchema(schema)
    }
  });
};
const searchForContent = ({
  content
}) => content.reduce((result, node) => {
  const nodeContent = node.content.content || [];
  if (node.type.name === SeshatNodes.CONTENT) {
    return [...result, ...nodeContent || []];
  } else {
    return [...result, ...searchForContent({ content: nodeContent })];
  }
}, []);
const getMarkNodesFromDom = ({
  schema,
  htmlNode
}) => {
  const proseMirrorNode = CustomDOMParser.fromSchema(schema).parse(htmlNode).content;
  const content = proseMirrorNode.content;
  const markSlice = searchForContent({ content });
  return markSlice;
};
const markInputRuleWithSetContent = ({
  regexp,
  markType,
  getAttributes,
  getText
}) => {
  return new InputRule({
    find: regexp,
    handler: ({ state, match, range, commands }) => {
      const { tr } = state;
      const attributes = getAttributes == null ? void 0 : getAttributes(match);
      const text = (getText == null ? void 0 : getText(match)) || match[match.length - 1];
      const fullMatch = match[0];
      let markEnd = range.to;
      if (!text)
        return;
      const startSpaces = fullMatch.search(/\S/);
      const textStart = range.from + fullMatch.indexOf(text);
      const textEnd = textStart + text.length;
      const excludedMarks = getMarksBetween(range.from, range.to, state.doc).filter((item) => {
        return item.mark.type.excluded.find(
          (type) => type.name === markType.name
        );
      }).filter((item) => item.to > textStart);
      if (excludedMarks.length)
        return;
      if (textEnd < range.to) {
        tr.delete(textEnd, range.to);
      }
      if (textStart > range.from) {
        tr.delete(range.from + startSpaces, textStart);
      }
      markEnd = range.from + startSpaces + text.length;
      tr.addMark(
        range.from + startSpaces,
        markEnd,
        markType.create(attributes)
      );
      tr.removeStoredMark(markType);
      commands.command(({ dispatch }) => {
        dispatch == null ? void 0 : dispatch(tr);
        return true;
      });
      return;
    }
  });
};
const getNodeMarkAttributes = (node, markType) => {
  var _a2, _b2;
  return (_b2 = (_a2 = node == null ? void 0 : node.marks) == null ? void 0 : _a2.find((r2) => {
    var _a3;
    return ((_a3 = r2 == null ? void 0 : r2.type) == null ? void 0 : _a3.name) === markType;
  })) == null ? void 0 : _b2.attrs;
};
const updateLink = (url) => ({ chain }) => {
  return chain().focus().extendMarkRange("link").setLink({ href: url }).run();
};
const inputRegexExact = /(https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,}\b(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)(?:[-a-zA-Z0-9@:%._+~#=?!&/]*))[?:^|\s\n]$/gi;
const markdownRegexExact = /(?:^|\s)\[([\w\s\d]+)\]\((https?:\/\/[\w\d./?=#]+)\)$/gi;
const LinkMark = Link.extend({
  priority: 1e4,
  addCommands() {
    var _a2;
    return {
      ...(_a2 = this.parent) == null ? void 0 : _a2.call(this),
      updateLink
    };
  },
  addOptions() {
    var _a2, _b2;
    return {
      ...(_a2 = this.parent) == null ? void 0 : _a2.call(this),
      linkOnPaste: false,
      HTMLAttributes: {
        ...(_b2 = this.parent) == null ? void 0 : _b2.call(this).HTMLAttributes,
        class: void 0
      }
    };
  },
  addInputRules() {
    return [
      markInputRule({
        find: inputRegexExact,
        type: this.type,
        getAttributes: (match) => {
          const href = match == null ? void 0 : match[1];
          return { href };
        }
      }),
      markInputRuleWithSetContent({
        regexp: markdownRegexExact,
        markType: this.type,
        getAttributes: (match) => {
          const href = match == null ? void 0 : match[2];
          return {
            href
          };
        },
        getText: (match) => match == null ? void 0 : match[1]
      })
    ];
  },
  renderHTML({ HTMLAttributes }) {
    const attrs = mergeAttributes(HTMLAttributes, {
      ...HTMLAttributes
    });
    return ["a", attrs, 0];
  }
});
const getLinkAttributes = (state, pos) => {
  const isRange = isRangeTextSelected(state);
  const { $from } = state.selection;
  const position = pos != null ? pos : isRange ? $from.pos + 1 : $from.pos;
  const { node } = getNodeFromPosition(state, position);
  if (!node)
    return void 0;
  const isLinkNode = checkNodeHasMark(node, MarkTypes.LINK);
  if (!isLinkNode)
    return void 0;
  return getNodeMarkAttributes(node, MarkTypes.LINK);
};
const StrikeMark = Strike.extend({
  addKeyboardShortcuts() {
    return {
      [shortcutConfig.strikethrough]: () => this.editor.commands.toggleStrike()
    };
  }
});
const ShineMark = Mark.create({
  name: MarkTypes.SHINE,
  addOptions() {
    return {
      class: "shine"
    };
  },
  parseHTML() {
    return [
      {
        tag: "span.shine"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(this.options, HTMLAttributes), 0];
  }
});
const ExternalImageNode = Node$1.create({
  name: SeshatInlineNodes.EXTERNAL_IMAGE,
  group: "inline",
  inline: true,
  atom: true,
  selectable: false,
  marks: `${MarkTypes.HIGHLIGHT}`,
  addOptions() {
    return {
      style: "max-width: 100%"
    };
  },
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      height: {
        default: null
      },
      width: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "img[src]",
        priority: 55,
        getAttrs: (node) => {
          var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
          if (typeof node === "string")
            return false;
          const htmlNode = node;
          const src = (_a2 = htmlNode.attributes.getNamedItem("src")) == null ? void 0 : _a2.value;
          const alt = (_c2 = (_b2 = htmlNode.attributes) == null ? void 0 : _b2.getNamedItem("alt")) == null ? void 0 : _c2.value;
          const width = (_e2 = (_d2 = htmlNode.attributes) == null ? void 0 : _d2.getNamedItem("width")) == null ? void 0 : _e2.value;
          const height = (_g2 = (_f2 = htmlNode.attributes) == null ? void 0 : _f2.getNamedItem("height")) == null ? void 0 : _g2.value;
          const ABSOLUTE_URL_REGEX = /^https:\/\//i;
          if (src && !ABSOLUTE_URL_REGEX.test(src))
            return false;
          return { src, alt, width, height };
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["img", mergeAttributes(this.options, HTMLAttributes)];
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("preventExternalImageParseRulesOnPaste"),
        props: {
          transformPastedHTML: (html) => {
            const isImagePasteRegex = /^(<meta charset='utf-8'>)*<img [^>]*src=".*?[^]"[^>]*\/>$/g;
            return html.match(isImagePasteRegex) ? "" : html;
          }
        }
      })
    ];
  }
});
const MentionNode = (options) => Node$1.create({
  name: SeshatInlineNodes.REFERENCE,
  inline: true,
  selectable: false,
  atom: true,
  group: "inline",
  addAttributes() {
    return {
      char: {
        default: void 0
      },
      id: {
        parseHTML: (element) => {
          return element.dataset.uuid || element.id;
        },
        renderHTML: (attributes) => {
          if (!attributes.id) {
            return {};
          }
          return {
            "data-uuid": attributes.id
          };
        }
      },
      cardUuid: {
        parseHTML: (element) => {
          return element.dataset.uuid || element.id;
        },
        renderHTML: (attributes) => {
          if (!attributes.id) {
            return {};
          }
          return {
            "data-uuid": attributes.id
          };
        }
      },
      value: {
        default: void 0,
        parseHTML: (element) => {
          return element.dataset.value;
        },
        renderHTML: (attributes) => {
          if (!attributes.value) {
            return {};
          }
          return { value: attributes.value };
        }
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "span[data-mention]"
      },
      {
        tag: "a.reference"
      }
    ];
  },
  addOptions() {
    return options == null ? void 0 : options.mentions;
  },
  addKeyboardShortcuts() {
    return {
      Backspace: ({ editor }) => {
        return editor.commands.command(({ tr, commands }) => {
          return shouldDeleteLastCharBetweenBlockStartAndMention(tr) ? commands.deleteRange({
            from: tr.selection.from - 1,
            to: tr.selection.from
          }) : false;
        });
      }
    };
  },
  renderText({ node }) {
    var _a2, _b2;
    return `${(_a2 = node.attrs.char) != null ? _a2 : ""}${(_b2 = node.attrs.value) != null ? _b2 : node.attrs.cardUuid}`;
  },
  renderHTML({ HTMLAttributes }) {
    return ["reference", mergeAttributes(HTMLAttributes)];
  },
  addCommands() {
    return {
      insertMention: (attrs) => ({
        state,
        dispatch
      }) => {
        const { tr, selection } = state;
        const { $from } = selection;
        const node = this.type.create({
          ...attrs
        });
        tr.insert($from.pos, node);
        dispatch == null ? void 0 : dispatch(tr);
        return true;
      }
    };
  }
});
const shouldDeleteLastCharBetweenBlockStartAndMention = (tr) => {
  var _a2;
  return tr.selection.empty && tr.selection.$from.parentOffset === 1 && ((_a2 = tr.selection.$to.nodeAfter) == null ? void 0 : _a2.type.name) === "reference";
};
const TextNode = Text.extend({ marks: "_" });
const seshatBlockInputRule = ({
  regexp,
  getAttrs
}) => {
  return new InputRule({
    find: regexp,
    handler: ({ match, state, commands }) => {
      const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || { type: BlockTypes.PARAGRAPH };
      const { tr, selection } = state;
      const { $from } = selection;
      tr.deleteRange($from.pos - match[0].length + 1, $from.pos);
      const parent = getCurrentBlock(tr.doc, tr.selection.from);
      if ((parent == null ? void 0 : parent.node.attrs.type) === BlockTypes.CARD_CONTENT)
        return;
      if (getNodeTypeByBlockType(attrs.type) === SeshatNodes.WRAPPING_BLOCK) {
        commands.wrapIntoBlock(attrs);
      } else {
        commands.updateBlockAttributes(attrs);
      }
    }
  });
};
const SeshatBlockGroup = (options) => applyContextIdToExtension(
  applyBlockIdToExtension(options)(
    Node$1.create({
      group: SeshatNodeGroups.BLOCK,
      defining: true,
      addOptions() {
        return {
          class: SeshatCssClass.BLOCK
        };
      },
      addAttributes() {
        return seshatBlockAttributes;
      },
      addCommands() {
        return seshatBlockCommands;
      },
      addKeyboardShortcuts() {
        return {
          Enter: () => {
            var _a2, _b2;
            if ((_b2 = (_a2 = this.editor.commands).unsetBlockSelection) == null ? void 0 : _b2.call(_a2))
              return true;
            return this.editor.commands.first(({ commands }) => [
              () => commands.insertSoftBreakOnEnter(),
              () => commands.onEnter()
            ]);
          },
          Delete: () => {
            return this.editor.commands.first(({ commands }) => [
              () => commands.onDelete()
            ]);
          },
          "Mod-Enter": () => {
            return this.editor.commands.first(({ commands }) => [
              () => commands.onHardBreak()
            ]);
          },
          "Mod-d": () => {
            return this.editor.commands.first(({ commands }) => [
              () => commands.duplicateBlock()
            ]);
          },
          "Shift-Enter": () => {
            return this.editor.commands.insertSoftBreak();
          },
          Backspace: () => {
            return this.editor.commands.first(({ commands }) => [
              () => commands.deleteBlockSelection && commands.deleteBlockSelection(),
              () => commands.unwrapInParentBlock(),
              () => commands.onBackspace()
            ]);
          },
          Tab: () => {
            return this.editor.commands.first(({ commands }) => [
              () => commands.insertSoftTab(),
              () => commands.indentBlock()
            ]);
          },
          "Shift-Tab": () => {
            return this.editor.commands.outdentBlock();
          },
          ...seshatBlockShortcut.reduce(
            (result, value) => {
              result[value.keys] = () => {
                var _a2;
                const editor = this.editor;
                const cfg = ALL_BLOCK_COMMANDS.find(
                  (b) => b.type === value.type
                );
                return (_a2 = cfg == null ? void 0 : cfg.runCommand(editor)) != null ? _a2 : editor.commands.updateBlockAttributes({
                  type: value.type
                });
              };
              return result;
            },
            {}
          )
        };
      },
      addProseMirrorPlugins() {
        return [seshatDOMSerializer(this.editor.state.schema)];
      },
      addInputRules() {
        return seshatBlockMarkdown.reduce((result, value) => {
          return [
            ...result,
            ...value.regexExps.map(
              (regex) => seshatBlockInputRule({
                regexp: regex,
                getAttrs: (match) => ({
                  type: value.type,
                  ...match.groups
                })
              })
            )
          ];
        }, []);
      },
      renderHTML({ HTMLAttributes }) {
        return ["div", mergeAttributes(this.options, HTMLAttributes), 0];
      }
    })
  )
);
const defaultCodeBlockAttrs = { type: BlockTypes.CODE };
const getTextContentFromHTMLElement = (element) => {
  var _a2;
  const text = ((_a2 = element == null ? void 0 : element.querySelector("code")) == null ? void 0 : _a2.textContent) || element.textContent;
  return text == null ? void 0 : text.replace(/\r\n?/g, "\n").replaceAll("  \n", "\n");
};
const parseCodeBlockHtml = ({
  priority
}) => [
  {
    tag: "pre",
    priority,
    preserveWhitespace: "full",
    attrs: defaultCodeBlockAttrs,
    getContent: (node, schema) => {
      var _a2;
      const element = node;
      const text = (_a2 = getTextContentFromHTMLElement(element)) != null ? _a2 : "";
      return createSeshatBlock({ schema, content: text }).content;
    }
  },
  {
    tag: "table.highlight[data-tagsearch-lang]",
    priority,
    preserveWhitespace: "full",
    getContent: (node, schema) => {
      var _a2;
      const element = node;
      const text = (_a2 = getTextContentFromHTMLElement(element)) != null ? _a2 : "";
      return createSeshatBlock({ schema, content: text }).content;
    },
    getAttrs: (node) => {
      var _a2;
      const htmlNode = node;
      const language = (_a2 = htmlNode.getAttribute("data-tagsearch-lang")) == null ? void 0 : _a2.toLowerCase();
      if (!language || !isSupportedCodeBlockLanguage(language))
        return defaultCodeBlockAttrs;
      return {
        ...defaultCodeBlockAttrs,
        language
      };
    }
  },
  {
    tag: 'div[data-codeblock="true"]',
    attrs: defaultCodeBlockAttrs,
    priority
  }
];
const pushNodeToSeshatBlockContent = ({
  nodeToPush,
  schema,
  seshatBlockType,
  indentedNode
}) => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  const seshatContent = seshatBlockType === BlockTypes.NODE_VIEW ? (_b2 = (_a2 = schema.nodes) == null ? void 0 : _a2[SeshatNodes.CONTENT_NODE_VIEW]) == null ? void 0 : _b2.create({}, [nodeToPush]) : (_d2 = (_c2 = schema.nodes) == null ? void 0 : _c2[SeshatNodes.CONTENT]) == null ? void 0 : _d2.create({}, [nodeToPush]);
  const seshatBlockContent = (_f2 = (_e2 = schema.nodes) == null ? void 0 : _e2[SeshatNodes.BLOCK_CONTENT]) == null ? void 0 : _f2.create({}, [seshatContent, ...indentedNode || []]);
  return seshatBlockContent;
};
const pushNodeToSeshatBlock = ({
  nodeToPush,
  schema,
  seshatBlockType,
  indentedNode
}) => {
  var _a2, _b2;
  const seshatBlockContent = pushNodeToSeshatBlockContent({
    nodeToPush,
    schema,
    seshatBlockType,
    indentedNode
  });
  const seshatBlock = (_b2 = (_a2 = schema.nodes) == null ? void 0 : _a2[SeshatNodes.BLOCK]) == null ? void 0 : _b2.create(
    {
      type: seshatBlockType
    },
    [seshatBlockContent]
  );
  return seshatBlock;
};
const parseDividerHtml = ({
  priority
}) => [
  {
    tag: "hr",
    priority,
    attrs: { type: BlockTypes.NODE_VIEW },
    getContent: (_, schema) => {
      var _a2, _b2;
      const dividerNode = (_b2 = (_a2 = schema.nodes) == null ? void 0 : _a2[NodeViewTypes.HORIZONTAL_RULE]) == null ? void 0 : _b2.create(
        {},
        []
      );
      const seshatBlock = pushNodeToSeshatBlock({
        schema,
        nodeToPush: dividerNode,
        seshatBlockType: BlockTypes.NODE_VIEW
      });
      return seshatBlock;
    }
  }
];
const parseFileHtml = ({ priority }) => [
  {
    tag: "section.file",
    attrs: { type: BlockTypes.NODE_VIEW },
    priority,
    getContent: (node, schema) => {
      var _a2, _b2, _c2, _d2;
      const htmlNode = node;
      const fileUUID = (_b2 = (_a2 = htmlNode.attributes) == null ? void 0 : _a2.getNamedItem("data-id")) == null ? void 0 : _b2.value;
      const file = (_d2 = (_c2 = schema.nodes) == null ? void 0 : _c2[NodeViewTypes.FILE]) == null ? void 0 : _d2.create({
        fileUuid: fileUUID
      });
      const seshatBlock = pushNodeToSeshatBlock({
        nodeToPush: file,
        schema,
        seshatBlockType: BlockTypes.NODE_VIEW
      });
      return seshatBlock;
    }
  }
];
const parseIframeHtml = ({ priority }) => [
  {
    tag: "figure.media>oembed",
    attrs: { type: BlockTypes.NODE_VIEW },
    priority,
    getContent: (node, schema) => {
      var _a2, _b2, _c2, _d2;
      const htmlNode = node;
      const src = (_b2 = (_a2 = htmlNode.attributes) == null ? void 0 : _a2.getNamedItem("url")) == null ? void 0 : _b2.value;
      const iframe = (_d2 = (_c2 = schema.nodes) == null ? void 0 : _c2[NodeViewTypes.IFRAME]) == null ? void 0 : _d2.create({
        src
      });
      const seshatBlock = pushNodeToSeshatBlock({
        nodeToPush: iframe,
        schema,
        seshatBlockType: BlockTypes.NODE_VIEW
      });
      return seshatBlock;
    }
  }
];
const extractSubList = ({
  htmlNode,
  schema
}) => {
  if (!htmlNode.innerHTML)
    return [];
  const ul = htmlNode.querySelector("ul");
  if (ul)
    ul.remove();
  const children = Array.from((ul == null ? void 0 : ul.children) || []).map(
    (node) => {
      if (!node.innerHTML)
        return node;
      return getListContent({ node, schema });
    }
  );
  return children;
};
const getListContent = ({ node, schema }) => {
  const htmlNode = node;
  htmlNode.innerHTML = htmlNode.innerHTML.replace(/[\n\r\t]/g, "");
  const children = extractSubList({
    htmlNode,
    schema
  });
  const attrs = htmlNode.attributes;
  const content = getMarkNodesFromDom({ schema, htmlNode });
  const seshatBlock = createSeshatBlock({
    attrs: { ...attrs, type: BlockTypes.BULLETED_LIST },
    schema,
    content,
    children
  });
  return seshatBlock;
};
const parseListHtml = ({
  priority,
  type,
  tag
}) => ({
  tag,
  attrs: { type },
  priority,
  getContent: (node, schema) => getListContent({ node, schema })
});
const CK5_TODO = "ul.todo-list>li";
const EVERNOTE_TODO = "ul[data-todo]>li";
const parseTodoHtml = ({ priority }) => [
  {
    tag: CK5_TODO,
    getAttrs: (node) => {
      var _a2;
      const input = (_a2 = node == null ? void 0 : node.querySelector) == null ? void 0 : _a2.call(node, "input");
      const isDone = input == null ? void 0 : input.checked;
      return {
        type: BlockTypes.CARD_CONTENT,
        collapsed: true,
        cardType: "task",
        isDone
      };
    },
    priority,
    getContent: (node, schema) => getCardContent(node, schema)
  },
  {
    tag: EVERNOTE_TODO,
    priority,
    getAttrs: (node) => {
      const htmlNode = node;
      const isDone = htmlNode.getAttribute("data-checked") !== "false";
      return {
        type: BlockTypes.CARD_CONTENT,
        collapsed: true,
        cardType: "task",
        isDone
      };
    },
    getContent: (node, schema) => getCardContent(node, schema)
  }
];
function getCardContent(node, schema) {
  const textContent = (node == null ? void 0 : node.textContent) ? [schema.text(node == null ? void 0 : node.textContent)] : void 0;
  const seshatContent = schema.nodes.seshatContent.create({}, textContent);
  const seshatBlockContent = schema.nodes[SeshatNodes.BLOCK_CONTENT].create(
    {},
    [seshatContent]
  );
  return Fragment.from([
    seshatBlockContent,
    createSeshatBlock({
      schema,
      attrs: { type: BlockTypes.PARAGRAPH }
    })
  ]);
}
const SeshatBlockNodeConfig = {
  name: SeshatNodes.BLOCK,
  content: `${SeshatNodes.BLOCK_CONTENT} ${SeshatNodeGroups.BLOCK}*`,
  parseHTML() {
    return [
      ...parseTodoHtml({ priority: 56 }),
      ...parseDividerHtml({ priority: 55 }),
      ...parseCodeBlockHtml({ priority: 55 }),
      ...parseFileHtml({ priority: 55 }),
      ...parseIframeHtml({ priority: 55 }),
      parseListHtml({
        tag: "ol>li",
        type: BlockTypes.NUMBERED_LIST,
        priority: 55
      }),
      parseListHtml({
        tag: "ul>li",
        type: BlockTypes.BULLETED_LIST,
        priority: 55
      }),
      {
        tag: "h1.clipContentTitle",
        attrs: { type: BlockTypes.CLIP_CONTENT_TITLE },
        priority: 56
      },
      { tag: "h1", attrs: { type: BlockTypes.HEADING_1 }, priority: 55 },
      { tag: "h2", attrs: { type: BlockTypes.HEADING_2 }, priority: 55 },
      { tag: "h3", attrs: { type: BlockTypes.HEADING_3 }, priority: 55 },
      { tag: "h4", attrs: { type: BlockTypes.HEADING_4 }, priority: 55 },
      { tag: "h5", attrs: { type: BlockTypes.HEADING_4 }, priority: 55 },
      { tag: "h6", attrs: { type: BlockTypes.HEADING_4 }, priority: 55 },
      { tag: "p", attrs: { type: BlockTypes.PARAGRAPH }, priority: 51 },
      {
        tag: "div",
        priority: 51,
        getAttrs: (node) => {
          const element = node;
          const containsCodeBlock = !!element.querySelector("pre");
          return containsCodeBlock ? false : { type: BlockTypes.PARAGRAPH };
        }
      },
      { tag: "td", attrs: { type: BlockTypes.PARAGRAPH }, priority: 40 },
      { tag: "th", attrs: { type: BlockTypes.PARAGRAPH }, priority: 40 }
    ];
  }
};
const SeshatBlockNode = (options) => SeshatBlockGroup(options).extend(SeshatBlockNodeConfig);
const SeshatWrappingBlockNodeConfig = {
  name: SeshatNodes.WRAPPING_BLOCK,
  content: `${SeshatNodeGroups.BLOCK}*`,
  parseHTML() {
    return [
      {
        tag: "blockquote.tweet",
        attrs: { type: BlockTypes.TWEET },
        priority: 57
      },
      {
        tag: "blockquote",
        attrs: { type: BlockTypes.BLOCKQUOTE },
        priority: 56
      },
      {
        tag: "tr",
        attrs: { type: BlockTypes.BLOCK_LINE },
        priority: 55,
        consuming: false
      },
      {
        tag: "td",
        consuming: false,
        attrs: { type: BlockTypes.BLOCK_COLUMN },
        priority: 55
      },
      {
        tag: "th",
        consuming: false,
        attrs: { type: BlockTypes.BLOCK_COLUMN },
        priority: 55
      }
    ];
  }
};
const SeshatWrappingBlockNode = (options) => SeshatBlockGroup(options).extend(SeshatWrappingBlockNodeConfig);
const SeshatBlockContentNode = Node$1.create({
  name: SeshatNodes.BLOCK_CONTENT,
  group: `${SeshatNodes.BLOCK_CONTENT}`,
  defining: true,
  content: `${SeshatNodes.CONTENT}`,
  addOptions() {
    return {
      class: SeshatCssClass.BLOCK_CONTENT
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(this.options, HTMLAttributes), 0];
  }
});
const SeshatContent = Node$1.create({
  priority: 1e3,
  group: `${SeshatNodeGroups.CONTENT}`,
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(this.options, HTMLAttributes), 0];
  }
});
const SeshatContentNode = SeshatContent.extend({
  name: SeshatNodes.CONTENT,
  content: "inline*",
  addOptions() {
    return {
      class: SeshatCssClass.CONTENT
    };
  }
});
const SeshatNodeViewContentNode = SeshatContent.extend({
  name: SeshatNodes.CONTENT_NODE_VIEW,
  content: SeshatNodeGroups.NODE_VIEW,
  addOptions() {
    return {
      class: SeshatCssClass.CONTENT_NODE_VIEW
    };
  },
  addCommands() {
    return {
      insertNodeViewContent
    };
  }
});
const editorNodeConfig = {
  [ClipBookBlock.name]: {
    extension: ClipBookBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [ClipBookmarkBlock.name]: {
    extension: ClipBookmarkBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [ExternalImageNode.name]: {
    extension: ExternalImageNode,
    targetedEditorVersions: ["all_editors"]
  },
  [TextNode.name]: {
    extension: TextNode,
    targetedEditorVersions: ["all_editors"]
  },
  [IFrameBlock.name]: {
    extension: IFrameBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [FileBlock.name]: {
    extension: FileBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [LayoutNode.name]: {
    extension: LayoutNode,
    targetedEditorVersions: ["all_editors"]
  },
  [MentionNode.name]: {
    extension: MentionNode,
    targetedEditorVersions: ["all_editors"]
  },
  [MentionPlaceholderNodes.name]: {
    extension: MentionPlaceholderNodes,
    targetedEditorVersions: ["all_editors"]
  },
  [HorizontalRuleBlock.name]: {
    extension: HorizontalRuleBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [TableOfContentsBlock.name]: {
    extension: TableOfContentsBlock,
    targetedEditorVersions: ["main"]
  },
  [SeshatBlockNode.name]: {
    extension: SeshatBlockNode,
    targetedEditorVersions: ["all_editors"]
  },
  [SeshatBlockContentNode.name]: {
    extension: SeshatBlockContentNode,
    targetedEditorVersions: ["all_editors"]
  },
  [SeshatContentNode.name]: {
    extension: SeshatContentNode,
    targetedEditorVersions: ["all_editors"]
  },
  [SeshatNodeViewContentNode.name]: {
    extension: SeshatNodeViewContentNode,
    targetedEditorVersions: ["all_editors"]
  },
  [SeshatWrappingBlockNode.name]: {
    extension: SeshatWrappingBlockNode,
    targetedEditorVersions: ["all_editors"]
  },
  [CardLinkBlock.name]: {
    extension: CardLinkBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [ReadLaterDecorationExtension.name]: {
    extension: ReadLaterDecorationExtension,
    targetedEditorVersions: ["read_later_view"]
  }
};
const editorMarkConfig = {
  [Bold.name]: {
    extension: Bold.extend({
      priority: ((_a = LinkMark.config.priority) != null ? _a : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [Code.name]: {
    extension: Code.extend({
      priority: ((_b = LinkMark.config.priority) != null ? _b : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [Italic.name]: {
    extension: Italic.extend({
      priority: ((_c = LinkMark.config.priority) != null ? _c : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [HighlightMark.name]: {
    extension: HighlightMark,
    targetedEditorVersions: ["all_editors"]
  },
  [StrikeMark.name]: {
    extension: StrikeMark.extend({
      priority: ((_d = LinkMark.config.priority) != null ? _d : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [LinkMark.name]: {
    extension: LinkMark,
    targetedEditorVersions: ["all_editors"]
  },
  [Underline.name]: {
    extension: Underline.extend({
      priority: ((_e = LinkMark.config.priority) != null ? _e : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [TextStyle.name]: {
    extension: TextStyle.extend({
      priority: ((_f = LinkMark.config.priority) != null ? _f : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [ShineMark.name]: {
    extension: ShineMark,
    targetedEditorVersions: ["all_editors"]
  }
};
const editorExtensionConfig = {
  [AnalyticsExtension.name]: {
    extension: AnalyticsExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [AnnotationModeExtension.name]: {
    extension: AnnotationModeExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [BlockSelectionExtension.name]: {
    extension: BlockSelectionExtension,
    targetedEditorVersions: ["main", "launcher"]
  },
  [BlockLineBlock.name]: {
    extension: BlockLineBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [BlockIDExtension.name]: {
    extension: BlockIDExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [BracketsExtension.name]: {
    extension: BracketsExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [CaptureBlock.name]: {
    extension: CaptureBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [CodeBlock.name]: {
    extension: CodeBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [CardBlock.name]: {
    extension: CardBlock,
    targetedEditorVersions: ["main", "launcher"]
  },
  [ClipboardExtension.name]: {
    extension: ClipboardExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [ClipContentBlock.name]: {
    extension: ClipContentBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [ContentEditableExtension.name]: {
    extension: ContentEditableExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [ContextIDExtension.name]: {
    extension: ContextIDExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [DropHandleExtension.name]: {
    extension: DropHandleExtension,
    targetedEditorVersions: ["main", "launcher"]
  },
  [TrailingLineExtension.name]: {
    extension: TrailingLineExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [FontColorExtension.name]: {
    extension: FontColorExtension.extend({
      priority: ((_g = LinkMark.config.priority) != null ? _g : 10) - 1
    }),
    targetedEditorVersions: ["all_editors"]
  },
  [HighlightsBlock.name]: {
    extension: HighlightsBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [HistoryExtension.name]: {
    extension: HistoryExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [MoveBlockExtension.name]: {
    extension: MoveBlockExtension,
    targetedEditorVersions: ["main", "launcher"]
  },
  [TabIndexExtension.name]: {
    extension: TabIndexExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [TaskEditableBlock.name]: {
    extension: TaskEditableBlock,
    targetedEditorVersions: ["all_editors"]
  },
  [TextAlignExtension.name]: {
    extension: TextAlignExtension,
    targetedEditorVersions: ["all_editors"]
  },
  [Typography.name]: {
    extension: Typography,
    targetedEditorVersions: ["all_editors"]
  }
};
const allEditorExtensionConfigs = {
  ...editorNodeConfig,
  ...editorMarkConfig,
  ...editorExtensionConfig
};
const EDITOR_CONTENT_DOM_ID = "seshat_container";
const getEditorExtensions = ({
  extensionOptions,
  extensionConfigs
}) => Object.values(extensionConfigs != null ? extensionConfigs : allEditorExtensionConfigs).filter(({ targetedEditorVersions }) => {
  var _a2;
  if (targetedEditorVersions.includes("all_editors"))
    return true;
  const editorVersion = (_a2 = extensionOptions == null ? void 0 : extensionOptions.extensionVersion) != null ? _a2 : "main";
  return targetedEditorVersions.includes(editorVersion);
}).flatMap(
  ({ extension }) => typeof extension === "function" ? extension(extensionOptions) : extension
);
const SESHAT_SESSION_STORAGE_PREFIX = "@lazy/SESHAT-";
const getNearestClip = ({ doc, from }) => {
  for (let i = from; i <= doc.nodeSize - SESHAT_CONTENT_DEPTH; i++) {
    const node = doc.nodeAt(i);
    if (isSeshatBlockClip(node)) {
      return { node, pos: i };
    }
  }
  for (let i = from; i >= 0; i--) {
    const node = doc.nodeAt(i);
    if (isSeshatBlockClip(node)) {
      return { node, pos: i };
    }
  }
  return void 0;
};
const isSeshatBlockClip = (node) => {
  var _a2;
  if ((node == null ? void 0 : node.type.spec.group) !== SeshatNodeGroups.BLOCK)
    return false;
  const nodeType = (_a2 = node == null ? void 0 : node.attrs.nodeViewType) != null ? _a2 : node == null ? void 0 : node.attrs.type;
  return nodeType && clipBlocks.includes(nodeType);
};
const getNextBlock = (doc, pos, predicate, options) => {
  const $posBefore = doc.resolve(pos - 1);
  const blockBefore = $posBefore.before($posBefore.depth);
  const hasChildren2 = hasBlockBeforeChildren(doc, blockBefore);
  const hasSelectableChildBlocks = !!hasChildren2 && hasSelectableChildren(doc, blockBefore);
  const start = !(options == null ? void 0 : options.ignoreChildren) && hasSelectableChildBlocks ? blockBefore + 1 : pos;
  for (let i = start; i < doc.nodeSize - 1; i++) {
    const node = doc.nodeAt(i);
    const $i = doc.resolve(i);
    if (!isBlock(node, predicate))
      continue;
    return {
      node,
      from: i,
      to: i + node.nodeSize,
      $from: $i,
      $to: doc.resolve(i + node.nodeSize),
      depth: $i.depth
    };
  }
  return void 0;
};
const hasBlockBeforeChildren = (doc, pos) => {
  const blockBefore = doc.nodeAt(pos);
  return blockBefore && hasChildren(blockBefore);
};
const hasSelectableChildren = (doc, pos) => {
  const blockBefore = doc.nodeAt(pos);
  return blockBefore && blockBefore.attrs.collapsed !== true && !isContentEditableFalse(blockBefore);
};
const isSeshatBlockEmpty = (node) => {
  return (node == null ? void 0 : node.type.spec.group) === SeshatNodeGroups.BLOCK && node.nodeSize === 6;
};
const getNodeTypeByBlockType = (type) => {
  if (type && SeshatWrappingBlocks.includes(type))
    return SeshatNodes.WRAPPING_BLOCK;
  else
    return SeshatNodes.BLOCK;
};
const isBlockCollapsible = (node) => {
  return [
    BlockTypes.CARD_CONTENT,
    BlockTypes.TOGGLE_LIST,
    BlockTypes.HIGHLIGHTS
  ].includes(node.attrs.type);
};
const getSeshatContent = (block) => {
  let node = block.firstChild;
  let depth = 1;
  while (node && ![
    SeshatNodes.CONTENT_NODE_VIEW,
    SeshatNodes.CONTENT
  ].includes(node == null ? void 0 : node.type.name)) {
    node = node.firstChild;
    depth++;
  }
  return { node, depth };
};
const findChildByBlockId = ({
  parentNode,
  blockId
}) => {
  let childIndex = -1;
  if (!blockId)
    return { index: childIndex, node: null };
  parentNode.content.content.some((node, index) => {
    if (node.attrs[BlockAttrsParams.BLOCK_UUID] === blockId) {
      childIndex = index;
      return true;
    }
    return false;
  });
  return {
    index: childIndex,
    node: childIndex !== -1 ? parentNode.content.child(childIndex) : null
  };
};
const isRootBlock = (node) => {
  var _a2, _b2;
  return (node == null ? void 0 : node.type.name) === SeshatNodes.BLOCK && ((_a2 = node == null ? void 0 : node.attrs) == null ? void 0 : _a2.type) === BlockTypes.CARD_CONTENT || (node == null ? void 0 : node.type.name) === SeshatNodes.WRAPPING_BLOCK && ((_b2 = node == null ? void 0 : node.attrs) == null ? void 0 : _b2.type) === BlockTypes.CAPTURE;
};
const isRootBlockJSON = (nodeJson) => {
  var _a2, _b2;
  return (nodeJson == null ? void 0 : nodeJson.type) === SeshatNodes.BLOCK && ((_a2 = nodeJson == null ? void 0 : nodeJson.attrs) == null ? void 0 : _a2.type) === BlockTypes.CARD_CONTENT || (nodeJson == null ? void 0 : nodeJson.type) === SeshatNodes.WRAPPING_BLOCK && ((_b2 = nodeJson == null ? void 0 : nodeJson.attrs) == null ? void 0 : _b2.type) === BlockTypes.CAPTURE;
};
const isParentRootBlock = ({
  $from,
  blockDepth
}) => {
  const parent = $from.node(blockDepth);
  const parentStart = $from.start(blockDepth);
  return isRootBlock(parent) && parentStart === 1;
};
const getNearestSeshatBlockParentSelection = ({
  $from
}) => {
  let depth = $from.depth + 1;
  while (depth >= 0) {
    const node = $from.node(depth);
    if ((node == null ? void 0 : node.type.spec.group) === SeshatNodeGroups.BLOCK) {
      return { node, depth, pos: $from.before(depth), to: $from.after(depth) };
    } else {
      depth--;
    }
  }
  return {
    node: void 0,
    depth: $from.depth,
    pos: 0,
    to: 0
  };
};
const getCardUuid = (editor, isReadLater = false) => {
  var _a2;
  const firstBlock = (_a2 = editor.state.doc.content.content) == null ? void 0 : _a2[0];
  if (isReadLater) {
    return firstBlock == null ? void 0 : firstBlock.content.content[0].content.content[0].content.content[0].content.content[0].attrs.parentCardUuid;
  }
  return firstBlock.attrs[BlockAttrsParams.BLOCK_UUID];
};
const formatContentNotACard = (content) => {
  if (isRootBlockJSON(content[0]))
    return content;
  return [
    {
      type: SeshatNodes.WRAPPING_BLOCK,
      attrs: {
        textAlign: "left",
        type: BlockTypes.CAPTURE
      },
      content
    }
  ];
};
const formatParallelSeshatBlock = (content) => {
  var _a2;
  if (content.length <= 1 || !isRootBlockJSON(content[0]))
    return content;
  const firstElement = content.shift();
  return [
    { ...firstElement, content: [...(_a2 = firstElement.content) != null ? _a2 : [], ...content] }
  ];
};
const formatContentCorruptContent = pipe(
  formatParallelSeshatBlock,
  formatContentNotACard
);
const applyContextToAllChildren = (jsonContent, contextUUIDFromCapture) => {
  if (!jsonContent)
    return [];
  return jsonContent.map((node) => {
    var _a2, _b2, _c2;
    if (contextUUIDFromCapture && node.type && [SeshatNodes.BLOCK, SeshatNodes.WRAPPING_BLOCK].includes(
      node.type
    ) && (node == null ? void 0 : node.attrs) && !((_a2 = node == null ? void 0 : node.attrs) == null ? void 0 : _a2[BlockAttrsParams.CONTEXT_UUID])) {
      node.attrs[BlockAttrsParams.CONTEXT_UUID] = contextUUIDFromCapture;
    }
    const contextUUID = (_b2 = node == null ? void 0 : node.attrs) == null ? void 0 : _b2[BlockAttrsParams.CONTEXT_UUID];
    if ((node == null ? void 0 : node.content) && ((_c2 = node == null ? void 0 : node.content) == null ? void 0 : _c2.length) > 0 && contextUUID) {
      node.content = applyContextToAllChildren(node.content, contextUUID);
    }
    return node;
  });
};
const addContextUuidToNodeChildren = ({
  node,
  contextID
}) => {
  Array.from(node.children).forEach((childNote) => {
    childNote == null ? void 0 : childNote.setAttribute(BlockAttrsParams.CONTEXT_UUID, contextID);
    addContextUuidToNodeChildren({ node: childNote, contextID });
  });
};
const createContextFromCaptureDataID = (content) => {
  const div = document.createElement("div");
  div.innerHTML = content;
  const references = div.querySelectorAll(".capture-block");
  Object.values(references).forEach((node) => {
    var _a2;
    const attrs = node.attributes;
    const contextID = (_a2 = attrs == null ? void 0 : attrs.getNamedItem("data-uuid")) == null ? void 0 : _a2.value;
    if (!contextID) {
      return;
    }
    addContextUuidToNodeChildren({ node, contextID });
    node.outerHTML = node.innerHTML;
  });
  return div.innerHTML;
};
const formatBidirectionalLink = (content, bidirectionalName) => {
  if (!bidirectionalName)
    return content;
  const div = document.createElement("div");
  div.innerHTML = content;
  const references = div.querySelectorAll("a[data-uuid]");
  Object.values(references).forEach((node) => {
    var _a2;
    const span = document.createElement("span");
    span.dataset.mention = bidirectionalName;
    const attrs = node.attributes;
    Object.values(attrs).forEach((attr) => {
      if (attr.nodeValue)
        span.setAttribute(attr.nodeName, attr.nodeValue);
    });
    (_a2 = node.parentNode) == null ? void 0 : _a2.replaceChild(span, node);
  });
  return div.innerHTML;
};
const getBlocksUuids = (content) => {
  const div = document.createElement("div");
  div.innerHTML = content;
  const captureBlocks = div.querySelectorAll(".capture-block");
  return Object.values(captureBlocks).map(
    (element) => element.dataset.uuid
  );
};
const proseMirrorNodeToJson = ({
  proseMirrorNode,
  schema
}) => {
  return proseMirrorNode.content.content.map((node) => {
    if (node.type.spec.group !== SeshatNodeGroups.BLOCK) {
      const seshatBlock = createSeshatBlock({
        attrs: { type: BlockTypes.PARAGRAPH },
        schema,
        content: [node]
      });
      return seshatBlock.toJSON();
    }
    return node.toJSON();
  });
};
const removeEmptyParagraphs = (content) => {
  var _a2;
  const div = document.createElement("div");
  div.innerHTML = content;
  const references = div.querySelectorAll("p");
  Object.values(references).forEach((node) => {
    var _a3, _b2;
    if (((_a3 = node == null ? void 0 : node.innerHTML) == null ? void 0 : _a3.length) === 0) {
      (_b2 = node.parentNode) == null ? void 0 : _b2.removeChild(node);
    }
  });
  return (_a2 = div.innerHTML) == null ? void 0 : _a2.replace(/\n/g, " ");
};
const createJSONContentFromHTML = ({
  HTMLContent,
  schema,
  options,
  config
}) => {
  options = {
    slice: true,
    parseOptions: {},
    ...options
  };
  if (typeof HTMLContent === "string") {
    let contentFormatted = formatBidirectionalLink(
      HTMLContent,
      config == null ? void 0 : config.bidirectionalName
    );
    contentFormatted = removeEmptyParagraphs(contentFormatted);
    contentFormatted = createContextFromCaptureDataID(contentFormatted);
    const blockUuids = getBlocksUuids(contentFormatted);
    const { jsonContent, textContent } = getJsonContentFromHtml({
      options,
      schema,
      contentFormatted
    });
    return {
      blockUuids,
      jsonContent,
      textContent
    };
  }
  return createJSONContentFromHTML({
    HTMLContent: "",
    schema,
    options,
    config
  });
};
const getJsonContentFromHtml = ({
  options,
  schema,
  contentFormatted
}) => {
  const parser = DOMParser.fromSchema(schema);
  const proseMirrorNode = (options == null ? void 0 : options.slice) ? parser.parseSlice(
    elementFromString(contentFormatted),
    options.parseOptions
  ) : parser.parse(elementFromString(contentFormatted), options == null ? void 0 : options.parseOptions);
  const doc = schema.nodes.doc.create({}, proseMirrorNode.content);
  let jsonContent = proseMirrorNodeToJson({
    proseMirrorNode,
    schema
  });
  jsonContent = formatContentCorruptContent(
    applyContextToAllChildren(jsonContent)
  );
  return { jsonContent, textContent: doc.textContent };
};
const getTextFromContent = ({
  content,
  extensionOptions
}) => {
  try {
    const extensions = getEditorExtensions({ extensionOptions });
    const instance = new Editor({
      extensions,
      content: { type: "doc", content }
    });
    const text = instance == null ? void 0 : instance.getText();
    instance.destroy();
    return text;
  } catch (e) {
    return "";
  }
};
const getSeshatContentFromHtml = ({
  content,
  schema
}) => {
  const parser = CustomDOMParser.fromSchema(schema);
  const node = parser.parse(elementFromString(content)).content;
  return node.toJSON();
};
const initHeadlessEditor = ({
  content,
  extensionOptions
} = {}) => {
  return new Editor({
    extensions: getEditorExtensions({ extensionOptions }),
    content: content ? {
      type: "doc",
      content
    } : void 0
  });
};
const DOC_TYPE = "doc";
export { ALL_BLOCK_COMMANDS, ANALYTICS_META, ANNOTATION_META, ANNOTATION_MODE_ATTRIBUTE, AddNoteConfig, AnalyticsExtension, AnnotationModeExtension, MAX_COLUMNS as BLOCK_LINE_MAX_COLUMNS, BlockIDExtension, BlockLineBlock, BlockSelection, BlockSelectionExtension, BracketsExtension, BulletBlockConfig, CaptureBlock, CardBlock, CardLinkBlock, ClipBlockConfig, ClipBookBlock, ClipBookmarkBlock, ClipContentBlock, ClipboardDOMSerializer, ClipboardExtension, ClipboardTextSerializer, CodeBlock, CodeBlockConfig, ConnectionConfig, ContentEditableExtension, ContextIDExtension, CustomDOMParser, DOC_TYPE, DROP_HANDLE_EXTENSION, DividerBlockConfig, DropCursor, DropHandleExtension, EDITOR_CONTENT_DOM_ID, EmbedBlockConfig, ExternalImageNode, FileBlock, FileBlockConfig, FontColorExtension, GroupColors, GroupHighlightColors, HARD_BREAK_DUE_TO_BLOCK_TYPE, HARD_BREAK_DUE_TO_PARENT_TYPE, HeadingBlockConfig, HighlightMark, HighlightsBlock, HighlightsConfig, HistoryExtension, HorizontalRuleBlock, IFrameBlock, IgnoreContentEditableFalse, LayoutNode, LinkMark, MentionNode, MentionPlaceholderExtensionKey, MentionPlaceholderNodes, MoveBlockExtension, NumberedBlockConfig, PREVENT_EDITOR_INPUT_PLUGIN, PREVENT_EDITOR_INPUT_PLUGIN_KEY, ParagraphBlockConfig, PreviewFile, QuoteBlockConfig, ReadLaterDecorationExtension, SESHAT_CONTENT_DEPTH, SESHAT_ROOT_DEPTH, SESHAT_SESSION_STORAGE_PREFIX, SelectionBoxSelector, SeshatBlockContentNode, SeshatBlockGroup, SeshatBlockNode, SeshatBlockNodeConfig, SeshatContentNode, SeshatNodeViewContentNode, SeshatWrappingBlockNode, SeshatWrappingBlockNodeConfig, ShineMark, StrikeMark, TabIndexExtension, TableOfContentBlockConfig, TableOfContentsBlock, TaskBlockConfig, TaskEditableBlock, TextAlignExtension, TextNode, ToggleBlock, TrailingLineExtension, YELLOW, allEditorExtensionConfigs, appendContentInACardContent, applyBlockIdToExtension, applyContextIdToExtension, clipBlocks, clipObserverPlugin, clipObserverPluginKey, codeBlockLanguages, countLeaves, createCardLink, createHighlightsBlockFromClipBookmark, createHighlightsFromClipContent, createHighlightsFromKindleHighlights, createHighlightsFromPaywallClipContent, createJSONContentFromHTML, createNewHighlightsFromKindleHighlights, createSeshatBlock, createShellCardContent, disabledIndent, editorExtensionConfig, editorMarkConfig, editorNodeConfig, excludedFromBlockSelection, findAncestor, findBlockAtMousePosition, findChildByBlockId, findFirstHighlight, findHighlight, findHighlightBlockQuote, findHighlightBlockQuoteParagraph, findNextCaretPosition, formatContentCorruptContent, generateBlockId, generateCapture, generateClipBookmark, generateClipContent, generateEmptyBlock, generateHighlights, generateNote, generateParagraph, generateTask, generateTaskEditable, getAllEditors, getAsinUrl, getBlockquoteContentFromHighlight, getBlocksInRange, getBlocksOfType, getCardContentFromSeshatBlockCard, getCardTitleContentFromSeshatBlockCard, getCardUuid, getClipByHrefAndEmpty, getClipContent, getClipContentBlock, getClipPositions, getConnectedHighlightsBlockByClipId, getCurrentBlock, getDefaultHighlightColor, getDirectPreviousSibling, getEditorApi, getEditorExtensions, getExtensionOptions, getForwardSeshatBlockContent, getFromNToFromRange, getHeadingForTableOfContents, getHighlightIdFromNode, getHighlightMarkFromNode, getHighlightsFromAttrs, getHighlightsFromClipBook, getHighlightsFromClipContent, getHighlightsFromClipContentById, getJsonContentFromHtml, getLinkAttributes, getNearestClip, getNearestHighlightBlock, getNearestSeshatBlockOfType, getNearestSeshatBlockParentSelection, getNextBlock, getNodeDepth, getNodeFromPosition, getNodeTypeByBlockType, getNoteFromHighlight, getPluginStateValue, getPreviousBlock, getPreviousSibling, getSeshatBlockByBlockId, getSeshatContent, getSeshatContentFromHtml, getSeshatEditorSchema, getTextFromContent, getTouchedClipIds, hasChildren, hasNodeSchemaAttribute, hideSelectionDecoration, highlightMatchingClipContent, highlighters, highlightsBlocksObserverPlugin, highlightsBlocksObserverPluginKey, initHeadlessEditor, inputRegex, insertClipBookmark, insertClipBookmarkTransaction, isAnnotation, isAtom, isBlock, isBlockCollapsible, isBlockSelection, isCardTitleNode, isCaretInEmptyClip, isCaretWithinHighlightBlockquote, isCaretWithinHighlightNote, isClipWithAttributesSync, isContentEditableFalse, isContentEditableFalseBlockType, isEmptyClip, isEmptyHighlightsBlock, isHighlightMark, isHighlightMarkAllowed, isLargeDocument, isLauncherEditor, isParentRootBlock, isRangeTextSelected, isRootBlock, isRootBlockJSON, isSeshatBlockClip, isSeshatBlockEmpty, isSupportedCodeBlockLanguage, matchHighlightsWithClipContent, matchHighlightsWithClipContentTransaction, maybeAddMissingMarksInClipContent, minMax, pasteRegex, pasteRegexForRoam, plainTextLanguage, pluginKey, preventEditorInputPlugin, replaceClipBookmarkByClipContent, resetAttrsInSlice, seshatBlockAttributes, seshatBlockChildrenOnEnter, seshatBlockCommands, seshatBlockMarkdown, seshatBlockOnEnter, seshatBlockResetOnEmptyEnter, seshatBlockResetOnStartBackspace, seshatBlockShortcut, seshatBlockSoftBreakOnEnter, seshatBlockSoftTab, seshatDOMSerializer, setPluginStateValue, shortcutConfig, syncClipBookmark, syncClipContent, syncHighlightsBlocksAfterClipModification, syncHighlightsBlocksAfterClipModificationTransaction, syncPaywallClipContent };
